// Generated by scripts/buildDictionary.ts — DO NOT EDIT MANUALLY.
// المصدر: dream-dictionary.txt (معجم تفسير الأحلام والرؤى - ابن سيرين وأئمة التعبير).

export interface DictionaryEntry {
  slug: string;
  arabicSlug: string;
  name: string;
  letter: string;
  category: string;
  categorySlug: string;
  canonicalSlug: string | null;
  text: string;
  wordCount: number;
}

export const DICTIONARY_DB: DictionaryEntry[] = [
  {
    "slug": "abnws",
    "arabicSlug": "تفسير-حلم-أبنوس",
    "name": "أبنوس",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام امرأة هندية موسرة، أو رجل صلب موسر",
    "wordCount": 9
  },
  {
    "slug": "abrahym-alyh-alslam",
    "arabicSlug": "تفسير-حلم-إبراهيم-عليه-السلام",
    "name": "إبراهيم عليه السلام",
    "letter": "أ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رآه رزق الحج إن شاء الله، كما تدل رؤيته على الوالد المشفق، وربما دلت على الوقوع في الشدائد والسلامة منها",
    "wordCount": 21
  },
  {
    "slug": "abrh",
    "arabicSlug": "تفسير-حلم-إبرة",
    "name": "إبرة",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة للأعزب على الزوجة، وللفقير على ستر الحال ومن رأى خيطا في إبرة اجتمع شمله، واجتمع له ما كان متفرقا من أمره، ومن رأى إن إبرته انكسرت فان شأنه يتفرق، ويفسد أمره",
    "wordCount": 32
  },
  {
    "slug": "abryq",
    "arabicSlug": "تفسير-حلم-إبريق",
    "name": "إبريق",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على التوبة للعاصي، والولد الذكر للحامل، ويدل الإبريق على اللعب والضحك",
    "wordCount": 13
  },
  {
    "slug": "ablys",
    "arabicSlug": "تفسير-حلم-إبليس",
    "name": "إبليس",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته تدل على العالم المبتدع، واكتساب الذنوب والآثام، كما تدل رؤيته على المكر والخديعة والفرقة، ومن رأى الشيطان يتخبطه فانه يأكل الربا",
    "wordCount": 22
  },
  {
    "slug": "ajas",
    "arabicSlug": "تفسير-حلم-أجاص",
    "name": "أجاص",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في وقته رزق، أو غائب جاء، وفي غير وقته مرض أو هم، فأن رأى مريض أنه يأكل أجاصا فانه يبرأ",
    "wordCount": 20
  },
  {
    "slug": "ahram-2",
    "arabicSlug": "تفسير-حلم-إحرام",
    "name": "إحرام",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا احرم الإنسان دل ذلك على امتناعه عن الجماع ودواعيه، فهو زواج الأعزب وطلاق المتزوج، أو بعده عن المعاصي والمخاصمة",
    "wordCount": 20
  },
  {
    "slug": "ahtqan-alansan",
    "arabicSlug": "تفسير-حلم-احتقان-الإنسان",
    "name": "احتقان الإنسان",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دل على رواج المخزون من بضاعة فاسدة، أو دل على الاطلاع على المساوي، أو نهبت داره",
    "wordCount": 16
  },
  {
    "slug": "akh-alansan",
    "arabicSlug": "تفسير-حلم-أخ-الإنسان",
    "name": "أخ الإنسان",
    "letter": "أ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دل على الشراكة في المال والمساعدين",
    "wordCount": 6
  },
  {
    "slug": "ada-alshhadh",
    "arabicSlug": "تفسير-حلم-أداء-الشهادة",
    "name": "أداء الشهادة",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الخروج عن العهد والوفاء، وقضاء الدين، فان كتم شهادة في المنام دل على الدين والطمع في الوديعة والحقد وربما دل على المرض",
    "wordCount": 24
  },
  {
    "slug": "adhan",
    "arabicSlug": "تفسير-حلم-أذان",
    "name": "أذان",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الحج وربما دل على النميمة والاتهام بالسرقة، وقد يدل الأذان على علو الدرجة والمنصب",
    "wordCount": 16
  },
  {
    "slug": "adhn",
    "arabicSlug": "تفسير-حلم-إذن",
    "name": "إذن",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على السمع، فمن رأى أن أذنه كبرت أو تحسنت دل ذلك على هدايته وقبوله أمر ربه",
    "wordCount": 17
  },
  {
    "slug": "arjwan",
    "arabicSlug": "تفسير-حلم-أرجوان",
    "name": "أرجوان",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة عفيفة فمن التقطه قبل امرأة غنية حسنة لها خطاب كثيرون وأقرباء عديدين",
    "wordCount": 13
  },
  {
    "slug": "arjwhh",
    "arabicSlug": "تفسير-حلم-أرجوحة",
    "name": "أرجوحة",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يتمرجح فيها فدل على فساد اعتقاده بدينه",
    "wordCount": 10
  },
  {
    "slug": "arz",
    "arabicSlug": "تفسير-حلم-أرز",
    "name": "أرز",
    "letter": "أ",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دل على مال فيه نصب وشغف وهو يدل على الربح",
    "wordCount": 10
  },
  {
    "slug": "ard",
    "arabicSlug": "تفسير-حلم-أرض",
    "name": "أرض",
    "letter": "أ",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "كل أرض على حسبها وجوهرها فرؤية ارض المحشر دالة على حفظ الأسرار، والأمن من الخوف، ورؤية الأرض الفلاحية تدل على الخصب، ومن رأى أنه ملك أرض تزوج أو رزق ولدا، ومن رأى إن الأرض خسفت بمن فيها دل ذلك على التيه والعجب والغفلة، ومن رأى انه في ارض واسعة فانه يسافر، والأرض تدل على امرأة نمامة لا تكتم السر وتدل على الجدال أو العلم",
    "wordCount": 64
  },
  {
    "slug": "arnb",
    "arabicSlug": "تفسير-حلم-أرنب",
    "name": "أرنب",
    "letter": "أ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "يدل على رجل جبان، أو امرأة إن ذبحها فهي زوجة غير باقية",
    "wordCount": 12
  },
  {
    "slug": "azar",
    "arabicSlug": "تفسير-حلم-إزار",
    "name": "إزار",
    "letter": "أ",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "دل على امرأة حرة، فأن رأت امرأة إن لها إزار احمر مصقول فإنها تتهم بريبة",
    "wordCount": 15
  },
  {
    "slug": "astraq-alsma",
    "arabicSlug": "تفسير-حلم-استراق-السمع",
    "name": "استراق السمع",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام كذب ونميمة ومن رأى كأنه يسمع أقاويل ويتبع أحسنها فانه ينال بشارة",
    "wordCount": 14
  },
  {
    "slug": "alasd",
    "arabicSlug": "تفسير-حلم-الأسد",
    "name": "الأسد",
    "letter": "أ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "lion",
    "text": "سلطان يدل على سلطان شديد ظالم، وربما دل على الموت، واللبوة امرأة شريرة",
    "wordCount": 13
  },
  {
    "slug": "asraa-alansan",
    "arabicSlug": "تفسير-حلم-إسراع-الإنسان",
    "name": "إسراع الإنسان",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المسارعة في إعمال الخير، إلا أن يكون مسرعا مريضا فانه يدل على موته",
    "wordCount": 15
  },
  {
    "slug": "astwanh",
    "arabicSlug": "تفسير-حلم-أسطوانة",
    "name": "أسطوانة",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من خشب أو طين فهي في المنام قيم دار أو خادم أهل الدار",
    "wordCount": 13
  },
  {
    "slug": "asm",
    "arabicSlug": "تفسير-حلم-اسم",
    "name": "اسم",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا تحول اسم الإنسان في المنام إلى غير اسمه فيعبر عنه بالفأل الحسن",
    "wordCount": 13
  },
  {
    "slug": "asba",
    "arabicSlug": "تفسير-حلم-أصبع",
    "name": "أصبع",
    "letter": "أ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هي المعينة للإنسان على دنياه في مهنته، والإصبع دلالة على الأولاد أو الأقرباء والمال ورزق الإنسان",
    "wordCount": 16
  },
  {
    "slug": "aladhyh",
    "arabicSlug": "تفسير-حلم-ألأضحية",
    "name": "ألأضحية",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دلالة على الوفاء بالنذر والخلاص من الشدائد، وان كان فقيرا اغتنى، وان كان خائفا أمن",
    "wordCount": 15
  },
  {
    "slug": "alaaarh",
    "arabicSlug": "تفسير-حلم-الإعارة",
    "name": "الإعارة",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من أنه استعار شيء أو أعاره فان كان محبوبا فانه ينال خيرا، وان مكروها نال كراهة لا تدوم",
    "wordCount": 18
  },
  {
    "slug": "aatkaf",
    "arabicSlug": "تفسير-حلم-اعتكاف",
    "name": "اعتكاف",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يعبر بحسب ما اعتكف فيه، فان اعتكف في مسجد اعتكف عل أعمال صالحة",
    "wordCount": 13
  },
  {
    "slug": "alaflas",
    "arabicSlug": "تفسير-حلم-الإفلاس",
    "name": "الإفلاس",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على نقص حال المفلس في دينه",
    "wordCount": 7
  },
  {
    "slug": "alakl",
    "arabicSlug": "تفسير-حلم-الأكل",
    "name": "الأكل",
    "letter": "أ",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "إذا أكل الإنسان في إناء مكروه فيدل على بلاء يصيبه، والأكل بين الناس شهوة، وان أكل لحم الغير فانه يغتابه أو يغتاب شخص أخر",
    "wordCount": 24
  },
  {
    "slug": "alam",
    "arabicSlug": "تفسير-حلم-الأم",
    "name": "الأم",
    "letter": "أ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "أم الإنسان إذا رآها الإنسان عبر حالها في المنام بحاله، وربما دلت على الشفقة والفرج لمن كان في شدة",
    "wordCount": 19
  },
  {
    "slug": "amath-aladha",
    "arabicSlug": "تفسير-حلم-إماطة-الأذى",
    "name": "إماطة الأذى",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الغيرة في الدين واليقظة، أو على الأزواج والأولاد والتحفظ في الكلام، وتدل على غفران الذنوب أو كثرة الصدقة",
    "wordCount": 20
  },
  {
    "slug": "amam-alslah",
    "arabicSlug": "تفسير-حلم-إمام-الصلاة",
    "name": "إمام الصلاة",
    "letter": "أ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": "prayer",
    "text": "دلت رؤياه على علو القدر، وان صلى بالناس إلى غير القبلة خان أصحابه وابتدع بدعة",
    "wordCount": 15
  },
  {
    "slug": "anshrah",
    "arabicSlug": "تفسير-حلم-انشراح",
    "name": "انشراح",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على التوبة للعاصي، أو فرج من الله",
    "wordCount": 8
  },
  {
    "slug": "anf",
    "arabicSlug": "تفسير-حلم-أنف",
    "name": "أنف",
    "letter": "أ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "يدل على ما يتجمل به الإنسان من مل أو ولد",
    "wordCount": 10
  },
  {
    "slug": "anqbad",
    "arabicSlug": "تفسير-حلم-انقباض",
    "name": "انقباض",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الإنسان في المنام يدل على القبض في الرزق وربما دل على الذنوب في اليقظة",
    "wordCount": 14
  },
  {
    "slug": "anqlab",
    "arabicSlug": "تفسير-حلم-انقلاب",
    "name": "انقلاب",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "انقلاب الإنسان على وجهه في المنام يدل على الخسارة، وان كانت امرأة أعرضت عن زوجها",
    "wordCount": 15
  },
  {
    "slug": "awz",
    "arabicSlug": "تفسير-حلم-أوز",
    "name": "أوز",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على نساء ذوات جمال ومال، ومن رأى انه يرعى الاوز فانه يصاحب قوما ذو رفعة",
    "wordCount": 16
  },
  {
    "slug": "ahram-3",
    "arabicSlug": "تفسير-حلم-اهرام",
    "name": "اهرام",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الأخبار الغريبة أو معاشرة الغرب، وربما تدل على العمر الطويل",
    "wordCount": 12
  },
  {
    "slug": "alayl",
    "arabicSlug": "تفسير-حلم-الأيل",
    "name": "الأيل",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على التاج والهيبة وقمع الأعداء",
    "wordCount": 7
  },
  {
    "slug": "ayat-alqran",
    "arabicSlug": "تفسير-حلم-آيات-القران",
    "name": "آيات القران",
    "letter": "أ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا كانت آيات رحمة فهو رحمة الله، وأن كانت آيات عقاب فهو عذاب الله تعالى",
    "wordCount": 15
  },
  {
    "slug": "bab",
    "arabicSlug": "تفسير-حلم-باب",
    "name": "باب",
    "letter": "ب",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "الأبواب المفتوحة أبواب رزق وأبواب البيوت معناها يقع على النساء",
    "wordCount": 10
  },
  {
    "slug": "badhnjan",
    "arabicSlug": "تفسير-حلم-باذنجان",
    "name": "باذنجان",
    "letter": "ب",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "يدل على رزق بأدنى هم، واكله دليل على إتيان الرخص والتملق في الكلام",
    "wordCount": 13
  },
  {
    "slug": "balwah",
    "arabicSlug": "تفسير-حلم-بالوعة",
    "name": "بالوعة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام خادم، وقيل امرأة سفيهة، والبالوعة المجهولة امرأة زانية، ومن سدت بالوعته ضاقت عليه وتعسر",
    "wordCount": 17
  },
  {
    "slug": "bbgha",
    "arabicSlug": "تفسير-حلم-ببغاء",
    "name": "ببغاء",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رجل كاذب ظالم، وقيل رجل فيلسوف . والببغاء دالة على المرأة الجميلة",
    "wordCount": 12
  },
  {
    "slug": "byr",
    "arabicSlug": "تفسير-حلم-بئر",
    "name": "بئر",
    "letter": "ب",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "البئر مال أو علم أو زاد، ومن رأى انه حفر بئرا وفيها ماء تزوج إنسان غني ومكر به ( بها ) ومن رأى انه شرب من مائها فانه يصيب مالا من مكر إذا كان هو حافر البئر",
    "wordCount": 37
  },
  {
    "slug": "bhr",
    "arabicSlug": "تفسير-حلم-بحر",
    "name": "بحر",
    "letter": "ب",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": "sea",
    "text": "يدل على ملك قوي، ومن رأى البحر من بعيد فأنه يرى أهوالا وفتنة، ومن رأى أنه وقف على البحر فانه يصيب من السلطان شيئا وربما دل للمرأة على الزواج",
    "wordCount": 29
  },
  {
    "slug": "bhyrh",
    "arabicSlug": "تفسير-حلم-بحيرة",
    "name": "بحيرة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على المرأة الغنية، وللمسافر تدل على تعذر السفر",
    "wordCount": 9
  },
  {
    "slug": "bkhar",
    "arabicSlug": "تفسير-حلم-بخار",
    "name": "بخار",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على بخار العين وظلمتها، أو ظهور الأسرار، وان كان عالما ابتدع بدعة ظاهرة",
    "wordCount": 14
  },
  {
    "slug": "bkhwr",
    "arabicSlug": "تفسير-حلم-بخور",
    "name": "بخور",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "التكلم بكلام يثني به على نفسه",
    "wordCount": 6
  },
  {
    "slug": "bkhl",
    "arabicSlug": "تفسير-حلم-بخل",
    "name": "بخل",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الداء الذي ليس له دواء، ويدل على النفاق أو الفقر",
    "wordCount": 12
  },
  {
    "slug": "bdn-alansan",
    "arabicSlug": "تفسير-حلم-بدن-الإنسان",
    "name": "بدن الإنسان",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "سمنه في المنام وقوته قوة الدين والإيمان، وهزله يدل على الفقر ونقص المال والعلم",
    "wordCount": 14
  },
  {
    "slug": "bdhr",
    "arabicSlug": "تفسير-حلم-بذر",
    "name": "بذر",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "البذر إذا كان في غير موضعه دال على الإسراف، وبذر البذور في الأرض دال على الولد",
    "wordCount": 16
  },
  {
    "slug": "brah",
    "arabicSlug": "تفسير-حلم-براءة",
    "name": "براءة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الأمان مما يحذر منه",
    "wordCount": 6
  },
  {
    "slug": "brd",
    "arabicSlug": "تفسير-حلم-برد",
    "name": "برد",
    "letter": "ب",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دال على الفقر، فمن وجد البرد في الظل فقعد في الشمس ذهب فقره",
    "wordCount": 13
  },
  {
    "slug": "brs",
    "arabicSlug": "تفسير-حلم-برص",
    "name": "برص",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه أبرص فانه يكسب المال",
    "wordCount": 7
  },
  {
    "slug": "brghwth",
    "arabicSlug": "تفسير-حلم-برغوث",
    "name": "برغوث",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو رجل عجوز ضعيف، ومن رأى إن البراغيث تلدغه أصاب غما وتهديدا",
    "wordCount": 12
  },
  {
    "slug": "brq",
    "arabicSlug": "تفسير-حلم-برق",
    "name": "برق",
    "letter": "ب",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "رويته لوحده دالة على الهدى بعد الضلالة، أو تبشير بقدوم غائب، أو تجديد الرزق",
    "wordCount": 14
  },
  {
    "slug": "brqwq",
    "arabicSlug": "تفسير-حلم-برقوق",
    "name": "برقوق",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رآه في المنام في أوانه دل على الخير وفي غير أوانه دل على الهم والتعب",
    "wordCount": 16
  },
  {
    "slug": "brhan",
    "arabicSlug": "تفسير-حلم-برهان",
    "name": "برهان",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا برهن على شيء فانه ينال حجة قوية، ومن رأى كأنه يأتي ببرهان فانه في خصومة مع إنسان والحجة عليه فيها",
    "wordCount": 21
  },
  {
    "slug": "bryd",
    "arabicSlug": "تفسير-حلم-بريد",
    "name": "بريد",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رويته على الحركة والأسفار",
    "wordCount": 5
  },
  {
    "slug": "bzr",
    "arabicSlug": "تفسير-حلم-بزر",
    "name": "بزر",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "النسل الصالح",
    "wordCount": 2
  },
  {
    "slug": "bsat",
    "arabicSlug": "تفسير-حلم-بساط",
    "name": "بساط",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "بسطة وعز ورفعة خصوصا إن ملكه وجلس عليه",
    "wordCount": 8
  },
  {
    "slug": "bstan",
    "arabicSlug": "تفسير-حلم-بستان",
    "name": "بستان",
    "letter": "ب",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "دال على الاستغفار، ويدل على المرأة، وربما دل على مكان أو حيوان يستغل منه",
    "wordCount": 14
  },
  {
    "slug": "bsmlh",
    "arabicSlug": "تفسير-حلم-بسملة",
    "name": "بسملة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على العلم والهداية",
    "wordCount": 4
  },
  {
    "slug": "bshashh",
    "arabicSlug": "تفسير-حلم-بشاشة",
    "name": "بشاشة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الإقبال على طاعة الله، والبشاشة لغيرهم من المضحكين أو المفسدين دليل على الغفلة والحرام",
    "wordCount": 16
  },
  {
    "slug": "bsaq",
    "arabicSlug": "تفسير-حلم-بصاق",
    "name": "بصاق",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل في المنام على قوة الرجل فمن رأى ريقه جف عجز عما يريد، ومن رأى أنه خرج من فمه رغوة وزبد فيدل على كلام باطل يقوله",
    "wordCount": 26
  },
  {
    "slug": "bsl",
    "arabicSlug": "تفسير-حلم-بصل",
    "name": "بصل",
    "letter": "ب",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "من رآه ولم يأكل منه فهو خير، وان أكل منه فشر",
    "wordCount": 11
  },
  {
    "slug": "btn",
    "arabicSlug": "تفسير-حلم-بطن",
    "name": "بطن",
    "letter": "ب",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دال على ما يحوي أهله وماله وسره، ويدل على السجن والقبر",
    "wordCount": 11
  },
  {
    "slug": "btykh",
    "arabicSlug": "تفسير-حلم-بطيخ",
    "name": "بطيخ",
    "letter": "ب",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "رجل صاحب هموم ومريض، ومن رأى أنه يأكل بطيخ فانه يخرج من الحبس",
    "wordCount": 13
  },
  {
    "slug": "bawd",
    "arabicSlug": "تفسير-حلم-بعوض",
    "name": "بعوض",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "عدو يسفك الدماء ويشوه البدن",
    "wordCount": 5
  },
  {
    "slug": "bgha",
    "arabicSlug": "تفسير-حلم-بغاء",
    "name": "بغاء",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الداء الذي ينزل بالفم حتى يحتاج إلى ما يشفيه",
    "wordCount": 11
  },
  {
    "slug": "bghd",
    "arabicSlug": "تفسير-حلم-بغض",
    "name": "بغض",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه يبغضه إنسان أو يبغض أنسانا فهو دليل رديء لجميع الناس",
    "wordCount": 13
  },
  {
    "slug": "bghl",
    "arabicSlug": "تفسير-حلم-بغل",
    "name": "بغل",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "سفر، وركوب البغل يدل على طول العمر والتزوج بامرأة عاقر",
    "wordCount": 10
  },
  {
    "slug": "bq",
    "arabicSlug": "تفسير-حلم-بق",
    "name": "بق",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على أعداء ضعاف، والبق يدل على الهم والحزن",
    "wordCount": 9
  },
  {
    "slug": "bqr",
    "arabicSlug": "تفسير-حلم-بقر",
    "name": "بقر",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على السنين، فالبقرة السوداء والصفراء سنة فيها سرور، والبقرة الهزيلة سنوات قحط وجدب، ومن رأى أنه يأكل لحم البقر فأنه يكسب مال وسلطان",
    "wordCount": 24
  },
  {
    "slug": "bka",
    "arabicSlug": "تفسير-حلم-بكاء",
    "name": "بكاء",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "crying",
    "text": "إذا كان بصراخ أو لطم أو لباس أسود فيدل على الحزن، وان كان البكاء خشية من الله فانه يدل على السرور وزوال الهم",
    "wordCount": 23
  },
  {
    "slug": "bkr",
    "arabicSlug": "تفسير-حلم-بكر",
    "name": "بكر",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى بكرا عذراء كان ذلك عسرا لأرباب المناصب، وتدل على الأرض القابلة النفع والمسكن الجديد",
    "wordCount": 16
  },
  {
    "slug": "bkrh",
    "arabicSlug": "تفسير-حلم-بكرة",
    "name": "بكرة",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل نافع مؤمن يسعى في أمور الناس",
    "wordCount": 7
  },
  {
    "slug": "bla",
    "arabicSlug": "تفسير-حلم-بلاء",
    "name": "بلاء",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الأفراح والسرور والفرج بعد الشدة",
    "wordCount": 7
  },
  {
    "slug": "blat",
    "arabicSlug": "تفسير-حلم-بلاط",
    "name": "بلاط",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على تغير الحال، في المناصب، والزوجات والمعيشة",
    "wordCount": 8
  },
  {
    "slug": "blbl",
    "arabicSlug": "تفسير-حلم-بلبل",
    "name": "بلبل",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على رجل موسر أو امرأة موسرة، وقيل البلبل يدل على ولد قاري لكتاب الله",
    "wordCount": 15
  },
  {
    "slug": "blh",
    "arabicSlug": "تفسير-حلم-بلح",
    "name": "بلح",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رزق أو رسول بخير",
    "wordCount": 4
  },
  {
    "slug": "blghm",
    "arabicSlug": "تفسير-حلم-بلغم",
    "name": "بلغم",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ألقى بلغما نال الفرج والشفاء",
    "wordCount": 8
  },
  {
    "slug": "bna",
    "arabicSlug": "تفسير-حلم-بناء",
    "name": "بناء",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "البناء المستحدث على الأرض إفادة دنيا خاصة أو عامة بقدر ما رأى من ذلك",
    "wordCount": 14
  },
  {
    "slug": "bndq",
    "arabicSlug": "تفسير-حلم-بندق",
    "name": "بندق",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل غريب غني، سخي ثقيل الروح، ومن أكله نال مالا بكد وتعب",
    "wordCount": 12
  },
  {
    "slug": "bnfsj",
    "arabicSlug": "تفسير-حلم-بنفسج",
    "name": "بنفسج",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "جارية بارعة، امرأة جميلة، وهو دليل على قلة الثبات أو قصر العمر",
    "wordCount": 12
  },
  {
    "slug": "bhaq",
    "arabicSlug": "تفسير-حلم-بهاق",
    "name": "بهاق",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إصابته بالبهاق فأن ذلك أسرار رديئة",
    "wordCount": 8
  },
  {
    "slug": "bwl",
    "arabicSlug": "تفسير-حلم-بول",
    "name": "بول",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إدرار البول في المنام دليل إدرار الرزق، وزوال ما في البطن، وإمساك البول أو تعسره ربما دل على استعجاله في الأمور وعدم الصواب",
    "wordCount": 23
  },
  {
    "slug": "bwm",
    "arabicSlug": "تفسير-حلم-بوم",
    "name": "بوم",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على البطالة والخوف، أو إنسان خائن لا خير فيه",
    "wordCount": 10
  },
  {
    "slug": "byad-allwn",
    "arabicSlug": "تفسير-حلم-بياض-اللون",
    "name": "بياض اللون",
    "letter": "ب",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى وجهه أشد بياضا فانه مرض، ومن رأى أن لون خده فأنه ينال عزا وكرما",
    "wordCount": 16
  },
  {
    "slug": "byt",
    "arabicSlug": "تفسير-حلم-بيت",
    "name": "بيت",
    "letter": "ب",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "رويته زوجة صالحة، ومن رأى خروجه من بيت صغير فهو خروج من هم",
    "wordCount": 13
  },
  {
    "slug": "byd",
    "arabicSlug": "تفسير-حلم-بيض",
    "name": "بيض",
    "letter": "ب",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "في موضع أو إناء نساء أو جوار، ومن رأى أن دجاجته باضت فانه يولد له ولد",
    "wordCount": 16
  },
  {
    "slug": "tabwt",
    "arabicSlug": "تفسير-حلم-تابوت",
    "name": "تابوت",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "ملك عظيم، فأن رأى انه في تابوت نال سلطانا، ودليل على الفرج والنجاة، ومن رأى انه أعطي تابوتا رزق علما ووقار كما تدل رؤيته على الهم والنكد",
    "wordCount": 27
  },
  {
    "slug": "taj",
    "arabicSlug": "تفسير-حلم-تاج",
    "name": "تاج",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل التاج في المنام على العلم والقران، وإذا رأت المرأة التاج على رأساها فإنها تتزوج برجل ذو منصب رفيع، وان كانت حامل ولدت ولدا",
    "wordCount": 24
  },
  {
    "slug": "tajr",
    "arabicSlug": "تفسير-حلم-تاجر",
    "name": "تاجر",
    "letter": "ت",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رأى انه تاجر دل على الربح والفائدة، كما تدل على التفريط في الدين",
    "wordCount": 14
  },
  {
    "slug": "tbsm",
    "arabicSlug": "تفسير-حلم-تبسم",
    "name": "تبسم",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على السرور",
    "wordCount": 3
  },
  {
    "slug": "altthawb",
    "arabicSlug": "تفسير-حلم-التثاؤب",
    "name": "التثاؤب",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "عمل يرضى به الشيطان، وربما يدل على مرضا لا يبرأ صاحبه",
    "wordCount": 11
  },
  {
    "slug": "tjrd-mn-almlabs",
    "arabicSlug": "تفسير-حلم-تجرد-من-الملابس",
    "name": "تجرد من الملابس",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "clothes",
    "text": "إذا رأى الإنسان تجرد ملابسه في مكان عام فدال على هتك سره، وإذ تجرد من الملابس ولم تكن عورته بارزة فأنه يسلم من أمر مكروه",
    "wordCount": 25
  },
  {
    "slug": "tkht",
    "arabicSlug": "تفسير-حلم-تخت",
    "name": "تخت",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الزوجة والدابة والمنصب",
    "wordCount": 6
  },
  {
    "slug": "tkhmh",
    "arabicSlug": "تفسير-حلم-تخمة",
    "name": "تخمة",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه في تخمة في المنام دال على أكل الربا فان انهضمت فانه يحرص على السعي في أموره",
    "wordCount": 19
  },
  {
    "slug": "tkhnth",
    "arabicSlug": "تفسير-حلم-تخنث",
    "name": "تخنث",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في منامه أنه تحول مخنثا فانه يصيبه هول وخوف وحزن",
    "wordCount": 12
  },
  {
    "slug": "tdly",
    "arabicSlug": "تفسير-حلم-تدلي",
    "name": "تدلي",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه تدلى من الأعلى إلى الأسفل فانه يتورع، ومن رأى انه يسقط دليل على عدم الحصول على مبتغياه",
    "wordCount": 20
  },
  {
    "slug": "trab",
    "arabicSlug": "تفسير-حلم-تراب",
    "name": "تراب",
    "letter": "ت",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "يدل على الناس، وربما دل على الأنعام والدواب، ومن رأى انه يسف التراب فهو مال يصيبه",
    "wordCount": 16
  },
  {
    "slug": "trms",
    "arabicSlug": "تفسير-حلم-ترمس",
    "name": "ترمس",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية أخضره في المنام شح ورزق بتعب، أو علم بغير عمل، والترمس اليابس هم ونكد، ومسلوق الترمس رزق عاجل",
    "wordCount": 19
  },
  {
    "slug": "tshhd",
    "arabicSlug": "تفسير-حلم-تشهد",
    "name": "تشهد",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الفرج وقضاء حاجة الإنسان",
    "wordCount": 6
  },
  {
    "slug": "tazyh",
    "arabicSlug": "تفسير-حلم-تعزية",
    "name": "تعزية",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من كان في حسن حال دليل على مضرة تصيبه، ومن كان في شدة فهو دليل منفعة",
    "wordCount": 16
  },
  {
    "slug": "talm",
    "arabicSlug": "تفسير-حلم-تعلم",
    "name": "تعلم",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يتعلم فدليل على الغنى بعد الفقر، والهدى بعد الضلالة",
    "wordCount": 12
  },
  {
    "slug": "tfah",
    "arabicSlug": "تفسير-حلم-تفاح",
    "name": "تفاح",
    "letter": "ت",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "يدل في المنام على الأولاد وحسان الوجوه، ومن رأى انه يأكل التفاح فأنه ينال بقدر رؤيته",
    "wordCount": 16
  },
  {
    "slug": "tflys",
    "arabicSlug": "تفسير-حلم-تفليس",
    "name": "تفليس",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على نقص حال المفلس في دينه أو دنياه، وان كان مريضا فدليل على نفاذ رزقه أو موته",
    "wordCount": 18
  },
  {
    "slug": "tkbr",
    "arabicSlug": "تفسير-حلم-تكبر",
    "name": "تكبر",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه تكبر يدل على انتهاء عمره، والتكبر في المنام يدل على الرزق والمنصب لكن عاقبته شر",
    "wordCount": 18
  },
  {
    "slug": "tkbyr",
    "arabicSlug": "تفسير-حلم-تكبير",
    "name": "تكبير",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الأعياد والفرح، كما يدل على الأعمال الصالحة",
    "wordCount": 9
  },
  {
    "slug": "tlf",
    "arabicSlug": "تفسير-حلم-تلف",
    "name": "تلف",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من أتلف شيء حسنا أفسد ما عليه من الخير",
    "wordCount": 9
  },
  {
    "slug": "tmr",
    "arabicSlug": "تفسير-حلم-تمر",
    "name": "تمر",
    "letter": "ت",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": "dates",
    "text": "لمن رآه مطر، ومن أكله رزق",
    "wordCount": 6
  },
  {
    "slug": "tmsah",
    "arabicSlug": "تفسير-حلم-تمساح",
    "name": "تمساح",
    "letter": "ت",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رؤيته تدل على شرطي، أو لص خائن، والتاجر الظالم",
    "wordCount": 9
  },
  {
    "slug": "tmlq",
    "arabicSlug": "تفسير-حلم-تملق",
    "name": "تملق",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "لمن لم يتعود ذلك ذلة ومهانة",
    "wordCount": 6
  },
  {
    "slug": "thdyd",
    "arabicSlug": "تفسير-حلم-تهديد",
    "name": "تهديد",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه مهدد فانه يظفر ولا يخاف ولا يخضع",
    "wordCount": 10
  },
  {
    "slug": "twasl",
    "arabicSlug": "تفسير-حلم-تواصل",
    "name": "تواصل",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على صلة الرحم والتواصل مع الناس حسب نوعياتهم",
    "wordCount": 9
  },
  {
    "slug": "twbh",
    "arabicSlug": "تفسير-حلم-توبة",
    "name": "توبة",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على النجاة",
    "wordCount": 3
  },
  {
    "slug": "twt",
    "arabicSlug": "تفسير-حلم-توت",
    "name": "توت",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "أكله في المنام يدل على كسب واسع نافع",
    "wordCount": 8
  },
  {
    "slug": "twdya",
    "arabicSlug": "تفسير-حلم-توديع",
    "name": "توديع",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على زوال المنصب، أو طلاق الزوجة، أو موت مريض",
    "wordCount": 10
  },
  {
    "slug": "tys",
    "arabicSlug": "تفسير-حلم-تيس",
    "name": "تيس",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام رجل مهيب في منظره، وأبله في اختياره",
    "wordCount": 9
  },
  {
    "slug": "tymm",
    "arabicSlug": "تفسير-حلم-تيمم",
    "name": "تيمم",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على السفر أو الإنذار بالمرض",
    "wordCount": 6
  },
  {
    "slug": "tyn-2",
    "arabicSlug": "تفسير-حلم-تين",
    "name": "تين",
    "letter": "ت",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على مال كثير، وزيادة الخير",
    "wordCount": 6
  },
  {
    "slug": "thalyl",
    "arabicSlug": "تفسير-حلم-ثآليل",
    "name": "ثآليل",
    "letter": "ث",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أن به ثآليل حصل على مالا يخشى من ضياعه",
    "wordCount": 11
  },
  {
    "slug": "thdy",
    "arabicSlug": "تفسير-حلم-ثدي",
    "name": "ثدي",
    "letter": "ث",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على امرأة الرجل أو بنته، الثدي الكبير دال على فجور المرأة، واللبن في الثدي زيادة في المال ودال على الولد",
    "wordCount": 21
  },
  {
    "slug": "thrwh",
    "arabicSlug": "تفسير-حلم-ثروة",
    "name": "ثروة",
    "letter": "ث",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الزوجة والأعمال الصالحة",
    "wordCount": 5
  },
  {
    "slug": "thrya",
    "arabicSlug": "تفسير-حلم-ثريا",
    "name": "ثريا",
    "letter": "ث",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل حازم في الأمور",
    "wordCount": 4
  },
  {
    "slug": "thaban",
    "arabicSlug": "تفسير-حلم-ثعبان",
    "name": "ثعبان",
    "letter": "ث",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "snake",
    "text": "يدل على العداوة من الأهل، وربما كان جار حسود، ومن رأى انه امتلك ثعبان فانه يصيب سلطانا عظيما",
    "wordCount": 18
  },
  {
    "slug": "thalb",
    "arabicSlug": "تفسير-حلم-ثعلب",
    "name": "ثعلب",
    "letter": "ث",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على عدو كذاب مخالف مراوغ في معاملته",
    "wordCount": 8
  },
  {
    "slug": "thlj",
    "arabicSlug": "تفسير-حلم-ثلج",
    "name": "ثلج",
    "letter": "ث",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دليل على الأرزاق والشفاء من الأمراض وربما يدل على الألفة والمحبة",
    "wordCount": 11
  },
  {
    "slug": "thmrh",
    "arabicSlug": "تفسير-حلم-ثمرة",
    "name": "ثمرة",
    "letter": "ث",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "إذا كانت ذا طعم حلو تدل على الرزق والفائدة",
    "wordCount": 9
  },
  {
    "slug": "thwb",
    "arabicSlug": "تفسير-حلم-ثوب",
    "name": "ثوب",
    "letter": "ث",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": "clothes",
    "text": "الثياب البيضاء خير لمن يلبسها، الثوب الأسود لمن لم يتعود على لبسه دال على المكروه، والثوب الأخضر دال على الزهد والعبادة",
    "wordCount": 21
  },
  {
    "slug": "thwr",
    "arabicSlug": "تفسير-حلم-ثور",
    "name": "ثور",
    "letter": "ث",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دليل على الرئاسة ونمو التجارة، ومن رأى إن الثور يصرعه فدال على الفتنة والهلاك",
    "wordCount": 14
  },
  {
    "slug": "thwm",
    "arabicSlug": "تفسير-حلم-ثوم",
    "name": "ثوم",
    "letter": "ث",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دال على المال الحرام، وتبديل الخير بالشر، واكل الثوم للمريض شفاء، وقيل إن الثوم هم وحزن",
    "wordCount": 16
  },
  {
    "slug": "jaby",
    "arabicSlug": "تفسير-حلم-جابي",
    "name": "جابي",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على قضاء الدين، وتأدية الأمانات",
    "wordCount": 7
  },
  {
    "slug": "jaryh",
    "arabicSlug": "تفسير-حلم-جارية",
    "name": "جارية",
    "letter": "ج",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دالة على تجارة، ومن رأى جارية مسلمة متزينة سمع خبر موحشا، ومن رأى جارية عابسة الوجه سمع خبرا سيئا، ومن رأى جارية مهزولة أصابه هم وفقر",
    "wordCount": 26
  },
  {
    "slug": "jasws",
    "arabicSlug": "تفسير-حلم-جاسوس",
    "name": "جاسوس",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الجان أو المؤثر لأعمال الشر",
    "wordCount": 7
  },
  {
    "slug": "jama",
    "arabicSlug": "تفسير-حلم-جامع",
    "name": "جامع",
    "letter": "ج",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "يدل في المنام على المكان الجامع للتجارة، ويدل على العدل لمن دخله في المنام مظلوما",
    "wordCount": 15
  },
  {
    "slug": "jamws",
    "arabicSlug": "تفسير-حلم-جاموس",
    "name": "جاموس",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الكد والسعي والخير",
    "wordCount": 5
  },
  {
    "slug": "jbs",
    "arabicSlug": "تفسير-حلم-جبس",
    "name": "جبس",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على دوام العز والمنصب، وحسن حال الأزواج والأولاد، والثبات في الدين والعلم، والشفاء من الأمراض",
    "wordCount": 16
  },
  {
    "slug": "jbanh",
    "arabicSlug": "تفسير-حلم-جبانة",
    "name": "جبانة",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أمن للخاف، وخوف لآمن، والجبانة دالة على الآخرة",
    "wordCount": 10
  },
  {
    "slug": "jbh",
    "arabicSlug": "تفسير-حلم-جبة",
    "name": "جبة",
    "letter": "ج",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "دالة على المرأة وان رأتها المرأة فإنها تخون زوجها، كما تدل على العمر الطويل",
    "wordCount": 14
  },
  {
    "slug": "jbl",
    "arabicSlug": "تفسير-حلم-جبل",
    "name": "جبل",
    "letter": "ج",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "هو في المنام رجل رفيع الشأن قاس، مدبر لأمره، أو امرأة قاسية",
    "wordCount": 12
  },
  {
    "slug": "jbn",
    "arabicSlug": "تفسير-حلم-جبن",
    "name": "جبن",
    "letter": "ج",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "هو المصنوع من اللبن دليل على عقد نكاح للأعزب، والولد للحامل والمال الرابح، والعمر الطويل، ورؤية الجبن للمحارب قهر له",
    "wordCount": 20
  },
  {
    "slug": "jbhh",
    "arabicSlug": "تفسير-حلم-جبهة",
    "name": "جبهة",
    "letter": "ج",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دالة على جاه الإنسان، فأن رأى بها كسر فانه نقصان في هيبته",
    "wordCount": 12
  },
  {
    "slug": "jhr",
    "arabicSlug": "تفسير-حلم-جحر",
    "name": "جحر",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على إتباع البدع، فمن رأى جحر خرج من حيوان فهو فم يخرج منه كلام بمنزلة ذلك الحيوان",
    "wordCount": 18
  },
  {
    "slug": "jhwd",
    "arabicSlug": "تفسير-حلم-جحود",
    "name": "جحود",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الجحود للفضل دليل على الظلم",
    "wordCount": 5
  },
  {
    "slug": "jdry",
    "arabicSlug": "تفسير-حلم-جدري",
    "name": "جدري",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المال",
    "wordCount": 3
  },
  {
    "slug": "jrahh",
    "arabicSlug": "تفسير-حلم-جراحة",
    "name": "جراحة",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه جرح وخرج منه الدم فانه يغتاب",
    "wordCount": 9
  },
  {
    "slug": "jrad",
    "arabicSlug": "تفسير-حلم-جراد",
    "name": "جراد",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على العذاب، وان وضع في إناء أو قدر فأنه مال",
    "wordCount": 11
  },
  {
    "slug": "jrb",
    "arabicSlug": "تفسير-حلم-جرب",
    "name": "جرب",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن عنده جرب فانه في تعب وهم",
    "wordCount": 9
  },
  {
    "slug": "jrh",
    "arabicSlug": "تفسير-حلم-جرة",
    "name": "جرة",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أجير منافق، كما تدل على المرأة",
    "wordCount": 8
  },
  {
    "slug": "jrjyr",
    "arabicSlug": "تفسير-حلم-جرجير",
    "name": "جرجير",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يأكل الجرجير فانه يعمل عمل أهل النار",
    "wordCount": 10
  },
  {
    "slug": "jrdh",
    "arabicSlug": "تفسير-حلم-جرذ",
    "name": "جرذ",
    "letter": "ج",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى انه اخذ جرذ أو دخل عليه انتقل من بلاده، ومن رأى انه يأكل لحمه اغتاب إنسان فاسق",
    "wordCount": 19
  },
  {
    "slug": "jrs",
    "arabicSlug": "تفسير-حلم-جرس",
    "name": "جرس",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل مؤذن، والجرس صاحب خير، وربما دل على السفر",
    "wordCount": 11
  },
  {
    "slug": "jzar",
    "arabicSlug": "تفسير-حلم-جزار",
    "name": "جزار",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل مهلك للرجال، والجزار إذا حسنت حالته دال على حسن عاقبته",
    "wordCount": 13
  },
  {
    "slug": "jzr",
    "arabicSlug": "تفسير-حلم-جزر",
    "name": "جزر",
    "letter": "ج",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "من رأى انه يأكل الجزر فأنه ينال خيرا ومنفعة، والجزر يدل على رجل سهل المرام",
    "wordCount": 15
  },
  {
    "slug": "jsr",
    "arabicSlug": "تفسير-حلم-جسر",
    "name": "جسر",
    "letter": "ج",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "دل على ما ينجي الإنسان من عذاب الآخرة",
    "wordCount": 8
  },
  {
    "slug": "jfaf",
    "arabicSlug": "تفسير-حلم-جفاف",
    "name": "جفاف",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الفقر وعدم الراحة",
    "wordCount": 5
  },
  {
    "slug": "jfn",
    "arabicSlug": "تفسير-حلم-جفن",
    "name": "جفن",
    "letter": "ج",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "إذا رأى الجفن خاليا من الألم فذلك محمود للجميع وإذا كانت الجفون قليلة اللحم وفيها قروح فيدل على غم وحزن",
    "wordCount": 20
  },
  {
    "slug": "jlad",
    "arabicSlug": "تفسير-حلم-جلاد",
    "name": "جلاد",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل شاتم، وتدل على النكد والأمراض وما يوجب الحدود",
    "wordCount": 11
  },
  {
    "slug": "jld",
    "arabicSlug": "تفسير-حلم-جلد",
    "name": "جلد",
    "letter": "ج",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دال على الصبر والتجلد في الأمور، فمن رأى جلده تحسن دل على الخير والراحة",
    "wordCount": 14
  },
  {
    "slug": "jmal",
    "arabicSlug": "تفسير-حلم-جمال",
    "name": "جمال",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية جمال الإنسان دليل على سوء حال عدوه",
    "wordCount": 8
  },
  {
    "slug": "jml",
    "arabicSlug": "تفسير-حلم-جمل",
    "name": "جمل",
    "letter": "ج",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "camel",
    "text": "دال على الأسفار وموت المرضى",
    "wordCount": 5
  },
  {
    "slug": "jmr",
    "arabicSlug": "تفسير-حلم-جمر",
    "name": "جمر",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رزق عاجل فأن انتفع به في المنام فهو رزق بدون تعب",
    "wordCount": 13
  },
  {
    "slug": "jmah",
    "arabicSlug": "تفسير-حلم-جمعة",
    "name": "جمعة",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه في يوم جمعة فان الله يجمع أموره المتفرقة ويحوله من العسر إلى اليسر",
    "wordCount": 16
  },
  {
    "slug": "jn",
    "arabicSlug": "تفسير-حلم-جن",
    "name": "جن",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أصحاب النصب والاحتيال لأمور الدنيا",
    "wordCount": 7
  },
  {
    "slug": "jnazh",
    "arabicSlug": "تفسير-حلم-جنازة",
    "name": "جنازة",
    "letter": "ج",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": null,
    "text": "من رأى انه يصلي على جنازة فانه يصاحب أناس تقيين",
    "wordCount": 10
  },
  {
    "slug": "jnayh",
    "arabicSlug": "تفسير-حلم-جناية",
    "name": "جناية",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الوقوع في المحذور، وربما دلت على بلوغ المقصود",
    "wordCount": 10
  },
  {
    "slug": "jnd",
    "arabicSlug": "تفسير-حلم-جند",
    "name": "جند",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على نصرة أصحاب الحق",
    "wordCount": 5
  },
  {
    "slug": "jhd",
    "arabicSlug": "تفسير-حلم-جهد",
    "name": "جهد",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على موت المريض، والجهد هو الكد على العيال أو الجهاد",
    "wordCount": 11
  },
  {
    "slug": "jwrb",
    "arabicSlug": "تفسير-حلم-جورب",
    "name": "جورب",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المال والوقاية ما لم يلبس، فمن رأى انه يلبس جوربا فقد وفى ماله، والجورب يعبر بالخادم والمرأة الجارية",
    "wordCount": 20
  },
  {
    "slug": "jwz",
    "arabicSlug": "تفسير-حلم-جوز",
    "name": "جوز",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المال المكنوز، فأن سمعت له صوت فهو خصومة",
    "wordCount": 10
  },
  {
    "slug": "jwa",
    "arabicSlug": "تفسير-حلم-جوع",
    "name": "جوع",
    "letter": "ج",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على لباس الحداد والخوف، وحرص في طلب المعيشة، وقيل من رأى انه جائع أصاب خير",
    "wordCount": 16
  },
  {
    "slug": "jwhry",
    "arabicSlug": "تفسير-حلم-جوهري",
    "name": "جوهري",
    "letter": "ج",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "رؤيته تدل على صاحب نسك وعبادة، كما تدل على الدلال، وتدل على العالم الذي يقتدي به الناس",
    "wordCount": 17
  },
  {
    "slug": "hayt",
    "arabicSlug": "تفسير-حلم-حائط",
    "name": "حائط",
    "letter": "ح",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "من رأى أنه قائم على حائط أو راكبه فان الحائط حاله الذي يقيمه، والحائط رجل منيع صاحب دين ومال",
    "wordCount": 19
  },
  {
    "slug": "hayk",
    "arabicSlug": "تفسير-حلم-حائك",
    "name": "حائك",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على تسهيل الأمور، أو السفر",
    "wordCount": 7
  },
  {
    "slug": "hajb-alayn",
    "arabicSlug": "تفسير-حلم-حاجب-العين",
    "name": "حاجب العين",
    "letter": "ح",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "أن رأى الإنسان إن حاجبيه اقترنا دل ذلك على الألفة والمحبة وبالعكس، ونزولهما على العين دليل على تغير الحال، وربما دل على طول العمر",
    "wordCount": 24
  },
  {
    "slug": "hb",
    "arabicSlug": "تفسير-حلم-حب",
    "name": "حب",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام هموم وأنكاد، ويدل على الفقر والموت للمريض",
    "wordCount": 9
  },
  {
    "slug": "hbh-swda",
    "arabicSlug": "تفسير-حلم-حبة-سوداء",
    "name": "حبة سوداء",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الصحة وعافية الجسم",
    "wordCount": 5
  },
  {
    "slug": "hbs",
    "arabicSlug": "تفسير-حلم-حبس",
    "name": "حبس",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الذل والهم",
    "wordCount": 4
  },
  {
    "slug": "hbl",
    "arabicSlug": "تفسير-حلم-حبل",
    "name": "حبل",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "pregnancy",
    "text": "دلالة على التمسك بالدين",
    "wordCount": 4
  },
  {
    "slug": "hj",
    "arabicSlug": "تفسير-حلم-حج",
    "name": "حج",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "hajj",
    "text": "من رأى انه حج فدلالة على الاستقامة، وأمن مما يخاف، ودين يقضيه",
    "wordCount": 12
  },
  {
    "slug": "hjamh",
    "arabicSlug": "تفسير-حلم-حجامة",
    "name": "حجامة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على كل متحكم في الناس",
    "wordCount": 6
  },
  {
    "slug": "hjr",
    "arabicSlug": "تفسير-حلم-حجر",
    "name": "حجر",
    "letter": "ح",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "يدل على أهل القسوة، ومن رأى انه ضرب حجر وخرج منه ماء فدليل على زيادة الرزق",
    "wordCount": 16
  },
  {
    "slug": "hd",
    "arabicSlug": "تفسير-حلم-حد",
    "name": "حد",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الدين والمطالبة به، وربما دل على وقوف الإنسان عند حده، أو الزواج للأعزب",
    "wordCount": 15
  },
  {
    "slug": "hdad",
    "arabicSlug": "تفسير-حلم-حداد",
    "name": "حداد",
    "letter": "ح",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "في المنام ملك عظيم أو سلطان مهيب، والحداد ملك الموت",
    "wordCount": 10
  },
  {
    "slug": "hdth",
    "arabicSlug": "تفسير-حلم-حدث",
    "name": "حدث",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى كأنه يحدث حدثا أصغر يذهب غمه، فأن كان صاحب مال فانه يزكي ماله، ومن رأى انه احدث وكان الحدث جامدا فانه ينفق ماله في عافية",
    "wordCount": 27
  },
  {
    "slug": "hdyd",
    "arabicSlug": "تفسير-حلم-حديد",
    "name": "حديد",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على مال وقوة لمن رآه في يده، ومن رأى أنه يذيب حديدا فانه يقع في ألسنة الناس ويغتابونه",
    "wordCount": 19
  },
  {
    "slug": "hdha",
    "arabicSlug": "تفسير-حلم-حذاء",
    "name": "حذاء",
    "letter": "ح",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": "shoes",
    "text": "دال على الرجل الذي يزين النساء",
    "wordCount": 6
  },
  {
    "slug": "hdhr",
    "arabicSlug": "تفسير-حلم-حذر",
    "name": "حذر",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على النفاق والبعد عن الحق",
    "wordCount": 6
  },
  {
    "slug": "hr",
    "arabicSlug": "تفسير-حلم-حر",
    "name": "حر",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إن كان في الشتاء دل على الفوائد وأن كان في الصيف دل على العكس",
    "wordCount": 14
  },
  {
    "slug": "hrb",
    "arabicSlug": "تفسير-حلم-حرب",
    "name": "حرب",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على غلاء الأسعار، والحرب بين السلاطين تدل على فتنة أو وباء",
    "wordCount": 12
  },
  {
    "slug": "hrba",
    "arabicSlug": "تفسير-حلم-حرباء",
    "name": "حرباء",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على وزير للملك، كما تدل على الخدمة للبطال، أو الفتنة",
    "wordCount": 11
  },
  {
    "slug": "hrth",
    "arabicSlug": "تفسير-حلم-حرث",
    "name": "حرث",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يحرث في ارض غيره وهو يعرف صاحبها فأنه يتزوج امرأته",
    "wordCount": 13
  },
  {
    "slug": "hryr",
    "arabicSlug": "تفسير-حلم-حرير",
    "name": "حرير",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على العشق لمن رآه، ويدل الحرير على التزوج بامرأة شريفة",
    "wordCount": 11
  },
  {
    "slug": "hzam",
    "arabicSlug": "تفسير-حلم-حزام",
    "name": "حزام",
    "letter": "ح",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "دال على المال والادخار وجمعه، وربما دل على الجد في طلب العلم",
    "wordCount": 12
  },
  {
    "slug": "hsab",
    "arabicSlug": "تفسير-حلم-حساب",
    "name": "حساب",
    "letter": "ح",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "للميت في المنام دال على عذابه، وان حاسب الإنسان نفسه في المنام فأنه يدل على توبته",
    "wordCount": 16
  },
  {
    "slug": "hsd",
    "arabicSlug": "تفسير-حلم-حسد",
    "name": "حسد",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "فساد لفاعله، والحسد في المنام يدل على الفقر للحاسد، ويدل للمحسود على الزيادة في الرزق",
    "wordCount": 15
  },
  {
    "slug": "hsnh",
    "arabicSlug": "تفسير-حلم-حسنة",
    "name": "حسنة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على التوبة وصلة الرحم والصدقة",
    "wordCount": 6
  },
  {
    "slug": "hshysh",
    "arabicSlug": "تفسير-حلم-حشيش",
    "name": "حشيش",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى الحشيش ينبت على الأرض فهو صلاح الأمور، ومن رأى الحشيش ينبت عليه نال خيرا",
    "wordCount": 16
  },
  {
    "slug": "hsa",
    "arabicSlug": "تفسير-حلم-حصى",
    "name": "حصى",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الأموال، كما تدل على السب والقذف",
    "wordCount": 8
  },
  {
    "slug": "hsad",
    "arabicSlug": "تفسير-حلم-حصاد",
    "name": "حصاد",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل عل تيسير الأمور والرزق العاجل",
    "wordCount": 6
  },
  {
    "slug": "hsbh",
    "arabicSlug": "تفسير-حلم-حصبة",
    "name": "حصبة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المال",
    "wordCount": 3
  },
  {
    "slug": "hsn",
    "arabicSlug": "تفسير-حلم-حصن",
    "name": "حصن",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الصدق، كما يدل على التحصين من الشيطان",
    "wordCount": 9
  },
  {
    "slug": "hsyr",
    "arabicSlug": "تفسير-حلم-حصير",
    "name": "حصير",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الخادم، ومن رأى انه جالس على حصير فانه يأتي أمرا يتحسر عليه ويندم",
    "wordCount": 16
  },
  {
    "slug": "htb",
    "arabicSlug": "تفسير-حلم-حطب",
    "name": "حطب",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على النميمة وربما حمل الحطب كلاما مؤلما وذم في الناس",
    "wordCount": 11
  },
  {
    "slug": "hfr",
    "arabicSlug": "تفسير-حلم-حفر",
    "name": "حفر",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "حفر الأرض دال على الحصول على المال",
    "wordCount": 7
  },
  {
    "slug": "hq",
    "arabicSlug": "تفسير-حلم-حق",
    "name": "حق",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على إتباع الهدى والبعد عن الباطل",
    "wordCount": 7
  },
  {
    "slug": "hkh",
    "arabicSlug": "تفسير-حلم-حكة",
    "name": "حكة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يحك جسمه فأنه يتفقد حال أهله ويصيبه منهم تعب",
    "wordCount": 12
  },
  {
    "slug": "hlaq",
    "arabicSlug": "تفسير-حلم-حلاق",
    "name": "حلاق",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته في المنام تدل على رجل يصلح الأمور",
    "wordCount": 8
  },
  {
    "slug": "hlal-2",
    "arabicSlug": "تفسير-حلم-حلال",
    "name": "حلال",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "لمن اكتسبه يدل على التوبة",
    "wordCount": 5
  },
  {
    "slug": "hlbh",
    "arabicSlug": "تفسير-حلم-حلبة",
    "name": "حلبة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "مال عسر مع كد وتعب",
    "wordCount": 5
  },
  {
    "slug": "hlf",
    "arabicSlug": "تفسير-حلم-حلف",
    "name": "حلف",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "أذا حلف لرجل أو حلف له فان الرجل يغرر به ويخدعه، ومن رأى انه حلف صادقا فانه يظفر",
    "wordCount": 18
  },
  {
    "slug": "hlq",
    "arabicSlug": "تفسير-حلم-حلق",
    "name": "حلق",
    "letter": "ح",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "من رأى انه يخرج من حلقه شعر أو خيط فمده ولم ينقطع فتطول حياته، أو مخاصمته",
    "wordCount": 16
  },
  {
    "slug": "hlq-alshar",
    "arabicSlug": "تفسير-حلم-حلق-الشعر",
    "name": "حلق الشعر",
    "letter": "ح",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "حلق الشعر دال على فعل الخير والحصول على الفائدة، وربما دل على الراحة والشفاء",
    "wordCount": 14
  },
  {
    "slug": "hlqwm",
    "arabicSlug": "تفسير-حلم-حلقوم",
    "name": "حلقوم",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "وهو مجرى النفس يدل في المنام على الرسول والموت والحياة",
    "wordCount": 10
  },
  {
    "slug": "hma",
    "arabicSlug": "تفسير-حلم-حمى",
    "name": "حمى",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على قضاء الدين وربما دلت على التوعد والتهديد",
    "wordCount": 9
  },
  {
    "slug": "hmar",
    "arabicSlug": "تفسير-حلم-حمار",
    "name": "حمار",
    "letter": "ح",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على السفر، ومن ركب حمار فأن سعيه موفق وحسن",
    "wordCount": 10
  },
  {
    "slug": "hmal",
    "arabicSlug": "تفسير-حلم-حمال",
    "name": "حمال",
    "letter": "ح",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رأى انه يحمل حمل ثقيلا فيصيبه هم بقدر الثقل",
    "wordCount": 10
  },
  {
    "slug": "hmam",
    "arabicSlug": "تفسير-حلم-حمام",
    "name": "حمام",
    "letter": "ح",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "الحمامة امرأة محبوبة، كما تدل على البشرى لمن كان في شدة",
    "wordCount": 11
  },
  {
    "slug": "hml-almrah",
    "arabicSlug": "تفسير-حلم-حمل-المرأة",
    "name": "حمل المرأة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "pregnancy",
    "text": "من رأى حمل المرأة فانه يرجى خير ا ومن رأت نفسها حبلى فتتزوج",
    "wordCount": 13
  },
  {
    "slug": "hms",
    "arabicSlug": "تفسير-حلم-حمص",
    "name": "حمص",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على مال بتعب",
    "wordCount": 4
  },
  {
    "slug": "hmq",
    "arabicSlug": "تفسير-حلم-حمق",
    "name": "حمق",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من اتسم بالحمق في الحلم فأنه يدل على الرزق",
    "wordCount": 9
  },
  {
    "slug": "hna-2",
    "arabicSlug": "تفسير-حلم-حناء",
    "name": "حناء",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "عدة الرجل لعمله الذي يعمله، والحناء زينة في المال والعيال",
    "wordCount": 10
  },
  {
    "slug": "hnth",
    "arabicSlug": "تفسير-حلم-حنطة",
    "name": "حنطة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام مال شريف في تعب ومن اشترى حنطة حصل على المال وزاد في عياله",
    "wordCount": 15
  },
  {
    "slug": "hnk-alansan",
    "arabicSlug": "تفسير-حلم-حنك-الإنسان",
    "name": "حنك الإنسان",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الزوجان أو شريكان أو ابنان",
    "wordCount": 7
  },
  {
    "slug": "hnyn",
    "arabicSlug": "تفسير-حلم-حنين",
    "name": "حنين",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الفراق، كما يدل على الغنى بعد الفقر",
    "wordCount": 9
  },
  {
    "slug": "hwa-2",
    "arabicSlug": "تفسير-حلم-حواء",
    "name": "حواء",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيتها تدل على البركة",
    "wordCount": 4
  },
  {
    "slug": "hwt",
    "arabicSlug": "تفسير-حلم-حوت",
    "name": "حوت",
    "letter": "ح",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "fish",
    "text": "يدل على الهم والنكد وحلول الغضب",
    "wordCount": 6
  },
  {
    "slug": "hwd",
    "arabicSlug": "تفسير-حلم-حوض",
    "name": "حوض",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرجل السخي نافع للناس، كما يدل على الرزق من إنسان كريم",
    "wordCount": 13
  },
  {
    "slug": "hwl-alayn",
    "arabicSlug": "تفسير-حلم-حول-العين",
    "name": "حول العين",
    "letter": "ح",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "يدل على نقض العهد أو النقص في الكلام",
    "wordCount": 8
  },
  {
    "slug": "hya",
    "arabicSlug": "تفسير-حلم-حياء",
    "name": "حياء",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إمساك عن إتيان الفاحشة، ودال على الهداية",
    "wordCount": 7
  },
  {
    "slug": "hyh",
    "arabicSlug": "تفسير-حلم-حية",
    "name": "حية",
    "letter": "ح",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "snake",
    "text": "في المنام دالة على عدو، أو كنز، أو امرأة، والحية عدو ذو مال",
    "wordCount": 13
  },
  {
    "slug": "hyrh",
    "arabicSlug": "تفسير-حلم-حيرة",
    "name": "حيرة",
    "letter": "ح",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الغفلة واستمالة الشيطان له إلى الضلالة",
    "wordCount": 8
  },
  {
    "slug": "hyd",
    "arabicSlug": "تفسير-حلم-حيض",
    "name": "حيض",
    "letter": "ح",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "إذا رأى رجل انه حائض فانه يأتي محرما، فأن رأت المرأة أنها حائض فإنها في ذنب فان اغتسلت تابت من الذنب وذهب همها",
    "wordCount": 23
  },
  {
    "slug": "khatm",
    "arabicSlug": "تفسير-حلم-خاتم",
    "name": "خاتم",
    "letter": "خ",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": "ring",
    "text": "من رأى خاتما من ذهب وزوجته حامل ولدت له ذكرا، وكسر الخاتم دال على الطلاق، ومن ضاع خاتمه ضاع ملكه، فأن أعطيت امرأة خاتم فإنها تتزوج أو تلد",
    "wordCount": 28
  },
  {
    "slug": "khatn",
    "arabicSlug": "تفسير-حلم-خاتن",
    "name": "خاتن",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على كشف العورات",
    "wordCount": 4
  },
  {
    "slug": "khbaz",
    "arabicSlug": "تفسير-حلم-خباز",
    "name": "خباز",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الطمانينة، والعيش الرغد",
    "wordCount": 6
  },
  {
    "slug": "khtm",
    "arabicSlug": "تفسير-حلم-ختم",
    "name": "ختم",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يختم على مال أو غلال دال على تولي منصب، أو الاستغناء",
    "wordCount": 14
  },
  {
    "slug": "khd",
    "arabicSlug": "تفسير-حلم-خد",
    "name": "خد",
    "letter": "خ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دال على ما يتجمل بهما الإنسان، وربما دل على الذل والمسكنة",
    "wordCount": 11
  },
  {
    "slug": "khdaa",
    "arabicSlug": "تفسير-حلم-خداع",
    "name": "خداع",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن احد يخدعه فأن الله يؤيده وينصره",
    "wordCount": 9
  },
  {
    "slug": "khdsh",
    "arabicSlug": "تفسير-حلم-خدش",
    "name": "خدش",
    "letter": "خ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "رؤيته تدل على الضرر في المال أو في الأقرباء",
    "wordCount": 9
  },
  {
    "slug": "khrab",
    "arabicSlug": "تفسير-حلم-خراب",
    "name": "خراب",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على تشتت الأهل وخراب البلد، ومن رأى انه في خراب فأنه يبتلى",
    "wordCount": 13
  },
  {
    "slug": "khrdl",
    "arabicSlug": "تفسير-حلم-خردل",
    "name": "خردل",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام سم، وربما ينال مال شريفا بتعب",
    "wordCount": 9
  },
  {
    "slug": "khrz",
    "arabicSlug": "تفسير-حلم-خرز",
    "name": "خرز",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه حصل على الخرز فانه يحصل على المال",
    "wordCount": 10
  },
  {
    "slug": "khrs",
    "arabicSlug": "تفسير-حلم-خرس",
    "name": "خرس",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على فساد الدين وقول الباطل، ومن رأى إن لسانه معتقل نال فصاحة ورزقا وظفر بالأعداء",
    "wordCount": 16
  },
  {
    "slug": "khrnwb",
    "arabicSlug": "تفسير-حلم-خرنوب",
    "name": "خرنوب",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على موت المريض وخراب جسمه",
    "wordCount": 6
  },
  {
    "slug": "khrwf",
    "arabicSlug": "تفسير-حلم-خروف",
    "name": "خروف",
    "letter": "خ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "يدل على ولد ذكر مطيع لوالديه",
    "wordCount": 6
  },
  {
    "slug": "khzanh",
    "arabicSlug": "تفسير-حلم-خزانة",
    "name": "خزانة",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على امرأة الرجل، كما تدل على حفظ الأسرار",
    "wordCount": 9
  },
  {
    "slug": "khsarh",
    "arabicSlug": "تفسير-حلم-خسارة",
    "name": "خسارة",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على فساد المعتقد",
    "wordCount": 4
  },
  {
    "slug": "khsf",
    "arabicSlug": "تفسير-حلم-خسف",
    "name": "خسف",
    "letter": "خ",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "من رأى إن الأرض انخسفت به فأنه يصيبه عذاب، أو عقوبة ز",
    "wordCount": 12
  },
  {
    "slug": "khshb",
    "arabicSlug": "تفسير-حلم-خشب",
    "name": "خشب",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رئيس المنافقين",
    "wordCount": 4
  },
  {
    "slug": "khshn",
    "arabicSlug": "تفسير-حلم-خشن",
    "name": "خشن",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من الملابس أو الأكل دال على زوال النعمة، كما يدل على نفور المتحابين",
    "wordCount": 13
  },
  {
    "slug": "khsam",
    "arabicSlug": "تفسير-حلم-خصام",
    "name": "خصام",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "للمتخاصمين دال على الصلح، ويدل على إبطال العمل الطيب",
    "wordCount": 9
  },
  {
    "slug": "khtyb",
    "arabicSlug": "تفسير-حلم-خطيب",
    "name": "خطيب",
    "letter": "خ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الطهارة، والتوبة من الذنوب، ويدل على الأفراح",
    "wordCount": 10
  },
  {
    "slug": "khf-2",
    "arabicSlug": "تفسير-حلم-خف",
    "name": "خف",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الخاتم، وعلى المال، وعلى الوقاية من المكاره، ومن رأى أنه لبس خفين فانه يسافر، ويدل نزع الخفين على زوال الهم والضيق",
    "wordCount": 23
  },
  {
    "slug": "khfash",
    "arabicSlug": "تفسير-حلم-خفاش",
    "name": "خفاش",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على ذهاب الخوف، وهو خير للمرأة الحمل",
    "wordCount": 8
  },
  {
    "slug": "khfyr",
    "arabicSlug": "تفسير-حلم-خفير",
    "name": "خفير",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الأمن والسلامة",
    "wordCount": 4
  },
  {
    "slug": "khl-2",
    "arabicSlug": "تفسير-حلم-خل",
    "name": "خل",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المال مع البركة وطول الحياة، ومن رأى انه يشرب الخل فان ذلك يدل على معادة أهل بيته",
    "wordCount": 19
  },
  {
    "slug": "khlkhal",
    "arabicSlug": "تفسير-حلم-خلخال",
    "name": "خلخال",
    "letter": "خ",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "من رأى أن عليه خلخالا من ذهب أصابه هم أو حزن وما رأت المرأة في خلخالاها من صلاح أو فساد فأن تأويل ذلك في زوجها، والخلخال في المنام رفعة وسعة وجمال",
    "wordCount": 31
  },
  {
    "slug": "khlyh-alnhl",
    "arabicSlug": "تفسير-حلم-خلية-النحل",
    "name": "خلية النحل",
    "letter": "خ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "في المنام زوجة لمالكها، ونحلها هو النسل، وشهدها هو مالها، وربما دلت على التخلي عن الهموم",
    "wordCount": 16
  },
  {
    "slug": "khlyj",
    "arabicSlug": "تفسير-حلم-خليج",
    "name": "خليج",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أتباع أو أبواب، كما يدل على الرجل المتوسط الحال",
    "wordCount": 11
  },
  {
    "slug": "khlyfh",
    "arabicSlug": "تفسير-حلم-خليفة",
    "name": "خليفة",
    "letter": "خ",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رأى نفسه خليفة دل على حسن حاله وإذا كان الراوي موعودا بوعد ينجز له وينال حاجته",
    "wordCount": 17
  },
  {
    "slug": "khmar",
    "arabicSlug": "تفسير-حلم-خمار",
    "name": "خمار",
    "letter": "خ",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "زوج للمرأة وسترها، وسعته سعة حال، وصفائه كثرة ماله، وبياضه دينه جاهه",
    "wordCount": 12
  },
  {
    "slug": "khmr",
    "arabicSlug": "تفسير-حلم-خمر",
    "name": "خمر",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام مال حرام، ومن رأى انه يشربها فانه يصيب إثما كبيرا ورزقا واسعا",
    "wordCount": 14
  },
  {
    "slug": "khnaq",
    "arabicSlug": "تفسير-حلم-خناق",
    "name": "خناق",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته تدل على القهر",
    "wordCount": 4
  },
  {
    "slug": "khnjr",
    "arabicSlug": "تفسير-حلم-خنجر",
    "name": "خنجر",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن بيده خنجرا نال مالا وغنى، ومن رأى أنه يدخل خنجرا في غلافه فانه ينكح امرأة",
    "wordCount": 18
  },
  {
    "slug": "khndq",
    "arabicSlug": "تفسير-حلم-خندق",
    "name": "خندق",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على ما يتحصن به المرء",
    "wordCount": 6
  },
  {
    "slug": "khnzyr",
    "arabicSlug": "تفسير-حلم-خنزير",
    "name": "خنزير",
    "letter": "خ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "في المنام عدو ملعون قوي مكايد، فأن رأى انه يركبه أصاب مالا كثيرا، وأن رأى انه يأكله نال مالا غير محلل",
    "wordCount": 21
  },
  {
    "slug": "khnfsa",
    "arabicSlug": "تفسير-حلم-خنفساء",
    "name": "خنفساء",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على إنسان بغيض قذر",
    "wordCount": 5
  },
  {
    "slug": "khwkh",
    "arabicSlug": "تفسير-حلم-خوخ",
    "name": "خوخ",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا كان حلوا نال من الشهوات ما يتمنى، وان كان حامضا فهو خوف لمن أكله",
    "wordCount": 15
  },
  {
    "slug": "khwdhh",
    "arabicSlug": "تفسير-حلم-خوذة",
    "name": "خوذة",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الأمن من العدو، أو من أوجاع الرأس",
    "wordCount": 9
  },
  {
    "slug": "khws",
    "arabicSlug": "تفسير-حلم-خوص",
    "name": "خوص",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في لمنام كلام شر، أو خبر مفرح",
    "wordCount": 8
  },
  {
    "slug": "khwf",
    "arabicSlug": "تفسير-حلم-خوف",
    "name": "خوف",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام أمن، والخوف يدل على التوبة",
    "wordCount": 8
  },
  {
    "slug": "khyar",
    "arabicSlug": "تفسير-حلم-خيار",
    "name": "خيار",
    "letter": "خ",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "هم وحزن، فمن أكله يسعى في أمر يثقل عليه، والخيار إذا قطع بالسكين فانه جيد للمرض، والخيار خير وخيره لمن يقدم عليه",
    "wordCount": 22
  },
  {
    "slug": "khyanh",
    "arabicSlug": "تفسير-حلم-خيانة",
    "name": "خيانة",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من أصحاب الأموال في المنام دليل على فقرهم، والخيانة تدل على الزنا",
    "wordCount": 12
  },
  {
    "slug": "khyt",
    "arabicSlug": "تفسير-حلم-خيط",
    "name": "خيط",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه اخذ خيطا فانه محتاج إلى بينة تقوم له",
    "wordCount": 11
  },
  {
    "slug": "khyl",
    "arabicSlug": "تفسير-حلم-خيل",
    "name": "خيل",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "horse",
    "text": "دال على اتساع الرزق والانتصار، وربما يدل على السفر",
    "wordCount": 9
  },
  {
    "slug": "khymh",
    "arabicSlug": "تفسير-حلم-خيمة",
    "name": "خيمة",
    "letter": "خ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على بشارة وربما دلت على السفر، وربما دلت على الزوجة",
    "wordCount": 11
  },
  {
    "slug": "dar",
    "arabicSlug": "تفسير-حلم-دار",
    "name": "دار",
    "letter": "د",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": "new-house",
    "text": "من رأى إن له دارا جديدة فنه إن كان فقيرا استغنى وان كان مهموما فرج عنه",
    "wordCount": 16
  },
  {
    "slug": "dabh",
    "arabicSlug": "تفسير-حلم-دابة",
    "name": "دابة",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دلت رؤيتها على تفريج الهموم",
    "wordCount": 5
  },
  {
    "slug": "db-2",
    "arabicSlug": "تفسير-حلم-دب",
    "name": "دب",
    "letter": "د",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "في المنام سرقة أو تجسس على أخبار من قصده في المنام",
    "wordCount": 11
  },
  {
    "slug": "dbr",
    "arabicSlug": "تفسير-حلم-دبر",
    "name": "دبر",
    "letter": "د",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى دبره قد سد فانه يموت، والدبر رجل ذليل، ومن رأى دبر رجل فانه ينال منه إدبار، ومنقطع دبره قطع رحما، ومن رأى دبر أمه بطل حجه وإلا وقف معاشه",
    "wordCount": 31
  },
  {
    "slug": "dbws",
    "arabicSlug": "تفسير-حلم-دبوس",
    "name": "دبوس",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام بؤس، وان كان حديدا بلا عصا فهو خدمة غير طائلة، أو امرأة بلا جهاز",
    "wordCount": 17
  },
  {
    "slug": "djajh",
    "arabicSlug": "تفسير-حلم-دجاجة",
    "name": "دجاجة",
    "letter": "د",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "في المنام امرأة حمقاء ذات جمال، ومن أكل لحمها فانه يرزق",
    "wordCount": 11
  },
  {
    "slug": "djal",
    "arabicSlug": "تفسير-حلم-دجال",
    "name": "دجال",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على المخادع وتسلط الأعداء",
    "wordCount": 6
  },
  {
    "slug": "dkhan",
    "arabicSlug": "تفسير-حلم-دخان",
    "name": "دخان",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى دخانا يخرج من بيته فانه يقع في خير بعد هول وفضيحة",
    "wordCount": 13
  },
  {
    "slug": "drb-2",
    "arabicSlug": "تفسير-حلم-درب",
    "name": "درب",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى دربا مغلقا دل على حادث، ودخول الدرب دخول في تجارة أو عمل",
    "wordCount": 14
  },
  {
    "slug": "drj",
    "arabicSlug": "تفسير-حلم-درج",
    "name": "درج",
    "letter": "د",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "يدل في المنام على أسباب العلو والرفعة، وأما النزول في الدرج فيعبر عن القدوم من السفر أو التنحي عن الرئاسة",
    "wordCount": 20
  },
  {
    "slug": "dra",
    "arabicSlug": "تفسير-حلم-درع",
    "name": "درع",
    "letter": "د",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "يدل على الوقاية من الأعداء والأمن من الخوف",
    "wordCount": 8
  },
  {
    "slug": "drn",
    "arabicSlug": "تفسير-حلم-درن",
    "name": "درن",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الدين أو المرض أو السفر الموجب للتقشف، وللوسخ على البدن والدرن على الجسد دال على كثرة الذنوب",
    "wordCount": 19
  },
  {
    "slug": "drhm",
    "arabicSlug": "تفسير-حلم-درهم",
    "name": "درهم",
    "letter": "د",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": "money",
    "text": "يدل على الولد، ويدل على التسبيح، وقد يدل على الضرب المؤلم",
    "wordCount": 11
  },
  {
    "slug": "daa",
    "arabicSlug": "تفسير-حلم-دعاء",
    "name": "دعاء",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على بلوغ المقصد، ويدل على الولد، وان كان بصراخ فانه يدل على المصائب",
    "wordCount": 14
  },
  {
    "slug": "dawh-ala-altaam",
    "arabicSlug": "تفسير-حلم-دعوة-إلى-الطعام",
    "name": "دعوة إلى الطعام",
    "letter": "د",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "تدل على اجتماع على خير، ومن رأى انه يدعو قوما فانه يدخل في أمر يورثه الندم والملام",
    "wordCount": 17
  },
  {
    "slug": "dghdghh",
    "arabicSlug": "تفسير-حلم-دغدغة",
    "name": "دغدغة",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يدغدغ رجلا فانه يحول بينه وبين حرفته",
    "wordCount": 10
  },
  {
    "slug": "df",
    "arabicSlug": "تفسير-حلم-دف",
    "name": "دف",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "مصيبة وهم وإحزان، وربما دل على الزواج، وربما دل على قدوم غائب",
    "wordCount": 12
  },
  {
    "slug": "dftr",
    "arabicSlug": "تفسير-حلم-دفتر",
    "name": "دفتر",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على تدبير عيش صاحب الرؤيا، وتدل رؤيته على الفوائد والأرزاق",
    "wordCount": 11
  },
  {
    "slug": "dfn",
    "arabicSlug": "تفسير-حلم-دفن",
    "name": "دفن",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ميت وقد دفن فانه يسافر سفرا بعيدا ولا يجد مالا، ومن رأى انه دفن في قبر من غير أن يموت فهو ظلم وقهر له",
    "wordCount": 27
  },
  {
    "slug": "dqyq",
    "arabicSlug": "تفسير-حلم-دقيق",
    "name": "دقيق",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرزق الحاضر، وعلى بيان الحق والراح بعد التعب",
    "wordCount": 10
  },
  {
    "slug": "dkan",
    "arabicSlug": "تفسير-حلم-دكان",
    "name": "دكان",
    "letter": "د",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "من رأى دكانا على باب الدار فهو صديق لامرأة صاحب الدار أو صاحب الرؤيا، ومن رأى انه جالس على دكان فأنه ينال عزا ورتبة",
    "wordCount": 24
  },
  {
    "slug": "dlal",
    "arabicSlug": "تفسير-حلم-دلال",
    "name": "دلال",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الخير أو الشر وربما تدل رؤيته على عاقد الأنكحة أو القواد",
    "wordCount": 14
  },
  {
    "slug": "dlfyn",
    "arabicSlug": "تفسير-حلم-دلفين",
    "name": "دلفين",
    "letter": "د",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "تدل رؤيته على المكايد والاحتفال، وربما دلت رؤيته على المطر",
    "wordCount": 10
  },
  {
    "slug": "dlw",
    "arabicSlug": "تفسير-حلم-دلو",
    "name": "دلو",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام رجل يستخرج أموالا بالمكر، فان سقى به بستانا فان يحصل على امرأة",
    "wordCount": 14
  },
  {
    "slug": "dm",
    "arabicSlug": "تفسير-حلم-دم",
    "name": "دم",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "blood",
    "text": "مال حرام، وان رأى دم عليه من حيث لا يعلم فيكذب عليه من حيث لا يشعر",
    "wordCount": 16
  },
  {
    "slug": "dmagh",
    "arabicSlug": "تفسير-حلم-دماغ",
    "name": "دماغ",
    "letter": "د",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأى إن دماغه كبيرة فهو عاقل ومن رأى إن لا دماغ له فهو جاهل",
    "wordCount": 15
  },
  {
    "slug": "dma",
    "arabicSlug": "تفسير-حلم-دمع",
    "name": "دمع",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الدمع البارد فرح، والدمع الحار هم وحزن، وربما يدل الدمع على الشوق والحنين، ومن ادمع فأنه يدخر مالا حلال لا يريد إظهاره",
    "wordCount": 22
  },
  {
    "slug": "dml",
    "arabicSlug": "تفسير-حلم-دمل",
    "name": "دمل",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الحصول على المال",
    "wordCount": 5
  },
  {
    "slug": "dnya",
    "arabicSlug": "تفسير-حلم-دنيا",
    "name": "دنيا",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يترك الدنيا فأنه يطلق امرأته، ورؤية الدنيا تدل على اللهو واللعب",
    "wordCount": 14
  },
  {
    "slug": "dhn",
    "arabicSlug": "تفسير-حلم-دهن",
    "name": "دهن",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته كلها هم وغم وأن كانت رائحته كريهة فهو ثناء قبيح، ومن رأى وجه مدهون فهو يصوم الدهر، والدهان لورم أو وجع فانه يدل على الإصلاح",
    "wordCount": 26
  },
  {
    "slug": "dwa",
    "arabicSlug": "تفسير-حلم-دواء",
    "name": "دواء",
    "letter": "د",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من تناول دواء كان دليلا على العلم والانتفاع بالعلم، وان لم يتناوله بعد عن الحق",
    "wordCount": 15
  },
  {
    "slug": "dwdh",
    "arabicSlug": "تفسير-حلم-دودة",
    "name": "دودة",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الدود في البطن هم الأولاد يأكلون من ماله، وخروج الدود من الجسد ذهاب هم",
    "wordCount": 14
  },
  {
    "slug": "dwlab",
    "arabicSlug": "تفسير-حلم-دولاب",
    "name": "دولاب",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام خازن المال، ويدل على السفر إذا كان يدور فان وقف وقفت المعيشة وبطل السفر",
    "wordCount": 16
  },
  {
    "slug": "dybaj",
    "arabicSlug": "تفسير-حلم-ديباج",
    "name": "ديباج",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يملكه فانه رجل متدين أو يتزوج امرأة شريفة",
    "wordCount": 11
  },
  {
    "slug": "dyr",
    "arabicSlug": "تفسير-حلم-دير",
    "name": "دير",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على زوال الهم والنكد والخلاص من الشدائد",
    "wordCount": 8
  },
  {
    "slug": "dyk",
    "arabicSlug": "تفسير-حلم-ديك",
    "name": "ديك",
    "letter": "د",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام رب الدار، ويدل على رجل أخلاقه رديئة، كما يدل على زيادة الحكمة والانتفاع في العلم",
    "wordCount": 18
  },
  {
    "slug": "dyn",
    "arabicSlug": "تفسير-حلم-دين",
    "name": "دين",
    "letter": "د",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه قضى دينا أو أدى حق فانه يصل رحما أو يطعم مسكينا",
    "wordCount": 14
  },
  {
    "slug": "dhyb",
    "arabicSlug": "تفسير-حلم-ذئب",
    "name": "ذئب",
    "letter": "ذ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "عدو ظلوم أو سارق، ومن رأى ذئبا فانه يتهم رجلا بريء",
    "wordCount": 11
  },
  {
    "slug": "dhbab",
    "arabicSlug": "تفسير-حلم-ذباب",
    "name": "ذباب",
    "letter": "ذ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رجل كبير السن، فأن أفاده أفاد رجل، وأن أكله نال رزقا دنيئا، وأن رأى الذباب في جوفه فأنه يخالط قوما سفهاء",
    "wordCount": 21
  },
  {
    "slug": "dhbh",
    "arabicSlug": "تفسير-حلم-ذبح",
    "name": "ذبح",
    "letter": "ذ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام عقوق وظلم ومن رأى أناس مذبوحين فذلك دليل خير على تمام الأمور",
    "wordCount": 14
  },
  {
    "slug": "dhraa-alyd",
    "arabicSlug": "تفسير-حلم-ذراع-اليد",
    "name": "ذراع اليد",
    "letter": "ذ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "إذا رأى ألنائم انه تألم بها فتدل على حزن وبطلان الأشياء التي تعمل باليد، ورؤية الشعر على الذراعين دين يلزمه، ومن رأى امرأة حاسرة الذراعين فهي الدنيا",
    "wordCount": 27
  },
  {
    "slug": "dhrh",
    "arabicSlug": "تفسير-حلم-ذرة",
    "name": "ذرة",
    "letter": "ذ",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دالة على المال وعدو دنيء، وضعيف المنفعة",
    "wordCount": 7
  },
  {
    "slug": "dhqn",
    "arabicSlug": "تفسير-حلم-ذقن",
    "name": "ذقن",
    "letter": "ذ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "رؤيته في المنام تدل على سيد العشيرة وصاحب نسل كثير، ومن رأى أن ذقنه طالت يتكلم بما لا يعنيه، ويضعف بعد قوة، والذقن تدل على ما يتجمل به الإنسان",
    "wordCount": 29
  },
  {
    "slug": "dhkr-allh",
    "arabicSlug": "تفسير-حلم-ذكر-الله",
    "name": "ذكر الله",
    "letter": "ذ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على النصر",
    "wordCount": 3
  },
  {
    "slug": "dhkr-alansan",
    "arabicSlug": "تفسير-حلم-ذكر-الإنسان",
    "name": "ذكر الإنسان",
    "letter": "ذ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام يدل على المال والولد والعمر، ومن رأى إن ذكره انقطع دليل على فقد الولد وانقطاع السفر أو العمر",
    "wordCount": 20
  },
  {
    "slug": "dhl",
    "arabicSlug": "تفسير-حلم-ذل",
    "name": "ذل",
    "letter": "ذ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ذليل فأنه يعز وينتصر، والذلة دالة على الفقر والنقص في الدين",
    "wordCount": 14
  },
  {
    "slug": "dhnb",
    "arabicSlug": "تفسير-حلم-ذنب",
    "name": "ذنب",
    "letter": "ذ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام دين، والإقرار بالذنب عز وشرف، وارتكاب الذنب ارتكاب الدين",
    "wordCount": 11
  },
  {
    "slug": "dhhb",
    "arabicSlug": "تفسير-حلم-ذهب",
    "name": "ذهب",
    "letter": "ذ",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": "gold",
    "text": "دليل على أمر مكروه، واكتساب الذهب ميراث يقع في يده . كما يدل الذهب على الأفراح والأرزاق",
    "wordCount": 17
  },
  {
    "slug": "ryh-2",
    "arabicSlug": "تفسير-حلم-رئة",
    "name": "رئة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من عفنت رئته فقد عمره، ومن رأى إن رئته اسودت دل على هدم باب ربحه",
    "wordCount": 15
  },
  {
    "slug": "ras",
    "arabicSlug": "تفسير-حلم-رأس",
    "name": "رأس",
    "letter": "ر",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "كبر الرأس دليل على زيادة الشرف، وصغر الرأس على نقصان الشرف، ومن رأى إن له رأسين فانه ينال ظفرا بالأعداء، وان كان فقيرا استغنى، وأن كان غنيا يكون له أولاد بررة، وان كان أعزب تزوج",
    "wordCount": 35
  },
  {
    "slug": "rahh",
    "arabicSlug": "تفسير-حلم-راحة",
    "name": "راحة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على لغنى بعد الفقر، والزوجة الصالحة بعد النكدة",
    "wordCount": 9
  },
  {
    "slug": "raay",
    "arabicSlug": "تفسير-حلم-راعي",
    "name": "راعي",
    "letter": "ر",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دال على صاحب ولاية، وتدل رؤية الراعي على علو القدر والتحكم بالرعية",
    "wordCount": 12
  },
  {
    "slug": "rahb",
    "arabicSlug": "تفسير-حلم-راهب",
    "name": "راهب",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه أصبح راهب فانه يكون له ثناء حسن لكن يعسر عليه شأنه",
    "wordCount": 14
  },
  {
    "slug": "rayh",
    "arabicSlug": "تفسير-حلم-راية",
    "name": "راية",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الهدايةة لأموره والخروج من الأحزان، والانفتاح، والراية في المنام تزويج، وللحامل ولد ذكر",
    "wordCount": 15
  },
  {
    "slug": "rban",
    "arabicSlug": "تفسير-حلم-ربان",
    "name": "ربان",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الأسفار البعيدة وعلى المال",
    "wordCount": 7
  },
  {
    "slug": "rbya",
    "arabicSlug": "تفسير-حلم-ربيع",
    "name": "ربيع",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على ولد لا يطول عمره، أو امرأة لا يدوم نكاحها أو ولاية لا تبقى",
    "wordCount": 15
  },
  {
    "slug": "rtbh",
    "arabicSlug": "تفسير-حلم-رتبة",
    "name": "رتبة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على زوجة أو معيشة أو عمل صالح يرفعه عند الله",
    "wordCount": 11
  },
  {
    "slug": "rjl",
    "arabicSlug": "تفسير-حلم-رجل",
    "name": "رجل",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا كان معروفا فهو ذلك الرجل بعينه أو شقيقه، ومن رأى إنسان فهو يرجو منه شيئا",
    "wordCount": 16
  },
  {
    "slug": "rjl-alansan",
    "arabicSlug": "تفسير-حلم-رجل-الإنسان",
    "name": "رجل الإنسان",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رأى فيهما حادث فتأويله في ماله، أو في ما يقوم به، ومن رأى انه يمشي حافيا فانه ينال تعب ونصب",
    "wordCount": 21
  },
  {
    "slug": "rjm",
    "arabicSlug": "تفسير-حلم-رجم",
    "name": "رجم",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الرجم دال على القذف في العرض إلا إن يكون حدا فانه يدل على طهارة المرجوم من الذنوب",
    "wordCount": 17
  },
  {
    "slug": "rjwa-mn-sfr",
    "arabicSlug": "تفسير-حلم-رجوع-من-سفر",
    "name": "رجوع من سفر",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الفرج من الهم، وربما دلت على التوبة من الذنوب",
    "wordCount": 11
  },
  {
    "slug": "rha",
    "arabicSlug": "تفسير-حلم-رحى",
    "name": "رحى",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الفرج بعد الضيق، وعلى الزوج للأعزب، وان رأى انه طحن فيها دل على تسهيل الأمور والشفاء من الأمراض",
    "wordCount": 20
  },
  {
    "slug": "rhmh",
    "arabicSlug": "تفسير-حلم-رحمة",
    "name": "رحمة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى رحيما يرحم ضعيفا فان دينه يقوى، فان رأى إن مرحوم فانه يغفر له، ومن رأى إن رحمة الله تنزل عليه فانه يرزق، فان رأى انه رحيم فرحان فانه يحفظ القران",
    "wordCount": 32
  },
  {
    "slug": "rkha",
    "arabicSlug": "تفسير-حلم-رخاء",
    "name": "رخاء",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الفرج بعد الشدة، ويدل على قضاء الدين وتفريج الهموم",
    "wordCount": 11
  },
  {
    "slug": "rkham",
    "arabicSlug": "تفسير-حلم-رخام",
    "name": "رخام",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يملك الرخام استغنى من بعد فقر أو تزوج، وربما نال علما أو أولادا",
    "wordCount": 16
  },
  {
    "slug": "rda",
    "arabicSlug": "تفسير-حلم-رداء",
    "name": "رداء",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على جاه الرجل عزه",
    "wordCount": 5
  },
  {
    "slug": "rsalh",
    "arabicSlug": "تفسير-حلم-رسالة",
    "name": "رسالة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا أتته رسالة فإنها دالة على المنصب الجليل والكلمة العالية",
    "wordCount": 10
  },
  {
    "slug": "rsam",
    "arabicSlug": "تفسير-حلم-رسام",
    "name": "رسام",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته في المنام على قبول الكلمة أو على صاحب الرأي",
    "wordCount": 11
  },
  {
    "slug": "rshash",
    "arabicSlug": "تفسير-حلم-رشاش",
    "name": "رشاش",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الأمطار، ويدل على صلاح الأحوال",
    "wordCount": 8
  },
  {
    "slug": "rsas",
    "arabicSlug": "تفسير-حلم-رصاص",
    "name": "رصاص",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على كسب حقير أصله من العبرة والشهوة، وربما دل على أن صاحبه مقداما",
    "wordCount": 14
  },
  {
    "slug": "rdaah",
    "arabicSlug": "تفسير-حلم-رضاعة",
    "name": "رضاعة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الاحتياج والانحباس والتلف وتغيير المزاج",
    "wordCount": 7
  },
  {
    "slug": "rtb",
    "arabicSlug": "تفسير-حلم-رطب",
    "name": "رطب",
    "letter": "ر",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "رزق حلال وشفاء وفرج",
    "wordCount": 4
  },
  {
    "slug": "raaf",
    "arabicSlug": "تفسير-حلم-رعاف",
    "name": "رعاف",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الهم والنكد",
    "wordCount": 4
  },
  {
    "slug": "rad",
    "arabicSlug": "تفسير-حلم-رعد",
    "name": "رعد",
    "letter": "ر",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "هو في المنام بلا مطر خوف، والرعد وعيد وتهديد، وربما يدل على صوت الطبول، كما يدل على قضاء الدين",
    "wordCount": 19
  },
  {
    "slug": "rashh",
    "arabicSlug": "تفسير-حلم-رعشة",
    "name": "رعشة",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن رأسه يرتعش نال عزا من رئيسه، أو غضب عليه، ومن رأى أن يده اليمنى ترتعش فأن معيشته قد تعسرت عليه، ومن رأى إن فخذه ترتعش فيدخل عليه خيرا، ومن رأى إن ساقيه ترتعش يدخل عليه عسر في ماله",
    "wordCount": 41
  },
  {
    "slug": "rf",
    "arabicSlug": "تفسير-حلم-رف",
    "name": "رف",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الحافظ للأسرار، والزوجة الجليلة",
    "wordCount": 6
  },
  {
    "slug": "rfs",
    "arabicSlug": "تفسير-حلم-رفس",
    "name": "رفس",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن رجلا رفسه برجله فانه يعيره بالفقر ويتكبر عليه بماله",
    "wordCount": 12
  },
  {
    "slug": "rqs",
    "arabicSlug": "تفسير-حلم-رقص",
    "name": "رقص",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "مصيبة، ومن رقص لغيره فانه يشاركه في المصيبة",
    "wordCount": 8
  },
  {
    "slug": "rqbh",
    "arabicSlug": "تفسير-حلم-رقبة",
    "name": "رقبة",
    "letter": "ر",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "تدل على العنق والملك",
    "wordCount": 4
  },
  {
    "slug": "rqyh",
    "arabicSlug": "تفسير-حلم-رقية",
    "name": "رقية",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الأمان من المصائب ودفع الهموم والأحزان",
    "wordCount": 8
  },
  {
    "slug": "rkbh",
    "arabicSlug": "تفسير-حلم-ركبة",
    "name": "ركبة",
    "letter": "ر",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "يدل على كد الرجل ونصيبه في معيشته ومطلبه",
    "wordCount": 8
  },
  {
    "slug": "rkwb",
    "arabicSlug": "تفسير-حلم-ركوب",
    "name": "ركوب",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "ركوب الدواب عز وسلطان",
    "wordCount": 4
  },
  {
    "slug": "rkwa",
    "arabicSlug": "تفسير-حلم-ركوع",
    "name": "ركوع",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على خدمة للبطال، وربما دل الركوع على طول العمر والانحناء، وإذا رأت المرأة أنها تركع ركوعا تاما دل على التوبة",
    "wordCount": 21
  },
  {
    "slug": "rmad",
    "arabicSlug": "تفسير-حلم-رماد",
    "name": "رماد",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الكلام الباطل أو علم لا ينتفع به، والرماد يدل على الحزن",
    "wordCount": 13
  },
  {
    "slug": "rmal",
    "arabicSlug": "تفسير-حلم-رمال",
    "name": "رمال",
    "letter": "ر",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الاحتيال والسرقة، كما يدل على الفوائد والأرباح",
    "wordCount": 10
  },
  {
    "slug": "rman",
    "arabicSlug": "تفسير-حلم-رمان",
    "name": "رمان",
    "letter": "ر",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "في المنام دال على مال مجموعا إذا كان حلوا، وربما دلت الرمانة على المرأة",
    "wordCount": 14
  },
  {
    "slug": "rmh",
    "arabicSlug": "تفسير-حلم-رمح",
    "name": "رمح",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المرء’ أو الولد أو شهادة حق أو سفر",
    "wordCount": 10
  },
  {
    "slug": "rmd",
    "arabicSlug": "تفسير-حلم-رمد",
    "name": "رمد",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على ضيق المعيشة، أو النقص في الدين",
    "wordCount": 8
  },
  {
    "slug": "rmy",
    "arabicSlug": "تفسير-حلم-رمي",
    "name": "رمي",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على القذف، ومن رأى أنه يرمي إلى غرض فلا يخطئ فانه ينال مراده",
    "wordCount": 14
  },
  {
    "slug": "rhn",
    "arabicSlug": "تفسير-حلم-رهن",
    "name": "رهن",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه رهينة فقد اكتسب على نفسه ذنوبا كثيرة، والرهن دال على الذل، والاطلاع على الفضائح",
    "wordCount": 19
  },
  {
    "slug": "rwd",
    "arabicSlug": "تفسير-حلم-روض",
    "name": "روض",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الرياض الخضراء دالة على الجنة",
    "wordCount": 5
  },
  {
    "slug": "ry",
    "arabicSlug": "تفسير-حلم-ري",
    "name": "ري",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على اليسر بعد العسر وقضاء الحاجة، والشفاء",
    "wordCount": 8
  },
  {
    "slug": "ryh-3",
    "arabicSlug": "تفسير-حلم-ريح",
    "name": "ريح",
    "letter": "ر",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دالة على العذاب والآفات عند هياجها، والرياح الطيبة إذا هبت من جهة معلومة فإنها دالة على الأخبار الطيبة والرحمة",
    "wordCount": 19
  },
  {
    "slug": "ryhan",
    "arabicSlug": "تفسير-حلم-ريحان",
    "name": "ريحان",
    "letter": "ر",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "تفريج عن الهموم أو أعمال صالحة، والريحان للعزب زوجة، وللزوجة ولد، أو علم يتصف به",
    "wordCount": 15
  },
  {
    "slug": "rysh",
    "arabicSlug": "تفسير-حلم-ريش",
    "name": "ريش",
    "letter": "ر",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المال وربما دل على الجاه، والريش كسوة",
    "wordCount": 9
  },
  {
    "slug": "zybq",
    "arabicSlug": "تفسير-حلم-زئبق",
    "name": "زئبق",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على أمر لا يتم",
    "wordCount": 5
  },
  {
    "slug": "zad",
    "arabicSlug": "تفسير-حلم-زاد",
    "name": "زاد",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دل على التقوى، وربما دل ذلك للفقير على الغنى، وعلى المدين لقضاء الدين",
    "wordCount": 13
  },
  {
    "slug": "zbal",
    "arabicSlug": "تفسير-حلم-زبال",
    "name": "زبال",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل محروم تدل رؤيته على تعب نفسه في راحة غيره",
    "wordCount": 10
  },
  {
    "slug": "zbalh",
    "arabicSlug": "تفسير-حلم-زبالة",
    "name": "زبالة",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل خير للفقراء",
    "wordCount": 3
  },
  {
    "slug": "zbd",
    "arabicSlug": "تفسير-حلم-زبد",
    "name": "زبد",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الخصوبة والكسب والفائدة",
    "wordCount": 5
  },
  {
    "slug": "zbdyh",
    "arabicSlug": "تفسير-حلم-زبدية",
    "name": "زبدية",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الزوجة أو معيشة، وبائع الزبادي تدل رؤيته على الرخاء والأمن",
    "wordCount": 12
  },
  {
    "slug": "zbyb",
    "arabicSlug": "تفسير-حلم-زبيب",
    "name": "زبيب",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرزق",
    "wordCount": 3
  },
  {
    "slug": "zjaj",
    "arabicSlug": "تفسير-حلم-زجاج",
    "name": "زجاج",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "قليله وكثيره هم، ومن رأى الزجاج وقد خفي عنه شيا بأن له . زحف : دال على الحزن والإخلاص في طلب العلم، وربما دل على الحج",
    "wordCount": 26
  },
  {
    "slug": "zr",
    "arabicSlug": "تفسير-حلم-زر",
    "name": "زر",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى زر وعروة فذلك يدل على الرجل والمرأة، فمن رأى انه يركب زر في عروة فأنه يتزوج وإلا فانه يولف أمرا تفرق",
    "wordCount": 23
  },
  {
    "slug": "zrafh",
    "arabicSlug": "تفسير-حلم-زرافة",
    "name": "زرافة",
    "letter": "ز",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دالة على المرأة الجميلة، أو الوقوف على الأخبار الغريبة",
    "wordCount": 9
  },
  {
    "slug": "zra",
    "arabicSlug": "تفسير-حلم-زرع",
    "name": "زرع",
    "letter": "ز",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "من رأى انه زرع فهو حمل لامرأته، ومن رأى انعه يزرع في ارض غيره فانه خلاف مع صاحب الأرض، ومن رأى انه يسعى في ارض خضراء فانه يسعى لأعمال الخير",
    "wordCount": 30
  },
  {
    "slug": "zrybh",
    "arabicSlug": "تفسير-حلم-زريبة",
    "name": "زريبة",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الأرزاق والفوائد والأرباح",
    "wordCount": 5
  },
  {
    "slug": "zafran",
    "arabicSlug": "تفسير-حلم-زعفران",
    "name": "زعفران",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الثناء والذكر الجميل، وأن اثر لونه في الجسد أو الثوب فانه مرض",
    "wordCount": 14
  },
  {
    "slug": "zqaq",
    "arabicSlug": "تفسير-حلم-زقاق",
    "name": "زقاق",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دخوله يدل على الوقوع في الشبهات، وربما دل على الحنث في اليمين",
    "wordCount": 12
  },
  {
    "slug": "zkah",
    "arabicSlug": "تفسير-حلم-زكاة",
    "name": "زكاة",
    "letter": "ز",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "دالة على زيادة المال، وإخراج الزكاة دالة على الخير",
    "wordCount": 9
  },
  {
    "slug": "zlabyh",
    "arabicSlug": "تفسير-حلم-زلابية",
    "name": "زلابية",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على مال بلهو وطرب، كما تدل على الأسف والندم",
    "wordCount": 10
  },
  {
    "slug": "zlzlh",
    "arabicSlug": "تفسير-حلم-زلزلة",
    "name": "زلزلة",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "خوف من سلطان، كما تدل على نقل أو تحويل",
    "wordCount": 9
  },
  {
    "slug": "zll",
    "arabicSlug": "تفسير-حلم-زلل",
    "name": "زلل",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "باللسان ربما دل على الزلل بالقدم والعكس، وربما دل على السهو والنسيان",
    "wordCount": 12
  },
  {
    "slug": "zmrd",
    "arabicSlug": "تفسير-حلم-زمرد",
    "name": "زمرد",
    "letter": "ز",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "دال على الشهادة، ومن رأى انه كسب زمردا فانه يكسب أخا صالحا أو علما أو مالا",
    "wordCount": 16
  },
  {
    "slug": "zmzm",
    "arabicSlug": "تفسير-حلم-زمزم",
    "name": "زمزم",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه شرب من ماء زمزم فهو دليل على الشفاء، أو يحصل على خير",
    "wordCount": 17
  },
  {
    "slug": "alzna",
    "arabicSlug": "تفسير-حلم-الزنا",
    "name": "الزنا",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يزني فقد خان، والمرأة الزانية المجهولة خير، ومن رأى زانية تراوده عن نفسها نال مالا حراما",
    "wordCount": 19
  },
  {
    "slug": "znbyl",
    "arabicSlug": "تفسير-حلم-زنبيل",
    "name": "زنبيل",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على صاحب البيت الساعي على أهل بيته، وربما دل على الزوجة أو الخادم",
    "wordCount": 14
  },
  {
    "slug": "zhd",
    "arabicSlug": "تفسير-حلم-زهد",
    "name": "زهد",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على التحبب إلى الناس",
    "wordCount": 5
  },
  {
    "slug": "zhrh",
    "arabicSlug": "تفسير-حلم-زهرة",
    "name": "زهرة",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رآها خطب امرأة جميلة، والزهرة في المنام دالة على التهم واللهو واللعب",
    "wordCount": 13
  },
  {
    "slug": "zwaj",
    "arabicSlug": "تفسير-حلم-زواج",
    "name": "زواج",
    "letter": "ز",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": "marriage",
    "text": "يدل على العناية من الله، وربما دل على الأسر والدين، أو السعي للمناصب الجليلة",
    "wordCount": 14
  },
  {
    "slug": "zyt",
    "arabicSlug": "تفسير-حلم-زيت",
    "name": "زيت",
    "letter": "ز",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دال على رزق ومال حلال وشفاء لمن دهن به، ومن رأى أنه يشرب الزيت فذلك يدل على السحر والمرض",
    "wordCount": 19
  },
  {
    "slug": "zytwn",
    "arabicSlug": "تفسير-حلم-زيتون",
    "name": "زيتون",
    "letter": "ز",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دال على المال والمتاع، ومن عصر زيتون نال بركة وخير",
    "wordCount": 10
  },
  {
    "slug": "zyr-alma",
    "arabicSlug": "تفسير-حلم-زير-الماء",
    "name": "زير الماء",
    "letter": "ز",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "يدل على الزوج أو الزوجة",
    "wordCount": 5
  },
  {
    "slug": "zynh",
    "arabicSlug": "تفسير-حلم-زينة",
    "name": "زينة",
    "letter": "ز",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الفقر وفساد الحال، والزينة في البلاد التي لا تعرف فيها الزينة واللباس الذي اعتاد لبسه الإنسان هو خير لجميع الناس",
    "wordCount": 22
  },
  {
    "slug": "swal",
    "arabicSlug": "تفسير-حلم-سؤال",
    "name": "سؤال",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على اقتفاء الآثار والتثبت في الأمور",
    "wordCount": 7
  },
  {
    "slug": "sayh-fy-alard",
    "arabicSlug": "تفسير-حلم-سائح-في-الأرض",
    "name": "سائح في الأرض",
    "letter": "س",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "رجل طالب للعلم",
    "wordCount": 3
  },
  {
    "slug": "says",
    "arabicSlug": "تفسير-حلم-سائس",
    "name": "سائس",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته تدل على رجل صاحب مال وتدبير، والسائس لا خير فيه",
    "wordCount": 11
  },
  {
    "slug": "sayl",
    "arabicSlug": "تفسير-حلم-سائل",
    "name": "سائل",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل طالب علم فان أعطي ما سأل نال ذلك العلم، والسائل يدل على حزن وفكر",
    "wordCount": 15
  },
  {
    "slug": "sahr",
    "arabicSlug": "تفسير-حلم-ساحر",
    "name": "ساحر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل فتان، فان سحر بتفاحة فانه يفتن ابنه، وان سحر بفراشة فانه يفتن امرأته",
    "wordCount": 14
  },
  {
    "slug": "sarq",
    "arabicSlug": "تفسير-حلم-سارق",
    "name": "سارق",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على إنسان كذاب",
    "wordCount": 4
  },
  {
    "slug": "satwr",
    "arabicSlug": "تفسير-حلم-ساطور",
    "name": "ساطور",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل قوي شجاع لديه القدرة على التفرقة بين الأمور سهلها وصعبها",
    "wordCount": 11
  },
  {
    "slug": "saah-alzman",
    "arabicSlug": "تفسير-حلم-ساعة-الزمان",
    "name": "ساعة الزمان",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى ساعة زمنية نال المال",
    "wordCount": 6
  },
  {
    "slug": "saay",
    "arabicSlug": "تفسير-حلم-ساعي",
    "name": "ساعي",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على صاحب الأخبار وربما دل على الساعي للخير",
    "wordCount": 9
  },
  {
    "slug": "saq",
    "arabicSlug": "تفسير-حلم-ساق",
    "name": "ساق",
    "letter": "س",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأى إن ساقه من حديد فيطول عمره، ومن رآها من قوارير اقترب اجله",
    "wordCount": 14
  },
  {
    "slug": "saqyh",
    "arabicSlug": "تفسير-حلم-ساقية",
    "name": "ساقية",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على مجرى الرزق، ومن رأى انه يسقى من ساقية فانه يحصل على خيرا",
    "wordCount": 14
  },
  {
    "slug": "sb",
    "arabicSlug": "تفسير-حلم-سب",
    "name": "سب",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام القتل، وسب الناس دال على رمي الكلام",
    "wordCount": 10
  },
  {
    "slug": "sbahh",
    "arabicSlug": "تفسير-حلم-سباحة",
    "name": "سباحة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على بلوغ الحاجة، كما يدل على الحبس",
    "wordCount": 8
  },
  {
    "slug": "sbhh",
    "arabicSlug": "تفسير-حلم-سبحة",
    "name": "سبحة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على امرأة صالحة، أو معيشة حلال، أو جنود نافعة لملكها",
    "wordCount": 11
  },
  {
    "slug": "str",
    "arabicSlug": "تفسير-حلم-ستر",
    "name": "ستر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الرفيق كاتم الأسرار، والزوجة التي تصون زوجها",
    "wordCount": 9
  },
  {
    "slug": "sjadh",
    "arabicSlug": "تفسير-حلم-سجادة",
    "name": "سجادة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة عفيفة، كما تدل على منصب ديني",
    "wordCount": 7
  },
  {
    "slug": "sjn",
    "arabicSlug": "تفسير-حلم-سجن",
    "name": "سجن",
    "letter": "س",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "من رأى انه خرج من سجن نجا من المرض، ومن رأى انه مسجون دال على العمر الطويل والاجتماع مع الأحبة",
    "wordCount": 20
  },
  {
    "slug": "sjwd",
    "arabicSlug": "تفسير-حلم-سجود",
    "name": "سجود",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه سجد لله ظفر في حياته، ومن رأى انه سجد لغير الله فأنه يذل ويخذل، وان كان في نزاع فانه يخسر",
    "wordCount": 23
  },
  {
    "slug": "sjwd-alshkr",
    "arabicSlug": "تفسير-حلم-سجود-الشكر",
    "name": "سجود الشكر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على رفع البلاء، وتجديد الأرزاق",
    "wordCount": 6
  },
  {
    "slug": "shab-2",
    "arabicSlug": "تفسير-حلم-سحاب",
    "name": "سحاب",
    "letter": "س",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دال على العلم والفقه، والحكمة والبيان، وربما دل على الحامل أو المطر، ورؤيته في وقته خيرا وبركة",
    "wordCount": 17
  },
  {
    "slug": "shr-2",
    "arabicSlug": "تفسير-حلم-سحر",
    "name": "سحر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الفتنة والغرور، ويدل على الفراق",
    "wordCount": 7
  },
  {
    "slug": "shwr",
    "arabicSlug": "تفسير-حلم-سحور",
    "name": "سحور",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على مكابدة الأعداء وعلى التوبة للعاصي",
    "wordCount": 7
  },
  {
    "slug": "skhryh",
    "arabicSlug": "تفسير-حلم-سخرية",
    "name": "سخرية",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الغبن",
    "wordCount": 3
  },
  {
    "slug": "sdr-2",
    "arabicSlug": "تفسير-حلم-سدر",
    "name": "سدر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة كريمة مستورة، ورجل فاضل كريم، ومن أكل السدر مرض مرضا شديدا",
    "wordCount": 12
  },
  {
    "slug": "sr",
    "arabicSlug": "تفسير-حلم-سر",
    "name": "سر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على النكاح، ومن رأى انه أودع امرأة سرا فانه يقصد نكاحها",
    "wordCount": 12
  },
  {
    "slug": "srawyl",
    "arabicSlug": "تفسير-حلم-سراويل",
    "name": "سراويل",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ملك سروال جديدا دليل على الزواج، ومن رأى إن سراويله محلولة فأن امرأته لا تستحي منة الرجال، ومن رأى سرواله مبلولا فأن امرأته حبلى",
    "wordCount": 27
  },
  {
    "slug": "srtan",
    "arabicSlug": "تفسير-حلم-سرطان",
    "name": "سرطان",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل كثير الكيد، ومن أكل لحم السرطان نال خيرا من أرض بعيدة",
    "wordCount": 12
  },
  {
    "slug": "srwr",
    "arabicSlug": "تفسير-حلم-سرور",
    "name": "سرور",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على البكاء وربما دل على الفرح كما رآه، ومن رأى اصدقائه في سرور فانه يدل على أمر لذيذ",
    "wordCount": 19
  },
  {
    "slug": "sryr",
    "arabicSlug": "تفسير-حلم-سرير",
    "name": "سرير",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الزوجة، وان رأته امرأة لا زوج لها فإنها تتزوج",
    "wordCount": 11
  },
  {
    "slug": "sth",
    "arabicSlug": "تفسير-حلم-سطح",
    "name": "سطح",
    "letter": "س",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة رفيعة القدر أو رجل رفيع القدر والجلوس على السطح دال على الراحة والكسوة وزوال الهموم",
    "wordCount": 19
  },
  {
    "slug": "saal",
    "arabicSlug": "تفسير-حلم-سعال",
    "name": "سعال",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الشكوى",
    "wordCount": 3
  },
  {
    "slug": "safh",
    "arabicSlug": "تفسير-حلم-سعفة",
    "name": "سعفة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الطهارة",
    "wordCount": 3
  },
  {
    "slug": "sf",
    "arabicSlug": "تفسير-حلم-سف",
    "name": "سف",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الرمل والتراب يدل على الفاقة والطمع",
    "wordCount": 6
  },
  {
    "slug": "sfr",
    "arabicSlug": "تفسير-حلم-سفر",
    "name": "سفر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "travel",
    "text": "دليل على الكشف عن أخلاق الناس، زان كان الفقير مسافر استغنى",
    "wordCount": 11
  },
  {
    "slug": "sfrh",
    "arabicSlug": "تفسير-حلم-سفرة",
    "name": "سفرة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على السعة وراحة لمن وجدها",
    "wordCount": 6
  },
  {
    "slug": "sfrjl",
    "arabicSlug": "تفسير-حلم-سفرجل",
    "name": "سفرجل",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام مرض، ومن رأى انه يأكلها وكان مريضا شفي، وان كان تاجر ربح",
    "wordCount": 14
  },
  {
    "slug": "sfynh",
    "arabicSlug": "تفسير-حلم-سفينة",
    "name": "سفينة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على النجاة لمن كان في هم، أو مرض أو ضيق، فان ركبها مع قوم صالحين فانه يتبع الهدى، وان ركبها مع أصدقائه فانه ينال عزا وبركة",
    "wordCount": 27
  },
  {
    "slug": "sqf",
    "arabicSlug": "تفسير-حلم-سقف",
    "name": "سقف",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل رفيع القدر، وان كان من خشب فهو رجل مغرور، وان رأى سقف ينزل عليه ناله خوفا من رجل رفيع القدر، وان نزل عليه تراب من السقف نال مالا",
    "wordCount": 29
  },
  {
    "slug": "sqwt",
    "arabicSlug": "تفسير-حلم-سقوط",
    "name": "سقوط",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "teeth-falling",
    "text": "الأسنان من الإنسان طول عمر وأن رأى جميع أسنانه سقطت وذهب بصره فان أهل بيته يموتون قبله",
    "wordCount": 17
  },
  {
    "slug": "skr",
    "arabicSlug": "تفسير-حلم-سكر",
    "name": "سكر",
    "letter": "س",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "يدل على الأفراح والشفاء من الأمراض، وزوال الهم",
    "wordCount": 8
  },
  {
    "slug": "skyn",
    "arabicSlug": "تفسير-حلم-سكين",
    "name": "سكين",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى بيده سكين وكان في محاكمة فانه ينتصر، ومن رأى انه أعطي سكينا ينال رزق",
    "wordCount": 16
  },
  {
    "slug": "slah-2",
    "arabicSlug": "تفسير-حلم-سلاح",
    "name": "سلاح",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على النصر وتفوق ودفع للأمراض",
    "wordCount": 6
  },
  {
    "slug": "slal",
    "arabicSlug": "تفسير-حلم-سلال",
    "name": "سلال",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على النساج أو البناء وما شابه",
    "wordCount": 7
  },
  {
    "slug": "slh-2",
    "arabicSlug": "تفسير-حلم-سلة",
    "name": "سلة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رآها فهو رزق والسلال تدل على التبشير والنذير فإذا كان فيها ما يستحب فهو خير وإذا كان فيها ما يكره فهو النذير",
    "wordCount": 23
  },
  {
    "slug": "slhfah",
    "arabicSlug": "تفسير-حلم-سلحفاة",
    "name": "سلحفاة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المرأة التي تعرض نفسها، وقيل هي الرجل العالم، وربما تدل على المكر والخديعة والاختفاء",
    "wordCount": 16
  },
  {
    "slug": "slsh",
    "arabicSlug": "تفسير-حلم-سلسة",
    "name": "سلسة",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على المعصية إن رآها بيده أو عنقه، كما تدل على تعقد الأمور",
    "wordCount": 13
  },
  {
    "slug": "sltan",
    "arabicSlug": "تفسير-حلم-سلطان",
    "name": "سلطان",
    "letter": "س",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "رؤيته دالة على رضا الله عز وجل على العبد، فمن رآه عابسا من غير سبب فأن صاحب الرؤيا محدث في صلاته أو في طاعته",
    "wordCount": 24
  },
  {
    "slug": "slah-3",
    "arabicSlug": "تفسير-حلم-سلعة",
    "name": "سلعة",
    "letter": "س",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "من رأى في جسده سلعة أصاب مالا",
    "wordCount": 7
  },
  {
    "slug": "slm-alsawd",
    "arabicSlug": "تفسير-حلم-سلم-الصعود",
    "name": "سلم الصعود",
    "letter": "س",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "إذا كان من الخشب فهو تعب ونكد، وأن رآه قائما شفي من المرض، كما يدل على السفر",
    "wordCount": 17
  },
  {
    "slug": "sm",
    "arabicSlug": "تفسير-حلم-سم",
    "name": "سم",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال، والسموم القاتلة في الرؤيا دليل الموت، ومن رأى أنه يسقي غيره فأنه يزني بامرأته، ومن رأى أنه يشربه فان حياته تطول",
    "wordCount": 25
  },
  {
    "slug": "sma",
    "arabicSlug": "تفسير-حلم-سماء",
    "name": "سماء",
    "letter": "س",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "تدل في المنام على نفسها فما نزل منها أو جاء من ناحيتها جاء نظيره من عند الله",
    "wordCount": 17
  },
  {
    "slug": "smsm",
    "arabicSlug": "تفسير-حلم-سمسم",
    "name": "سمسم",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رزق ومال حلال، ومن رأى انه يزرع السمسم فان رزقه ينمى",
    "wordCount": 11
  },
  {
    "slug": "smk",
    "arabicSlug": "تفسير-حلم-سمك",
    "name": "سمك",
    "letter": "س",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "fish",
    "text": "إذا عرف عدده فهو نساء، وان لم يعرف عدده فهو مال، ومن رأى انه يصطاد فأن ذلك يدل على منفعة وخير",
    "wordCount": 21
  },
  {
    "slug": "smn",
    "arabicSlug": "تفسير-حلم-سمن",
    "name": "سمن",
    "letter": "س",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "يدل على علم نافع، ومن أكله دل على الرخاء لمن هو في شدة",
    "wordCount": 13
  },
  {
    "slug": "sn",
    "arabicSlug": "تفسير-حلم-سن",
    "name": "سن",
    "letter": "س",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": "teeth-falling",
    "text": "الأسنان تدل على الأهل والأقرباء، وربما دلت على الأملاك أو الأسرار",
    "wordCount": 11
  },
  {
    "slug": "snbl",
    "arabicSlug": "تفسير-حلم-سنبل",
    "name": "سنبل",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على مال مجموع يتضاعف، والسنبلة اليابسة جدب وقحط",
    "wordCount": 10
  },
  {
    "slug": "snh",
    "arabicSlug": "تفسير-حلم-سنة",
    "name": "سنة",
    "letter": "س",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "ربما دلت رؤيتها على عام كله شدة وقحط",
    "wordCount": 8
  },
  {
    "slug": "sndyan",
    "arabicSlug": "تفسير-حلم-سنديان",
    "name": "سنديان",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على مال رابح وعز ثابت، وربما دل على معاشرة أهل الغفلة",
    "wordCount": 12
  },
  {
    "slug": "shr-3",
    "arabicSlug": "تفسير-حلم-سهر",
    "name": "سهر",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على فقد الأحبة وفراقهم",
    "wordCount": 5
  },
  {
    "slug": "shm-alqws",
    "arabicSlug": "تفسير-حلم-سهم-القوس",
    "name": "سهم القوس",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرسول والمكاتبة، وعلى القوة والنصر . سوار : من رأى في يده سوارا من الرجال فهو ضيق، فأن كانت أسورة من ذهب أو فضة فهو رجل يسعى للخير، وأن كان له أعداء فان الله يعينه",
    "wordCount": 37
  },
  {
    "slug": "swak",
    "arabicSlug": "تفسير-حلم-سواك",
    "name": "سواك",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يستعمل السواك فأنه يقيم سنة من سنن الرسول، ويكون محسنا لأقاربه، ومن رأى انه يتسوك والدم يخرج من أسنانه خرج من ذنوبه",
    "wordCount": 25
  },
  {
    "slug": "swr",
    "arabicSlug": "تفسير-حلم-سور",
    "name": "سور",
    "letter": "س",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "يدل على الشرع الفاصل بين الحق والباطل، وربما دل على السرور ومن رأى انه يبني سورا فهو أمن من أعدائه",
    "wordCount": 20
  },
  {
    "slug": "sws",
    "arabicSlug": "تفسير-حلم-سوس",
    "name": "سوس",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل نمام يسعى برجال أغنياء لكي يقطع المنفعة عنهم، كما يدل على المرض، والسوس عدو من الأهل",
    "wordCount": 17
  },
  {
    "slug": "swq",
    "arabicSlug": "تفسير-حلم-سوق",
    "name": "سوق",
    "letter": "س",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "دال على المسجد، وقد يدل على الحرب",
    "wordCount": 7
  },
  {
    "slug": "syaj",
    "arabicSlug": "تفسير-حلم-سياج",
    "name": "سياج",
    "letter": "س",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الدين، كما يدل على الحصن",
    "wordCount": 7
  },
  {
    "slug": "syf",
    "arabicSlug": "تفسير-حلم-سيف",
    "name": "سيف",
    "letter": "س",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "من رأى أنه تقلد سيفا فقد تقلد ولاية كبيرة، ومن رأى انه ناول امرأته نصلا أو ناولته نصلا فأنه ولد ذكر، وقد يدل على الفتنة .سيل : هو في المنام هجوم العدو، ومن رأى سيلا من مطر فأنه يصيبه أذى أو مرض",
    "wordCount": 42
  },
  {
    "slug": "shab-3",
    "arabicSlug": "تفسير-حلم-شاب",
    "name": "شاب",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تل رؤيته على الحركة والقوة",
    "wordCount": 5
  },
  {
    "slug": "shabh",
    "arabicSlug": "تفسير-حلم-شابة",
    "name": "شابة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية الشابة الجميلة دالة على خبر سار",
    "wordCount": 7
  },
  {
    "slug": "shah-alghnm",
    "arabicSlug": "تفسير-حلم-شاة-الغنم",
    "name": "شاة الغنم",
    "letter": "ش",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى انه حصل على شاة دليل على حصوله على امرأة",
    "wordCount": 11
  },
  {
    "slug": "sharb",
    "arabicSlug": "تفسير-حلم-شارب",
    "name": "شارب",
    "letter": "ش",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأي انه يقص شاربه فان ذلك دليل محافظته على السنة",
    "wordCount": 11
  },
  {
    "slug": "shbt",
    "arabicSlug": "تفسير-حلم-شبت",
    "name": "شبت",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى بيده الشبت فانه يقع له أمر يرى في المستقبل",
    "wordCount": 11
  },
  {
    "slug": "shba",
    "arabicSlug": "تفسير-حلم-شبع",
    "name": "شبع",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه شبعان فان ذلك تغيير أمره وسقوطه عن حال في دنياه أو موته إلا أن يرى في فمه سعة فيكون مرزوقا",
    "wordCount": 23
  },
  {
    "slug": "shbkh",
    "arabicSlug": "تفسير-حلم-شبكة",
    "name": "شبكة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام مكر وخديعة",
    "wordCount": 5
  },
  {
    "slug": "shtm",
    "arabicSlug": "تفسير-حلم-شتم",
    "name": "شتم",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ذلة للمشتوم وعز للشاتم",
    "wordCount": 7
  },
  {
    "slug": "shjrh",
    "arabicSlug": "تفسير-حلم-شجرة",
    "name": "شجرة",
    "letter": "ش",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "الأشجار تدل على النساء والرجال المختلفين في الأخلاق، كما تدل على المشاجرة والأشجار المجهولة دالة على الهموم",
    "wordCount": 17
  },
  {
    "slug": "shh-2",
    "arabicSlug": "تفسير-حلم-شح",
    "name": "شح",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الوقوع في المحذور",
    "wordCount": 5
  },
  {
    "slug": "shhm",
    "arabicSlug": "تفسير-حلم-شحم",
    "name": "شحم",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "ما يؤكل لحمه في المنام رزق مستمر وكسوة، وشحم ما لا يؤكل لحمه يدل على المال الحرام والزنا أو الردة عن الدين",
    "wordCount": 22
  },
  {
    "slug": "shrab",
    "arabicSlug": "تفسير-حلم-شراب",
    "name": "شراب",
    "letter": "ش",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دليل على الهداية والعلم، ومن شرب ماء بارد حصل على المال الحلال",
    "wordCount": 12
  },
  {
    "slug": "shraa",
    "arabicSlug": "تفسير-حلم-شراع",
    "name": "شراع",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يملك شراعا فيحصل على العز والرفعة",
    "wordCount": 9
  },
  {
    "slug": "shrr",
    "arabicSlug": "تفسير-حلم-شرر",
    "name": "شرر",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام كلام قبيح، ومن رأى الشرر كثر عليه فانه يصيبه العذاب",
    "wordCount": 13
  },
  {
    "slug": "shrty",
    "arabicSlug": "تفسير-حلم-شرطي",
    "name": "شرطي",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الهول والهم",
    "wordCount": 4
  },
  {
    "slug": "shrkh",
    "arabicSlug": "تفسير-حلم-شركة",
    "name": "شركة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على غنى الفقير إذا شارك في المنام من هو أرفع منه قدرا",
    "wordCount": 13
  },
  {
    "slug": "shtrnj",
    "arabicSlug": "تفسير-حلم-شطرنج",
    "name": "شطرنج",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على معاشرة خليط من الناس، ومن رأى انه يلعب الشطرنج فان له عدوا دنيا",
    "wordCount": 15
  },
  {
    "slug": "shar",
    "arabicSlug": "تفسير-حلم-شعر",
    "name": "شعر",
    "letter": "ش",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": "hair",
    "text": "من رأى انه يقول الشعر فانه يشهد الزور",
    "wordCount": 8
  },
  {
    "slug": "shawdhh",
    "arabicSlug": "تفسير-حلم-شعوذة",
    "name": "شعوذة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "غرور وافتعال وفتنة",
    "wordCount": 3
  },
  {
    "slug": "shayr",
    "arabicSlug": "تفسير-حلم-شعير",
    "name": "شعير",
    "letter": "ش",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "هو في المنام رزق طيب عاجل قليل التعب، ومن رأى أنه يأخذ شعيرا فانه يرزق ولدا عالما",
    "wordCount": 17
  },
  {
    "slug": "shghl",
    "arabicSlug": "تفسير-حلم-شغل",
    "name": "شغل",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه مشغول فانه يتزوج ببكر وان كان ينتقل إلى شغل جديد فهو دال على تجديد الرزق",
    "wordCount": 18
  },
  {
    "slug": "shfaah",
    "arabicSlug": "تفسير-حلم-شفاعة",
    "name": "شفاعة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على العز والجاه، وربما دلت على الأجر من غير مذلة",
    "wordCount": 11
  },
  {
    "slug": "shfh",
    "arabicSlug": "تفسير-حلم-شفة",
    "name": "شفة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام عون الرجل الذي يتباهى به وقوته في البيان",
    "wordCount": 11
  },
  {
    "slug": "shfrh",
    "arabicSlug": "تفسير-حلم-شفرة",
    "name": "شفرة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المرأة الخدومة، كما تدل على الرزق والمعيشة شفق : تدل رؤيته على اليمين، وربما دل على ظهور الحركة",
    "wordCount": 20
  },
  {
    "slug": "shq-alqmash",
    "arabicSlug": "تفسير-حلم-شق-القماش",
    "name": "شق القماش",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام يدل على الطلاق",
    "wordCount": 5
  },
  {
    "slug": "shkr",
    "arabicSlug": "تفسير-حلم-شكر",
    "name": "شكر",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "شكر الله في المنام نجاة من الهم",
    "wordCount": 7
  },
  {
    "slug": "shll",
    "arabicSlug": "تفسير-حلم-شلل",
    "name": "شلل",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن يديه قد شلتا فانه يذنب ذنبا عظيما",
    "wordCount": 10
  },
  {
    "slug": "shm",
    "arabicSlug": "تفسير-حلم-شم",
    "name": "شم",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من شم في المنام رائحة طيبة ناله مرض يسير، ومن شم رائحة كريهة فهو كلام رديء",
    "wordCount": 16
  },
  {
    "slug": "shms",
    "arabicSlug": "تفسير-حلم-شمس",
    "name": "شمس",
    "letter": "ش",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دالة على ملك أو الأب",
    "wordCount": 5
  },
  {
    "slug": "shmah",
    "arabicSlug": "تفسير-حلم-شمعة",
    "name": "شمعة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "أمل وتدل للعازب على الزوجة، وهداية للجاهل",
    "wordCount": 7
  },
  {
    "slug": "shnq",
    "arabicSlug": "تفسير-حلم-شنق",
    "name": "شنق",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام شماتة وشهرة، وربما دل على التهمة والقذف",
    "wordCount": 10
  },
  {
    "slug": "shhd",
    "arabicSlug": "تفسير-حلم-شهد",
    "name": "شهد",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على ميراث جلال أو مال من شركة",
    "wordCount": 8
  },
  {
    "slug": "shhwh",
    "arabicSlug": "تفسير-حلم-شهوة",
    "name": "شهوة",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام دالة لمن ظفر بها على أفعال أهل النار",
    "wordCount": 11
  },
  {
    "slug": "shwa",
    "arabicSlug": "تفسير-حلم-شواء",
    "name": "شواء",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على البشارة في معيشته",
    "wordCount": 5
  },
  {
    "slug": "shwk",
    "arabicSlug": "تفسير-حلم-شوك",
    "name": "شوك",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل خشن صعب، ومن نال شوك نالته فتنة، ومن رأى انه يمشي فوق الشوك فانه يماطل",
    "wordCount": 18
  },
  {
    "slug": "shykh",
    "arabicSlug": "تفسير-حلم-شيخ",
    "name": "شيخ",
    "letter": "ش",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "إن رأى شاب انه تحول شيخا فانه ينال علما وأدبا، والشيخ الصالح يدل على العز والشرف والبركة",
    "wordCount": 17
  },
  {
    "slug": "shyb",
    "arabicSlug": "تفسير-حلم-شيب",
    "name": "شيب",
    "letter": "ش",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الوقار وطول العمر، كما يدل على الضعف والفقر شيطان : هو في المنام عدو في الدين والدنيا مكار مخادع",
    "wordCount": 21
  },
  {
    "slug": "saygh",
    "arabicSlug": "تفسير-حلم-صائغ",
    "name": "صائغ",
    "letter": "ص",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الكذب والغش، وربما دلت رؤيته على تلفيق الكلام",
    "wordCount": 11
  },
  {
    "slug": "sabwn",
    "arabicSlug": "تفسير-حلم-صابون",
    "name": "صابون",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل يسلي الهموم، ومن غسل ثوب بالصابون فانه يشفى",
    "wordCount": 11
  },
  {
    "slug": "sbagh",
    "arabicSlug": "تفسير-حلم-صباغ",
    "name": "صباغ",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام صاحب بهتان، وربما يجري على يده الخير",
    "wordCount": 10
  },
  {
    "slug": "sbh",
    "arabicSlug": "تفسير-حلم-صبح",
    "name": "صبح",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام انجاز الوعد، ومن رأى الصبح وحاله سيء دل على معصيته",
    "wordCount": 13
  },
  {
    "slug": "sbr",
    "arabicSlug": "تفسير-حلم-صبر",
    "name": "صبر",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رفعة وبشارة، وربما دل على حسن العاقبة",
    "wordCount": 7
  },
  {
    "slug": "sby",
    "arabicSlug": "تفسير-حلم-صبي",
    "name": "صبي",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الهم والضعف، والصبي المراهق بشرى للإنسان",
    "wordCount": 8
  },
  {
    "slug": "shh-3",
    "arabicSlug": "تفسير-حلم-صحة",
    "name": "صحة",
    "letter": "ص",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دالة على النعمة، والشفاء للمريض",
    "wordCount": 5
  },
  {
    "slug": "shf",
    "arabicSlug": "تفسير-حلم-صحف",
    "name": "صحف",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام شهود أو أئمة يهتدى بهم",
    "wordCount": 8
  },
  {
    "slug": "shyfh",
    "arabicSlug": "تفسير-حلم-صحيفة",
    "name": "صحيفة",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "بشارة لمن يمتلكها، فمن رأى امرأة تناوله الصحيفة فانه يتوقع أمرا فيه فرج، ومن رأى انه يتناول الصحيفة بيده اليسرى فأنه يندم على فعل فعله",
    "wordCount": 25
  },
  {
    "slug": "skhr",
    "arabicSlug": "تفسير-حلم-صخر",
    "name": "صخر",
    "letter": "ص",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دال على النساء الصابرات، كما يدل على الحزم وطول العمر، وربما دلت رؤياه على النسيان",
    "wordCount": 15
  },
  {
    "slug": "sda",
    "arabicSlug": "تفسير-حلم-صدى",
    "name": "صدى",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرجل المرائي",
    "wordCount": 4
  },
  {
    "slug": "sdaa",
    "arabicSlug": "تفسير-حلم-صداع",
    "name": "صداع",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن به صداع دل على الذنب الذي توجب التوبة منه",
    "wordCount": 12
  },
  {
    "slug": "sdqh",
    "arabicSlug": "تفسير-حلم-صدقة",
    "name": "صدقة",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل في المنام على دفع البلاء وعافية المريض والخير",
    "wordCount": 9
  },
  {
    "slug": "sdr-3",
    "arabicSlug": "تفسير-حلم-صدر",
    "name": "صدر",
    "letter": "ص",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "اتساعه في المنام دليل على الانشراح، وهو توبة، ومن رأى محبوبه في صدره دل على شكايته به",
    "wordCount": 17
  },
  {
    "slug": "sdgh",
    "arabicSlug": "تفسير-حلم-صدغ",
    "name": "صدغ",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على لبنان شريفان فمن رأى يهما حدثا من خير أو شر فهو حادث في الابنين",
    "wordCount": 16
  },
  {
    "slug": "sdf",
    "arabicSlug": "تفسير-حلم-صدف",
    "name": "صدف",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الصدفة في المنام تدل على لسقوط للحامل",
    "wordCount": 7
  },
  {
    "slug": "sdq",
    "arabicSlug": "تفسير-حلم-صدق",
    "name": "صدق",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الإيمان والصدق، والصدق في المنام نجاة من المكايد",
    "wordCount": 10
  },
  {
    "slug": "sdmh",
    "arabicSlug": "تفسير-حلم-صدمة",
    "name": "صدمة",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من صدمه في المنام ما أبكاه دل على فراقه ولدا أو مالا",
    "wordCount": 12
  },
  {
    "slug": "srat",
    "arabicSlug": "تفسير-حلم-صراط",
    "name": "صراط",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل المشي عليه في المنام على السفر في البحر، فان زال أو انقطع به خسر وهلك",
    "wordCount": 16
  },
  {
    "slug": "sraa",
    "arabicSlug": "تفسير-حلم-صراع",
    "name": "صراع",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنسانا صرعه فانه يتلف ماله",
    "wordCount": 9
  },
  {
    "slug": "srh",
    "arabicSlug": "تفسير-حلم-صرة",
    "name": "صرة",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام سر فمن رأى أنه استودع رجلا صرة أو كيس فيه مال فانه يستودعه سرا فان فتح الصرة لم يحفظ السر",
    "wordCount": 23
  },
  {
    "slug": "sawd-alsma",
    "arabicSlug": "تفسير-حلم-صعود-السماء",
    "name": "صعود السماء",
    "letter": "ص",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "في المنام يدل على الحصول على ولاية وشرف عظيم صفر : من رأى أنه يذيب صفرا فانه يخاصم في أمر من متاع الدنيا ويقع في السنة الناس",
    "wordCount": 27
  },
  {
    "slug": "sfrh-alwjh",
    "arabicSlug": "تفسير-حلم-صفرة-الوجه",
    "name": "صفرة الوجه",
    "letter": "ص",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأى إن وجهه اصفر اللون ناله مرض، وصفرة الوجه تدل على الذل والحسد",
    "wordCount": 14
  },
  {
    "slug": "sqr",
    "arabicSlug": "تفسير-حلم-صقر",
    "name": "صقر",
    "letter": "ص",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام ولد ذكر وسلطان رفيع القدر، ومن رأى صقرا من غير منازعة فانه ينال مغنما",
    "wordCount": 17
  },
  {
    "slug": "slah-4",
    "arabicSlug": "تفسير-حلم-صلاة",
    "name": "صلاة",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "prayer",
    "text": "من رأى انه يصلي النافلة أو التطوع فإنها تدل على صلاح دينه وتمسكه بالسنة",
    "wordCount": 14
  },
  {
    "slug": "slh-3",
    "arabicSlug": "تفسير-حلم-صلح",
    "name": "صلح",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الألفة والتوبة والهداية",
    "wordCount": 5
  },
  {
    "slug": "sla",
    "arabicSlug": "تفسير-حلم-صلع",
    "name": "صلع",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في لمنام شعر رأسه قد تناثر حتى صلع فانه يخاف عليه ذهاب ماله وسقوط جاهه عند الناس و ومن رأى في منامه امرأة صلعاء فانه أمر مع فتنة",
    "wordCount": 30
  },
  {
    "slug": "slyb",
    "arabicSlug": "تفسير-حلم-صليب",
    "name": "صليب",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الكذب والقذف وشهادة الزور",
    "wordCount": 6
  },
  {
    "slug": "smgh",
    "arabicSlug": "تفسير-حلم-صمغ",
    "name": "صمغ",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام من كل شجرة فضل ونبل من رجل ينسب إلى جوهر الشجر",
    "wordCount": 14
  },
  {
    "slug": "snj",
    "arabicSlug": "تفسير-حلم-صنج",
    "name": "صنج",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجال أصحاب دنيا وتكبر",
    "wordCount": 6
  },
  {
    "slug": "sndwq",
    "arabicSlug": "تفسير-حلم-صندوق",
    "name": "صندوق",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة أو جارية حسناء، والصندوق يدل على بيت الرجل وعلى زوجته وأملاكه",
    "wordCount": 15
  },
  {
    "slug": "snm",
    "arabicSlug": "تفسير-حلم-صنم",
    "name": "صنم",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على إنسان غدار حسن الوجه سيء الخلق",
    "wordCount": 8
  },
  {
    "slug": "snwbr",
    "arabicSlug": "تفسير-حلم-صنوبر",
    "name": "صنوبر",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل رفيع القدر، قليل الخير",
    "wordCount": 7
  },
  {
    "slug": "shryj",
    "arabicSlug": "تفسير-حلم-صهريج",
    "name": "صهريج",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الزوجة وربما دل عل كل من يطلع على السر كالشريك والزوجة",
    "wordCount": 13
  },
  {
    "slug": "swt",
    "arabicSlug": "تفسير-حلم-صوت",
    "name": "صوت",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام صيت الإنسان وذكره",
    "wordCount": 6
  },
  {
    "slug": "swf",
    "arabicSlug": "تفسير-حلم-صوف",
    "name": "صوف",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يلبس الصوف دل على جمع المال الكثير، ومن رأى أنه نام على الصوف نال مالا من جهة زوجته",
    "wordCount": 21
  },
  {
    "slug": "swm",
    "arabicSlug": "تفسير-حلم-صوم",
    "name": "صوم",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه صام نال عوا وتوبة، ومن رأى انه مفطر في شهر رمضان فربما دل على سفر، وان كان الصائم مريضا دل على شفائه",
    "wordCount": 25
  },
  {
    "slug": "syah-alansan",
    "arabicSlug": "تفسير-حلم-صياح-الإنسان",
    "name": "صياح الإنسان",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يصيح على قوم فانه ينال دولة، ومن صاح وحده فانه يذهب بطشه وتضعف قوته، والصيحة تدل على الفتنة",
    "wordCount": 21
  },
  {
    "slug": "syad",
    "arabicSlug": "تفسير-حلم-صياد",
    "name": "صياد",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام رجل يميل إلى النساء، والصياد تدل رؤيته على الظفر",
    "wordCount": 12
  },
  {
    "slug": "syd",
    "arabicSlug": "تفسير-حلم-صيد",
    "name": "صيد",
    "letter": "ص",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الحصول على غنيمة",
    "wordCount": 5
  },
  {
    "slug": "db-3",
    "arabicSlug": "تفسير-حلم-ضب",
    "name": "ضب",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرجل الخبيث المخادع",
    "wordCount": 5
  },
  {
    "slug": "dba",
    "arabicSlug": "تفسير-حلم-ضبع",
    "name": "ضبع",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على عدو ظالم، والضبعة امرأة دنيئة",
    "wordCount": 7
  },
  {
    "slug": "djyj",
    "arabicSlug": "تفسير-حلم-ضجيج",
    "name": "ضجيج",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على مشاهدة فتنة أو موسم أو أمر مهم يجتمع فيه أخلاط الناس",
    "wordCount": 13
  },
  {
    "slug": "dhk",
    "arabicSlug": "تفسير-حلم-ضحك",
    "name": "ضحك",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الفرح والسرور",
    "wordCount": 4
  },
  {
    "slug": "drb-3",
    "arabicSlug": "تفسير-حلم-ضرب",
    "name": "ضرب",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الضرب في المنام كلام سوء، والضرب بالسيف دليل النصر",
    "wordCount": 9
  },
  {
    "slug": "drb-alanq",
    "arabicSlug": "تفسير-حلم-ضرب-العنق",
    "name": "ضرب العنق",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام للملوك عتق، ومن رأى إن عنقه ضرب دال على الفرج، وان كان مريضا شفي",
    "wordCount": 16
  },
  {
    "slug": "drs",
    "arabicSlug": "تفسير-حلم-ضرس",
    "name": "ضرس",
    "letter": "ض",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": "teeth-falling",
    "text": "دال على الخيانة، وربما دل على هم يصيب أهله",
    "wordCount": 9
  },
  {
    "slug": "daf",
    "arabicSlug": "تفسير-حلم-ضعف",
    "name": "ضعف",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام قوة",
    "wordCount": 4
  },
  {
    "slug": "dfda",
    "arabicSlug": "تفسير-حلم-ضفدع",
    "name": "ضفدع",
    "letter": "ض",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رجل عابد مجتهد في طاعة الله، ومن رأى انه مع الضفادع حسنت صحبته ضلع : في المنام يدل على النساء فما حدث فيها فأن تأويله حادث في النساء",
    "wordCount": 28
  },
  {
    "slug": "dw",
    "arabicSlug": "تفسير-حلم-ضوء",
    "name": "ضوء",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على رسول أو علم وربما دل على التمكن من فعل ما يريد",
    "wordCount": 13
  },
  {
    "slug": "dyaa",
    "arabicSlug": "تفسير-حلم-ضياع",
    "name": "ضياع",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على قلة الحظ، وربما دل على ذهاب الشر",
    "wordCount": 9
  },
  {
    "slug": "dyah",
    "arabicSlug": "تفسير-حلم-ضيعة",
    "name": "ضيعة",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الرزق والخير، فما أصاب الضيعة في المنام كان ذلك نقصا في الخير",
    "wordCount": 14
  },
  {
    "slug": "dyf",
    "arabicSlug": "تفسير-حلم-ضيف",
    "name": "ضيف",
    "letter": "ض",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "بشارة بولد ذكر، ومن رأى الضيوف وليس لديه امرأة حامل فانه ينال رزقا عاجلا",
    "wordCount": 14
  },
  {
    "slug": "dyq-alnfs",
    "arabicSlug": "تفسير-حلم-ضيق-النفس",
    "name": "ضيق النفس",
    "letter": "ض",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الملل والسآمة",
    "wordCount": 4
  },
  {
    "slug": "tahwnh",
    "arabicSlug": "تفسير-حلم-طاحونة",
    "name": "طاحونة",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الطاحونة الذي يطحن فيه القمح دال على دار العلم التي يفصل فيها الحق من الباطل، وربما دلت على الهموم وضيق الصدر",
    "wordCount": 21
  },
  {
    "slug": "tash",
    "arabicSlug": "تفسير-حلم-طاسه",
    "name": "طاسه",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المرأة والولد وجودتها على قدر قيمتها",
    "wordCount": 8
  },
  {
    "slug": "taawn",
    "arabicSlug": "تفسير-حلم-طاعون",
    "name": "طاعون",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على العذاب، وربما دل على القبر",
    "wordCount": 7
  },
  {
    "slug": "tawws",
    "arabicSlug": "تفسير-حلم-طاووس",
    "name": "طاووس",
    "letter": "ط",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على المرأة الجميلة",
    "wordCount": 4
  },
  {
    "slug": "tbal",
    "arabicSlug": "تفسير-حلم-طبال",
    "name": "طبال",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على صاحب الأخبار",
    "wordCount": 5
  },
  {
    "slug": "tbkh",
    "arabicSlug": "تفسير-حلم-طبخ",
    "name": "طبخ",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه طبخ بالنار طبيخا ونضج فانه ينال مراده",
    "wordCount": 10
  },
  {
    "slug": "tbq",
    "arabicSlug": "تفسير-حلم-طبق",
    "name": "طبق",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام حبيب الرجل والمحبوب يقدم إليه من الطعام الشهي",
    "wordCount": 11
  },
  {
    "slug": "tbl",
    "arabicSlug": "تفسير-حلم-طبل",
    "name": "طبل",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الخبر الباطل",
    "wordCount": 4
  },
  {
    "slug": "tbyb",
    "arabicSlug": "تفسير-حلم-طبيب",
    "name": "طبيب",
    "letter": "ط",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رأى إن طبيب داواه فانه يصح جسمه، وان رأى عالما يعظه فانه يخرج الشك من قلبه",
    "wordCount": 17
  },
  {
    "slug": "trb",
    "arabicSlug": "تفسير-حلم-طرب",
    "name": "طرب",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على استدعاء للهموم والأحزان، وربما دل على سرعة الفهم والوعي",
    "wordCount": 11
  },
  {
    "slug": "trd",
    "arabicSlug": "تفسير-حلم-طرد",
    "name": "طرد",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يطرد من بلده فهو يحبس، ومن رأى انه طرد من الجنة فانه يفتقر",
    "wordCount": 16
  },
  {
    "slug": "trsh",
    "arabicSlug": "تفسير-حلم-طرش",
    "name": "طرش",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على نقص الدين",
    "wordCount": 4
  },
  {
    "slug": "tryq",
    "arabicSlug": "تفسير-حلم-طريق",
    "name": "طريق",
    "letter": "ط",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "يدل على الشرعة، والطرق المختلفة هي البدع",
    "wordCount": 7
  },
  {
    "slug": "taam",
    "arabicSlug": "تفسير-حلم-طعام",
    "name": "طعام",
    "letter": "ط",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "الأطعمة غير الموسمية هي أرزاق وفوائد مستمرة، والأطعمة الموسمية فأرزاق في وقت محدد، وأطعمة الملوك عز ورفعة",
    "wordCount": 17
  },
  {
    "slug": "tfl",
    "arabicSlug": "تفسير-حلم-طفل",
    "name": "طفل",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الهموم والتعب",
    "wordCount": 5
  },
  {
    "slug": "tlaq",
    "arabicSlug": "تفسير-حلم-طلاق",
    "name": "طلاق",
    "letter": "ط",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": null,
    "text": "يدل للأعزب على فراقه للخير أو الشر، وطلاق المتزوج بطلان معيشته أو موته",
    "wordCount": 13
  },
  {
    "slug": "tla",
    "arabicSlug": "تفسير-حلم-طلع",
    "name": "طلع",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "النخل يدل على الرزق وحمل الزوجة، وان رآه مريض دل على شفائه",
    "wordCount": 12
  },
  {
    "slug": "twaf",
    "arabicSlug": "تفسير-حلم-طواف",
    "name": "طواف",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه يطوف بالكعبة في المنام إن كان عبدا عتق، أو كان عاصيا عتق من النار، وأن كان أعزب تزوج",
    "wordCount": 21
  },
  {
    "slug": "twq",
    "arabicSlug": "تفسير-حلم-طوق",
    "name": "طوق",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في عنقه طوقا فانه بخيل، والطوق إحسان المرأة إلى زوجها، والطوق للمرأة زوجها فان كان من فضة وكان واسعا فالزوج كريم وسخي",
    "wordCount": 24
  },
  {
    "slug": "twl",
    "arabicSlug": "تفسير-حلم-طول",
    "name": "طول",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه طال في المنام فانه يزيد علمه وماله، ومن رأى انه طال فوق الحد المعقول قرب اجله وسقوطه عن مرتبته، وطول القامة دال على طول الحياة",
    "wordCount": 28
  },
  {
    "slug": "tyb",
    "arabicSlug": "تفسير-حلم-طيب",
    "name": "طيب",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ثناء حسن، والطيب في المرضى يدل على موتهم، والمرأة إذا رأت إنها تتطيب فإنها تدخل في عمل صالح، أو تتزوج",
    "wordCount": 23
  },
  {
    "slug": "tyr",
    "arabicSlug": "تفسير-حلم-طير",
    "name": "طير",
    "letter": "ط",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "إذا كان مجهولا يدل على ملك الموت، وربما يدل على المسافر، ومن رأى طائر جاء من السماء فوقع بين يديه فهي بشارة خير",
    "wordCount": 23
  },
  {
    "slug": "tyran",
    "arabicSlug": "تفسير-حلم-طيران",
    "name": "طيران",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "flying",
    "text": "دال على السفر، ومن رأى انه يطير بين السماء والارض فانه يكثر التمني",
    "wordCount": 13
  },
  {
    "slug": "tyn-3",
    "arabicSlug": "تفسير-حلم-طين",
    "name": "طين",
    "letter": "ط",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المرض، والبناء بالطين هو الدين واليقين",
    "wordCount": 8
  },
  {
    "slug": "zbyh",
    "arabicSlug": "تفسير-حلم-ظبية",
    "name": "ظبية",
    "letter": "ظ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى أنه ملك ظبية فيدل على زواجه",
    "wordCount": 8
  },
  {
    "slug": "zfr",
    "arabicSlug": "تفسير-حلم-ظفر",
    "name": "ظفر",
    "letter": "ظ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "يدل على الظفر بالأعداء، والظفر قوة الرجل",
    "wordCount": 7
  },
  {
    "slug": "zl",
    "arabicSlug": "تفسير-حلم-ظل",
    "name": "ظل",
    "letter": "ظ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام في الصيف راحة وفائدة، وفي الشتاء دال على الهم والنكد، ومن رأى انه أوى إلى ظل يستريح من الحر فانه ينجو من الهم وينال رزق، وظل المرأة زوجها",
    "wordCount": 31
  },
  {
    "slug": "zlm",
    "arabicSlug": "تفسير-حلم-ظلم",
    "name": "ظلم",
    "letter": "ظ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل في المنام على تعجيل الدمار والخراب",
    "wordCount": 7
  },
  {
    "slug": "zma",
    "arabicSlug": "تفسير-حلم-ظمأ",
    "name": "ظمأ",
    "letter": "ظ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "ربما دل على الفقر وتوقف حال ذوي الكسب، والشوق للغائب",
    "wordCount": 10
  },
  {
    "slug": "zhr",
    "arabicSlug": "تفسير-حلم-ظهر",
    "name": "ظهر",
    "letter": "ظ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "الإنسان في المنام دال على ما يظهر عليه كاللباس وما يستظهر به من مال مدخر أو مصلحة، وانقصام الظهر خوف أو حزن",
    "wordCount": 22
  },
  {
    "slug": "zhwr",
    "arabicSlug": "تفسير-حلم-ظهور",
    "name": "ظهور",
    "letter": "ظ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من ظهر له في المنام ما كان عنه مكتوما دل على الأنس بعد الوحشة والفائدة بعد المغرم أو الولد بعد اليأس منه، وظهور الشيء في غير أوانه دليل على الدين",
    "wordCount": 30
  },
  {
    "slug": "aatq",
    "arabicSlug": "تفسير-حلم-عاتق",
    "name": "عاتق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن حمل ثقيل على عاتقيه دليل على حمل الأوزار",
    "wordCount": 11
  },
  {
    "slug": "aaqd-alankhh",
    "arabicSlug": "تفسير-حلم-عاقد-الانكحة",
    "name": "عاقد الانكحة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته في المنام على الزواج للأعزب والطلاق للمتزوج",
    "wordCount": 9
  },
  {
    "slug": "aam",
    "arabicSlug": "تفسير-حلم-عام",
    "name": "عام",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الفتنة يراها الرائي في نفسه أو غيره",
    "wordCount": 10
  },
  {
    "slug": "aanh",
    "arabicSlug": "تفسير-حلم-عانة",
    "name": "عانة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا حلقها الإنسان أو أزالها تدل على ذهاب الدين والهم، وعانة المرأة مزرعة وقيل هي دليل طلاقها",
    "wordCount": 17
  },
  {
    "slug": "abws-alwjh",
    "arabicSlug": "تفسير-حلم-عبوس-الوجه",
    "name": "عبوس الوجه",
    "letter": "ع",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأى إن وجهه عابس فانه يولد له بنت",
    "wordCount": 9
  },
  {
    "slug": "atab",
    "arabicSlug": "تفسير-حلم-عتاب",
    "name": "عتاب",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "العتاب دال على المحب والمحبة، ومن رأى انه يعاتب نفسه فانه يعمل عمل يندم عليه نفسه",
    "wordCount": 16
  },
  {
    "slug": "atbh",
    "arabicSlug": "تفسير-حلم-عتبة",
    "name": "عتبة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام امرأة الرجل",
    "wordCount": 5
  },
  {
    "slug": "atq",
    "arabicSlug": "تفسير-حلم-عتق",
    "name": "عتق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الأضحية فمن رأى انه اعتق فانه يضحي، ومن اعتق زوجته طلقها",
    "wordCount": 13
  },
  {
    "slug": "ajan-aldqyq",
    "arabicSlug": "تفسير-حلم-عجان-الدقيق",
    "name": "عجان الدقيق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الرزق والاهتمام بمصالح الناس",
    "wordCount": 7
  },
  {
    "slug": "ajb",
    "arabicSlug": "تفسير-حلم-عجب",
    "name": "عجب",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الظلم",
    "wordCount": 3
  },
  {
    "slug": "ajh",
    "arabicSlug": "تفسير-حلم-عجة",
    "name": "عجة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على العز والأفراح والأزواج",
    "wordCount": 5
  },
  {
    "slug": "ajl",
    "arabicSlug": "تفسير-حلم-عجل",
    "name": "عجل",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على الولد الذكر، والعجل المشوي أمان من الخوف",
    "wordCount": 9
  },
  {
    "slug": "ajlh",
    "arabicSlug": "تفسير-حلم-عجلة",
    "name": "عجلة",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى انه يعجل في أمر فانه يندم فيه",
    "wordCount": 9
  },
  {
    "slug": "ajwh",
    "arabicSlug": "تفسير-حلم-عجوة",
    "name": "عجوة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "التمر مال حلال طيب",
    "wordCount": 4
  },
  {
    "slug": "ajwz",
    "arabicSlug": "تفسير-حلم-عجوز",
    "name": "عجوز",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام عجز وربما دلت على الدنيا الذاهبة، والعجوز تدل على أرض سبخة لا تنبت",
    "wordCount": 16
  },
  {
    "slug": "ajyn",
    "arabicSlug": "تفسير-حلم-عجين",
    "name": "عجين",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على أمور سهلة وقرب راحة وانتظار فرج، والعجين مال يحصل",
    "wordCount": 12
  },
  {
    "slug": "adawh",
    "arabicSlug": "تفسير-حلم-عداوة",
    "name": "عداوة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يعادي رجل فانه يود ويصطحبه، والعداوة لأعداء الله دالة على الإيمان",
    "wordCount": 14
  },
  {
    "slug": "ads",
    "arabicSlug": "تفسير-حلم-عدس",
    "name": "عدس",
    "letter": "ع",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دال على المال الحلال إذا كان نابتا وقيل انه هم ورزق دنيء",
    "wordCount": 12
  },
  {
    "slug": "adhra",
    "arabicSlug": "تفسير-حلم-عذراء",
    "name": "عذراء",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على العسر لأصحاب المناصب",
    "wordCount": 5
  },
  {
    "slug": "arj",
    "arabicSlug": "تفسير-حلم-عرج",
    "name": "عرج",
    "letter": "ع",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو عجز عن أمر يقصده، وربما دل على علم وزيادة في الدين",
    "wordCount": 12
  },
  {
    "slug": "ars",
    "arabicSlug": "تفسير-حلم-عرس",
    "name": "عرس",
    "letter": "ع",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": "marriage",
    "text": "هو في المنام دال على الموت",
    "wordCount": 6
  },
  {
    "slug": "arfh",
    "arabicSlug": "تفسير-حلم-عرفة",
    "name": "عرفة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه في يوم عرفة فانه إن كان له غائب رجع إليه مسرورا",
    "wordCount": 16
  },
  {
    "slug": "arq",
    "arabicSlug": "تفسير-حلم-عرق",
    "name": "عرق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على عافية للمريض وإلا فهو عرق الموت، وللسليم خدمة أو حرفة، والعرق دليل على مضرة الدنيا",
    "wordCount": 17
  },
  {
    "slug": "arws",
    "arabicSlug": "تفسير-حلم-عروس",
    "name": "عروس",
    "letter": "ع",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": null,
    "text": "هي في المنام إذا كانت مزينة دنيا خصبة، وإذا رأى أنه تزوج حصل على ملك بقدر المرأة وفضلها",
    "wordCount": 18
  },
  {
    "slug": "ary",
    "arabicSlug": "تفسير-حلم-عري",
    "name": "عري",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على سلامة الباطن، وربما دل على ما يوقعه في الندم، وان رأى انه عريان في محفل فانه يفتضح",
    "wordCount": 19
  },
  {
    "slug": "az",
    "arabicSlug": "تفسير-حلم-عز",
    "name": "عز",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ذل، فمن رأى انه عزيز ذل",
    "wordCount": 9
  },
  {
    "slug": "azl",
    "arabicSlug": "تفسير-حلم-عزل",
    "name": "عزل",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من المنصب في المنام طلاق للزوجة أو انتقال من صنعة إلى غيرها، والعزل عم المرأة تبذير للمال وحرمان للعيال، وأن رأى أنه عزل عن ولاية يرجوها فأنه يولاها",
    "wordCount": 28
  },
  {
    "slug": "asl",
    "arabicSlug": "تفسير-حلم-عسل",
    "name": "عسل",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على المال الحلال، والعسل لأهل الدين حلاوة الإيمان، ولأهل الدنيا غنيمة من غير تعب",
    "wordCount": 15
  },
  {
    "slug": "ash",
    "arabicSlug": "تفسير-حلم-عش",
    "name": "عش",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الزوجة، ورؤيا العش للمرأة الحامل ولادة، وإذا كان العش في حائط أو كهف فهو وكر",
    "wordCount": 17
  },
  {
    "slug": "asha",
    "arabicSlug": "تفسير-حلم-عشاء",
    "name": "عشاء",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الاحتيال والكذب وقيام الفتنة",
    "wordCount": 6
  },
  {
    "slug": "ashq",
    "arabicSlug": "تفسير-حلم-عشق",
    "name": "عشق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام بلاء، فمن رأى انه عاشق ابتلى",
    "wordCount": 9
  },
  {
    "slug": "asa",
    "arabicSlug": "تفسير-حلم-عصا",
    "name": "عصا",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام رجل حسيب منيع، فمن رأى إن بيده عصا فانه يستعين برجل قوي يوصله إلى مطلبه",
    "wordCount": 18
  },
  {
    "slug": "asb",
    "arabicSlug": "تفسير-حلم-عصب",
    "name": "عصب",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من وجد الألم بعصبه ناله هم وحزن، وان انقطع عصبه تشتت أمره",
    "wordCount": 12
  },
  {
    "slug": "asfwr",
    "arabicSlug": "تفسير-حلم-عصفور",
    "name": "عصفور",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رجل صاحب لهو وحكايات، وان رأى أنه ذبح عصفورا ولد له ولد ذكر ضعيف، وقيل العصفور يدل على رجل مخاصم كثير المال، والعصفور يدل على امرأة حسناء",
    "wordCount": 27
  },
  {
    "slug": "asyr",
    "arabicSlug": "تفسير-حلم-عصير",
    "name": "عصير",
    "letter": "ع",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "من رأى انه يعصر عنبا أو قصبا نال خصبا، وان كان فقيرا استغنى",
    "wordCount": 13
  },
  {
    "slug": "ad",
    "arabicSlug": "تفسير-حلم-عض",
    "name": "عض",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الكيد والحقد وقيل العض يدل على فرط المحبة لأي معضوض، ومن رأى أنسانا يعض على أنامله فانه حقود",
    "wordCount": 20
  },
  {
    "slug": "ad-alansan",
    "arabicSlug": "تفسير-حلم-عضو-الإنسان",
    "name": "عضو الإنسان",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل في المنام يعبر بالأهل فمن تقطعت أعضاؤه فارق أهله",
    "wordCount": 10
  },
  {
    "slug": "ata",
    "arabicSlug": "تفسير-حلم-عطاء",
    "name": "عطاء",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام على قدر المعطي",
    "wordCount": 6
  },
  {
    "slug": "atar",
    "arabicSlug": "تفسير-حلم-عطار",
    "name": "عطار",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل عالم أو زاهد، والعطار تدل رؤيته على العلم واكتساب المدح",
    "wordCount": 13
  },
  {
    "slug": "atas",
    "arabicSlug": "تفسير-حلم-عطاس",
    "name": "عطاس",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام استبانة أمر كان منه في شك",
    "wordCount": 9
  },
  {
    "slug": "atsh",
    "arabicSlug": "تفسير-حلم-عطش",
    "name": "عطش",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على فساد في الدين، ومن رأى انه عطشان وأراد أن يشرب من نهر فلم يشرب فانه ينجو من هم، والعطش دال على التخلق بأخلاق أهل الفتنة",
    "wordCount": 27
  },
  {
    "slug": "azm",
    "arabicSlug": "تفسير-حلم-عظم",
    "name": "عظم",
    "letter": "ع",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه عظم حتى صارت جثته أعظم من هيئة الناس فانه دليل موته",
    "wordCount": 16
  },
  {
    "slug": "afw",
    "arabicSlug": "تفسير-حلم-عفو",
    "name": "عفو",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه عفا عن مذنب ذنبا فانه يعمل عملا يغفره الله تعالى له",
    "wordCount": 16
  },
  {
    "slug": "aqab",
    "arabicSlug": "تفسير-حلم-عقاب",
    "name": "عقاب",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام رجل قوي لا يؤامنه قريب ولا بعيد",
    "wordCount": 10
  },
  {
    "slug": "aqbh",
    "arabicSlug": "تفسير-حلم-عقبة",
    "name": "عقبة",
    "letter": "ع",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هي في المنام من طلع إليها لحاجة فانه يجهد نفسه في تحصيل الدنيا والآخرة على قدر ما قصده في المنام، وربما دلت العقبة على المرأة الصعبة، وربما دلت العقبة على الرفيق أو الشريك الذي لا يؤمن على مال ولا نفس",
    "wordCount": 40
  },
  {
    "slug": "aqd-alshy",
    "arabicSlug": "تفسير-حلم-عقد-الشيء",
    "name": "عقد الشيء",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "عقد الحبل هو الدين، وعلى السراويل عقد على امرأة، وعلى الخيط تأكيد أمر يريده من تجارة أو تزويج والعقد تيسير وان لم ينعقد تعسر",
    "wordCount": 24
  },
  {
    "slug": "aqrb",
    "arabicSlug": "تفسير-حلم-عقرب",
    "name": "عقرب",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "scorpion",
    "text": "يدل على الهم والنكد، والعقرب رجل نمام بين الناس",
    "wordCount": 9
  },
  {
    "slug": "aqwq-alwaldyn",
    "arabicSlug": "تفسير-حلم-عقوق-الوالدين",
    "name": "عقوق الوالدين",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام دال على الوقوع في الكبائر كالشرك بالله وقتل النفس",
    "wordCount": 11
  },
  {
    "slug": "aqyq",
    "arabicSlug": "تفسير-حلم-عقيق",
    "name": "عقيق",
    "letter": "ع",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "هو في المنام نفي للفقر",
    "wordCount": 5
  },
  {
    "slug": "aqyqh",
    "arabicSlug": "تفسير-حلم-عقيقة",
    "name": "عقيقة",
    "letter": "ع",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "بشارة بقدوم غائب أو عافية مريض أو خلاص سجين، وربما دلت على زيادة الإيمان والقيام بالسنة",
    "wordCount": 16
  },
  {
    "slug": "alaf",
    "arabicSlug": "تفسير-حلم-علاف",
    "name": "علاف",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام رجل كريم كثير المال مذكور بالفضائل، والعلاف تدل رؤيته على القيام بالمصالح",
    "wordCount": 15
  },
  {
    "slug": "alk",
    "arabicSlug": "تفسير-حلم-علك",
    "name": "علك",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يمضغ علكا فانه يأتي فاحشة، وربما يكثر كلامه في أمر منازعة",
    "wordCount": 14
  },
  {
    "slug": "alm",
    "arabicSlug": "تفسير-حلم-علم",
    "name": "علم",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام التزوج بامرأة عالية المقام",
    "wordCount": 7
  },
  {
    "slug": "al-alshan",
    "arabicSlug": "تفسير-حلم-علو-الشأن",
    "name": "علو الشأن",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على انحطاط القدر، وان رأى أنه لا يريد العلو نال رفعة وسرورا",
    "wordCount": 13
  },
  {
    "slug": "ama",
    "arabicSlug": "تفسير-حلم-عمى",
    "name": "عمى",
    "letter": "ع",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "ضلالة في الدين، وربما ميراث كبير، فمن رأى أنه أعمى استغنى، وان رأى أنسانا أعماه فانه يضله",
    "wordCount": 17
  },
  {
    "slug": "amamh",
    "arabicSlug": "تفسير-حلم-عمامة",
    "name": "عمامة",
    "letter": "ع",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "دالة على تاج الرجل وجاهه، وقوته وزوجته عمل : ناقص في المنام يدل على البطالة أو اليأس من المرجو عمله، والعمل التام يدل في المنام على الحياة",
    "wordCount": 27
  },
  {
    "slug": "amwd",
    "arabicSlug": "تفسير-حلم-عمود",
    "name": "عمود",
    "letter": "ع",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هو في المنام الدين، فمن رأى عامود أو ضرب به فانه كلام يعبر به الضارب المضروب فان جرحه به فانه يدخل عليه مضرة",
    "wordCount": 23
  },
  {
    "slug": "anaq",
    "arabicSlug": "تفسير-حلم-عناق",
    "name": "عناق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يعانق حيا فانه يخالطه مخالطة طويلة على قدر طول العناق وبقدر ذلك المحبة، وأن عانق ميت أو خالطه مخالطة قصيرة تطول حياته",
    "wordCount": 25
  },
  {
    "slug": "anb",
    "arabicSlug": "تفسير-حلم-عنب",
    "name": "عنب",
    "letter": "ع",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "هو في المنام رزق حسن ودائم",
    "wordCount": 6
  },
  {
    "slug": "anbr",
    "arabicSlug": "تفسير-حلم-عنبر",
    "name": "عنبر",
    "letter": "ع",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "يدل على مال ومنفعة من جهة رجل كبير المنزلة، فان استعمل فهو ثناء، وربما دل على الأملاك، والعنبر ريح أو خير من جهة البحر",
    "wordCount": 24
  },
  {
    "slug": "anzh",
    "arabicSlug": "تفسير-حلم-عنزة",
    "name": "عنزة",
    "letter": "ع",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "من رأى انه أصاب عنزا فانه ينال جارية أو امرأة فاسدة الدين، ومن وجد عنزا فانه ينال سعة رزق وخيرا",
    "wordCount": 20
  },
  {
    "slug": "anq",
    "arabicSlug": "تفسير-حلم-عنق",
    "name": "عنق",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام محل الأمانة، ومن رأى أن عنقه غليظ فانه قائم بما حمل من الأمانة",
    "wordCount": 16
  },
  {
    "slug": "ankbwt",
    "arabicSlug": "تفسير-حلم-عنكبوت",
    "name": "عنكبوت",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المرأة التي تهجر فراش زوجها، وقيل العنكبوت رجل عابد زاهد",
    "wordCount": 12
  },
  {
    "slug": "awd",
    "arabicSlug": "تفسير-حلم-عود",
    "name": "عود",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على البرء من الإسقام، وهو للأعزب زوجة وللمتزوجة ولد في حجرها، وقيل ضرب العود كلام كذب وكذلك استماعه",
    "wordCount": 19
  },
  {
    "slug": "awr",
    "arabicSlug": "تفسير-حلم-عور",
    "name": "عور",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه أعور العين فقد نصف ماله أو فقد نصف دينه، أو أصاب إثما كبيرا",
    "wordCount": 18
  },
  {
    "slug": "awrh",
    "arabicSlug": "تفسير-حلم-عورة",
    "name": "عورة",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه انكشفت ثيابه عن عورته فظهرت فانه ينتهك ستره",
    "wordCount": 11
  },
  {
    "slug": "ayal",
    "arabicSlug": "تفسير-حلم-عيال",
    "name": "عيال",
    "letter": "ع",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام غنى لمن رآهم",
    "wordCount": 5
  },
  {
    "slug": "ayn-alma",
    "arabicSlug": "تفسير-حلم-عين-الماء",
    "name": "عين الماء",
    "letter": "ع",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "نعمة وخير وبركة وبلوغ أمنية إن كان صاحبها مستورا، ومن رأى عيون تفجرت في داره وكان غير مستور أصابه مصيبة، ومن رأى انه يتوضأ من عين فهو خير",
    "wordCount": 28
  },
  {
    "slug": "ayn-alansan",
    "arabicSlug": "تفسير-حلم-عين-الإنسان",
    "name": "عين الإنسان",
    "letter": "ع",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "في المنام دين الرجل وبصيرته",
    "wordCount": 5
  },
  {
    "slug": "ghayt",
    "arabicSlug": "تفسير-حلم-غائط",
    "name": "غائط",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه تغوط غائطا صلبا فانه ينفق مالا في صحة جسم، ومن تغوط والناس ينظرون إليه فليحذر من فضيحة تبدو منه أو كلام قبيح",
    "wordCount": 25
  },
  {
    "slug": "ghar",
    "arabicSlug": "تفسير-حلم-غار",
    "name": "غار",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام أمن للخائف فمن رأى انه يفر من العدو حتى دخل غارا فانه يأمن من عدوه",
    "wordCount": 17
  },
  {
    "slug": "ghbar",
    "arabicSlug": "تفسير-حلم-غبار",
    "name": "غبار",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى غبار بين السماء والأرض فهو أمر ملتبس لا يعرف المخرج منه، ومن رأى انه ينفض الغبار فانه يفتقر، ومن رأى أن عليه غبارا سافر",
    "wordCount": 26
  },
  {
    "slug": "ghdr",
    "arabicSlug": "تفسير-حلم-غدر",
    "name": "غدر",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام منقصة في الدين والدنيا",
    "wordCount": 7
  },
  {
    "slug": "ghrab",
    "arabicSlug": "تفسير-حلم-غراب",
    "name": "غراب",
    "letter": "غ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على رجل رفيع ضخم صبور، ومن صاد غرابا نال مالا حراما، والغراب شؤم",
    "wordCount": 14
  },
  {
    "slug": "ghrbal",
    "arabicSlug": "تفسير-حلم-غربال",
    "name": "غربال",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام يدل على العلم والتمييز والعز والفرق بين الحق والباطل",
    "wordCount": 12
  },
  {
    "slug": "ghrfh",
    "arabicSlug": "تفسير-حلم-غرفة",
    "name": "غرفة",
    "letter": "غ",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "دالة على الأمن من الخوف",
    "wordCount": 5
  },
  {
    "slug": "ghrq",
    "arabicSlug": "تفسير-حلم-غرق",
    "name": "غرق",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "drowning",
    "text": "فمن رأى انه غرق فهو في النار، ومن رأى انه يغرق في البحر ويغوص ويطفو فانه يغرق في أمر دنياه ويستغني",
    "wordCount": 21
  },
  {
    "slug": "ghzal",
    "arabicSlug": "تفسير-حلم-غزال",
    "name": "غزال",
    "letter": "غ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام من النساء أو الأولاد، ومن حصل على غزال حصل له رزق",
    "wordCount": 14
  },
  {
    "slug": "ghzl",
    "arabicSlug": "تفسير-حلم-غزل",
    "name": "غزل",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رأت امرأة أنها تغزل مسرع فانه يقدم لها غائب، وان كانت مبطئة فإنها تسافر أو يسافر زوجها",
    "wordCount": 18
  },
  {
    "slug": "ghsl",
    "arabicSlug": "تفسير-حلم-غسل",
    "name": "غسل",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يغسل بماء طاهر يدل على التوبة من الذنوب",
    "wordCount": 11
  },
  {
    "slug": "ghsh",
    "arabicSlug": "تفسير-حلم-غش",
    "name": "غش",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الارتداد عن الدين",
    "wordCount": 5
  },
  {
    "slug": "ghshawh",
    "arabicSlug": "تفسير-حلم-غشاوة",
    "name": "غشاوة",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن على عينيه غشاوة أصابه حزن عظيم",
    "wordCount": 9
  },
  {
    "slug": "ghd-albsr",
    "arabicSlug": "تفسير-حلم-غض-البصر",
    "name": "غض البصر",
    "letter": "غ",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دليل على المحافظة على أوامر الله",
    "wordCount": 6
  },
  {
    "slug": "ghdb",
    "arabicSlug": "تفسير-حلم-غضب",
    "name": "غضب",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام سجن",
    "wordCount": 4
  },
  {
    "slug": "ghtas",
    "arabicSlug": "تفسير-حلم-غطاس",
    "name": "غطاس",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الجاسوس وعلى الفوائد والأرزاق",
    "wordCount": 6
  },
  {
    "slug": "ghtyt-alnaym",
    "arabicSlug": "تفسير-حلم-غطيط-النائم",
    "name": "غطيط النائم",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على إدراك عدوه وعلى كشف ما يريد ستره، وربما دل على الأمن من الخوف",
    "wordCount": 15
  },
  {
    "slug": "ghlaf",
    "arabicSlug": "تفسير-حلم-غلاف",
    "name": "غلاف",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على زوج أو امرأة، والغلاف ولد أبله لا حركة فيه",
    "wordCount": 11
  },
  {
    "slug": "ghlam",
    "arabicSlug": "تفسير-حلم-غلام",
    "name": "غلام",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "بشارة لمن رآه، ومن حمل غلاما يناله هم",
    "wordCount": 8
  },
  {
    "slug": "ghm",
    "arabicSlug": "تفسير-حلم-غم",
    "name": "غم",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام فرح بعد حزن، وربما دل على بعد الفوائد",
    "wordCount": 11
  },
  {
    "slug": "ghna-2",
    "arabicSlug": "تفسير-حلم-غنى",
    "name": "غنى",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على فقر أو القناعة",
    "wordCount": 5
  },
  {
    "slug": "ghna-3",
    "arabicSlug": "تفسير-حلم-غناء",
    "name": "غناء",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الكلام الباطل أو المصيبة، وإذا كان الصوت طيبا فانه يدل على تجارة نافعة، والمغني حكيم أو عالم",
    "wordCount": 17
  },
  {
    "slug": "ghnm",
    "arabicSlug": "تفسير-حلم-غنم",
    "name": "غنم",
    "letter": "غ",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "رعية صالحة طائعة، والغنم تدل على الغنيمة والأزواج والأملاك",
    "wordCount": 9
  },
  {
    "slug": "ghnymh",
    "arabicSlug": "تفسير-حلم-غنيمة",
    "name": "غنيمة",
    "letter": "غ",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "دالة على الفرح والسرور والظفر بالمطلوب",
    "wordCount": 6
  },
  {
    "slug": "ghwas",
    "arabicSlug": "تفسير-حلم-غواص",
    "name": "غواص",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ملك، وان رأى أنه غاص في الماء فانه يدخل في عمل يرزق منه، والغواص رجل داخل في غوامض الأمور",
    "wordCount": 22
  },
  {
    "slug": "ghybh",
    "arabicSlug": "تفسير-حلم-غيبة",
    "name": "غيبة",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "للغير في المنام دالة على محق البركات لأن الغيبة تأكل الحسنات، ومن رأى أنه يغتاب أنسانا فان الغيبة بالفقر يرجع إليه الفقر",
    "wordCount": 22
  },
  {
    "slug": "ghyrh",
    "arabicSlug": "تفسير-حلم-غيرة",
    "name": "غيرة",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الحرص",
    "wordCount": 3
  },
  {
    "slug": "ghyz",
    "arabicSlug": "تفسير-حلم-غيظ",
    "name": "غيظ",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دال على الموت، وربما دل على ارتكاب الفضائح والأمراض",
    "wordCount": 12
  },
  {
    "slug": "ghym",
    "arabicSlug": "تفسير-حلم-غيم",
    "name": "غيم",
    "letter": "غ",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل في المنام على السفر في البحر وحمله الماء بين السماء والأرض",
    "wordCount": 12
  },
  {
    "slug": "farh",
    "arabicSlug": "تفسير-حلم-فأرة",
    "name": "فأرة",
    "letter": "ف",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "تدل على المرأة الفاسقة",
    "wordCount": 4
  },
  {
    "slug": "fas",
    "arabicSlug": "تفسير-حلم-فأس",
    "name": "فأس",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الإعانة والرزق، ومن رأى إن بيده فأس فانه يصبح وكيلا أو وصيا",
    "wordCount": 15
  },
  {
    "slug": "faqh",
    "arabicSlug": "تفسير-حلم-فاقة",
    "name": "فاقة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على إجابة السؤال لما يرجوه من ذوي الأقدار",
    "wordCount": 9
  },
  {
    "slug": "fakhany",
    "arabicSlug": "تفسير-حلم-فاكهاني",
    "name": "فاكهاني",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل أمين على أموال الناس",
    "wordCount": 5
  },
  {
    "slug": "fakhh",
    "arabicSlug": "تفسير-حلم-فاكهة",
    "name": "فاكهة",
    "letter": "ف",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "دالة على الزواج",
    "wordCount": 3
  },
  {
    "slug": "fta",
    "arabicSlug": "تفسير-حلم-فتى",
    "name": "فتى",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الحظ والقبول والانتصار",
    "wordCount": 6
  },
  {
    "slug": "ftk",
    "arabicSlug": "تفسير-حلم-فتك",
    "name": "فتك",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام من العدو وربما كان آفة تهلك الرزق",
    "wordCount": 10
  },
  {
    "slug": "ftnh",
    "arabicSlug": "تفسير-حلم-فتنة",
    "name": "فتنة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام مل وأولاد",
    "wordCount": 5
  },
  {
    "slug": "ftylh",
    "arabicSlug": "تفسير-حلم-فتيلة",
    "name": "فتيلة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الخادمة التي تخدم الناس",
    "wordCount": 6
  },
  {
    "slug": "fjr",
    "arabicSlug": "تفسير-حلم-فجر",
    "name": "فجر",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رآه قد طلع ينال فرحا وسرور",
    "wordCount": 7
  },
  {
    "slug": "fjwr",
    "arabicSlug": "تفسير-حلم-فجور",
    "name": "فجور",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الكفر",
    "wordCount": 4
  },
  {
    "slug": "fham",
    "arabicSlug": "تفسير-حلم-فحام",
    "name": "فحام",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الشرور والكذب",
    "wordCount": 5
  },
  {
    "slug": "fhm",
    "arabicSlug": "تفسير-حلم-فحم",
    "name": "فحم",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل خطير أو مال حرام، ومن رأى فحم مشتعل فأنه رجل ممتحن مظلوم",
    "wordCount": 15
  },
  {
    "slug": "fkh",
    "arabicSlug": "تفسير-حلم-فخ",
    "name": "فخ",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل قليل الدين ذو حيلة ومكر، وإذا رأت المرأة أنها تنصب فخ للطيور ولا تمسك بها فإنها تطلب الحمل من زوجها ولا يثبت الحمل",
    "wordCount": 24
  },
  {
    "slug": "fkhdh",
    "arabicSlug": "تفسير-حلم-فخذ",
    "name": "فخذ",
    "letter": "ف",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام عشيرة الرجل",
    "wordCount": 5
  },
  {
    "slug": "fkhr",
    "arabicSlug": "تفسير-حلم-فخر",
    "name": "فخر",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على المال والرزق",
    "wordCount": 4
  },
  {
    "slug": "fra",
    "arabicSlug": "تفسير-حلم-فراء",
    "name": "فراء",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته في الصيف على الهموم، وفي الشتاء على العافية والنشاط",
    "wordCount": 11
  },
  {
    "slug": "frash-2",
    "arabicSlug": "تفسير-حلم-فراسة",
    "name": "فراسة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى نفسه يتفرس ويعلم الغيب فانه يكثر خيره ولا يمسه سوء",
    "wordCount": 12
  },
  {
    "slug": "frash-3",
    "arabicSlug": "تفسير-حلم-فراش",
    "name": "فراش",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة",
    "wordCount": 4
  },
  {
    "slug": "frashh",
    "arabicSlug": "تفسير-حلم-فراشة",
    "name": "فراشة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الجهل وربما دلت رؤيته على المحبة",
    "wordCount": 9
  },
  {
    "slug": "fran",
    "arabicSlug": "تفسير-حلم-فران",
    "name": "فران",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على العالم بمصالح الناس",
    "wordCount": 6
  },
  {
    "slug": "frj",
    "arabicSlug": "تفسير-حلم-فرج",
    "name": "فرج",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام فرج لمن هو في شدة، والزواج للأعزب",
    "wordCount": 10
  },
  {
    "slug": "frh",
    "arabicSlug": "تفسير-حلم-فرح",
    "name": "فرح",
    "letter": "ف",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": null,
    "text": "هو في المنام إذا كان فيه ما لا يرضي الله فانه يدل على الهم والحزن",
    "wordCount": 15
  },
  {
    "slug": "frawn",
    "arabicSlug": "تفسير-حلم-فرعون",
    "name": "فرعون",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على عدو الدين",
    "wordCount": 4
  },
  {
    "slug": "frn",
    "arabicSlug": "تفسير-حلم-فرن",
    "name": "فرن",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا كان فرن البيت يدل على صاحب الدار أو خادمه",
    "wordCount": 10
  },
  {
    "slug": "frw",
    "arabicSlug": "تفسير-حلم-فرو",
    "name": "فرو",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من لبسه في الشتاء خير يحصل عليه وان كان في الصيف فانه خير يصيبه في غم وهم",
    "wordCount": 17
  },
  {
    "slug": "frwj",
    "arabicSlug": "تفسير-حلم-فروج",
    "name": "فروج",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مملوك صغير أو ولد",
    "wordCount": 7
  },
  {
    "slug": "fza",
    "arabicSlug": "تفسير-حلم-فزع",
    "name": "فزع",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على السرور، ومن رأى انه مات من الفزع فانه يفتقر، ولا يوصل الحقوق لأصحابها",
    "wordCount": 15
  },
  {
    "slug": "fsa",
    "arabicSlug": "تفسير-حلم-فساء",
    "name": "فساء",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الكلام القبيح",
    "wordCount": 4
  },
  {
    "slug": "fstq",
    "arabicSlug": "تفسير-حلم-فستق",
    "name": "فستق",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرجل الكريم، ويدل على المال الحلال",
    "wordCount": 8
  },
  {
    "slug": "fsahh",
    "arabicSlug": "تفسير-حلم-فصاحة",
    "name": "فصاحة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه أصبح فصيح اللسان فانه ينال شرفا وعزا",
    "wordCount": 10
  },
  {
    "slug": "fdh",
    "arabicSlug": "تفسير-حلم-فضة",
    "name": "فضة",
    "letter": "ف",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "مال مجموع، والآنية من الفضة متاجر أو أعمال صالحة",
    "wordCount": 9
  },
  {
    "slug": "fz",
    "arabicSlug": "تفسير-حلم-فظ",
    "name": "فظ",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من نعت في المنام بالفظ فان كان متوليا عزل",
    "wordCount": 9
  },
  {
    "slug": "fal-alkhyr",
    "arabicSlug": "تفسير-حلم-فعل-الخير",
    "name": "فعل الخير",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يفعل الخير فانه ينال آملا، ومن رأى انه أنفق مالا في طاعة الله فانه يرزق مالا",
    "wordCount": 19
  },
  {
    "slug": "fqr",
    "arabicSlug": "تفسير-حلم-فقر",
    "name": "فقر",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه فقير نال طعاما كثيرا",
    "wordCount": 7
  },
  {
    "slug": "fls",
    "arabicSlug": "تفسير-حلم-فلس",
    "name": "فلس",
    "letter": "ف",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": "money",
    "text": "هو في المنام كلام مع رياء ومجادلة",
    "wordCount": 7
  },
  {
    "slug": "flfl",
    "arabicSlug": "تفسير-حلم-فلفل",
    "name": "فلفل",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال يحفظ به الأموال، وزمن رأى انه يأكل فلفل فانه يقع في الهم",
    "wordCount": 16
  },
  {
    "slug": "flk",
    "arabicSlug": "تفسير-حلم-فلك",
    "name": "فلك",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأه في منامه انه في الفلك فانه يرتقي ويحصل على ما أراده",
    "wordCount": 13
  },
  {
    "slug": "fm",
    "arabicSlug": "تفسير-حلم-فم",
    "name": "فم",
    "letter": "ف",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دال على مفتاح أمر صاحبه، وما يخرج من الفم فهو من جوهر الكلام في خير أو شر",
    "wordCount": 17
  },
  {
    "slug": "fn",
    "arabicSlug": "تفسير-حلم-فن",
    "name": "فن",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الشفاء والأمن والأنس",
    "wordCount": 5
  },
  {
    "slug": "fna",
    "arabicSlug": "تفسير-حلم-فناء",
    "name": "فناء",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على إبطال الفوائد",
    "wordCount": 4
  },
  {
    "slug": "fhd",
    "arabicSlug": "تفسير-حلم-فهد",
    "name": "فهد",
    "letter": "ف",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "تدل رؤيته على العز والرفعة، ومن رأى انه ينازع الفهد فهو ينازع أنسانا",
    "wordCount": 13
  },
  {
    "slug": "fwth",
    "arabicSlug": "تفسير-حلم-فوطة",
    "name": "فوطة",
    "letter": "ف",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الخادم، وربما دلت علي الحج والعمرة",
    "wordCount": 8
  },
  {
    "slug": "fyl",
    "arabicSlug": "تفسير-حلم-فيل",
    "name": "فيل",
    "letter": "ف",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام ملك مهيب، متحجر القلب، ومن ركب فيلا أو ملكه اتصل بسلطان ونال منزلة عالية",
    "wordCount": 17
  },
  {
    "slug": "qayd",
    "arabicSlug": "تفسير-حلم-قائد",
    "name": "قائد",
    "letter": "ق",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "رجل مشهور، ومن رأى انه قائد ينال خيرا",
    "wordCount": 8
  },
  {
    "slug": "qarwrh",
    "arabicSlug": "تفسير-حلم-قارورة",
    "name": "قارورة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المرأة",
    "wordCount": 3
  },
  {
    "slug": "qary",
    "arabicSlug": "تفسير-حلم-قارئ",
    "name": "قارئ",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على النصح",
    "wordCount": 4
  },
  {
    "slug": "qad",
    "arabicSlug": "تفسير-حلم-قاض",
    "name": "قاض",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه قاضي فعدل فانه يحصل على مرتبة بين الناس",
    "wordCount": 11
  },
  {
    "slug": "qaah",
    "arabicSlug": "تفسير-حلم-قاعة",
    "name": "قاعة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الراحة، وعلى زوال الفقر، وعلى الزوجة المريحة، أو على المنصب الجليل قليل الخطر",
    "wordCount": 15
  },
  {
    "slug": "qbh",
    "arabicSlug": "تفسير-حلم-قبة",
    "name": "قبة",
    "letter": "ق",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هي في المنام امرأة",
    "wordCount": 4
  },
  {
    "slug": "qbr",
    "arabicSlug": "تفسير-حلم-قبر",
    "name": "قبر",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على السجن، ومن حفر قبرا وكان أعزب تزوج",
    "wordCount": 9
  },
  {
    "slug": "qbd-alnfs",
    "arabicSlug": "تفسير-حلم-قبض-النفس",
    "name": "قبض النفس",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المرض أو الموت",
    "wordCount": 5
  },
  {
    "slug": "qbqab",
    "arabicSlug": "تفسير-حلم-قبقاب",
    "name": "قبقاب",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "توبة للعاصي أو خصام أو إظهار سر",
    "wordCount": 7
  },
  {
    "slug": "qblh",
    "arabicSlug": "تفسير-حلم-قبلة",
    "name": "قبلة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام قضاء الحاجة والظفر بالعدو",
    "wordCount": 7
  },
  {
    "slug": "qtl",
    "arabicSlug": "تفسير-حلم-قتل",
    "name": "قتل",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يقتل نفسه تاب، ومن رأى انه يقتل أنسانا فانه يذنب، ومن رأى انه يقتل يطول عمره",
    "wordCount": 19
  },
  {
    "slug": "qdh",
    "arabicSlug": "تفسير-حلم-قدح",
    "name": "قدح",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المرأة ويدل على الخادم وأقداح الذهب والفضة خير من أقداح الزجاج",
    "wordCount": 13
  },
  {
    "slug": "qdr",
    "arabicSlug": "تفسير-حلم-قدر",
    "name": "قدر",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على العالم الجالس على الكرسي وما فيه من اللحم فوائده لمن يتناوله",
    "wordCount": 13
  },
  {
    "slug": "qdm",
    "arabicSlug": "تفسير-حلم-قدم",
    "name": "قدم",
    "letter": "ق",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "زينة مال الرجل وثباته",
    "wordCount": 4
  },
  {
    "slug": "qdwm",
    "arabicSlug": "تفسير-حلم-قدوم",
    "name": "قدوم",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المعيشة والرزق والقدوم",
    "wordCount": 5
  },
  {
    "slug": "qran",
    "arabicSlug": "تفسير-حلم-قرآن",
    "name": "قرآن",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "قراءته تدل على طلب الحق",
    "wordCount": 5
  },
  {
    "slug": "qrd-2",
    "arabicSlug": "تفسير-حلم-قرد",
    "name": "قرد",
    "letter": "ق",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "يدل على الأعداء",
    "wordCount": 3
  },
  {
    "slug": "qraa-alras",
    "arabicSlug": "تفسير-حلم-قراع-الرأس",
    "name": "قراع الرأس",
    "letter": "ق",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام مال من رئيس لا ينتفع به، والمرأة القرعاء سنة قحط",
    "wordCount": 13
  },
  {
    "slug": "qrban",
    "arabicSlug": "تفسير-حلم-قربان",
    "name": "قربان",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الزوجة أو الولد، أو على العداوة والمشاجرة",
    "wordCount": 9
  },
  {
    "slug": "qrbh",
    "arabicSlug": "تفسير-حلم-قربة",
    "name": "قربة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على السفر وربما على المرأة الحامل وتسقط ما في بطنها، وتدل على لفقر والغنى",
    "wordCount": 15
  },
  {
    "slug": "qrsh",
    "arabicSlug": "تفسير-حلم-قرش",
    "name": "قرش",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "سمك القرش يدل على علو الهمة والشرف",
    "wordCount": 7
  },
  {
    "slug": "qrs",
    "arabicSlug": "تفسير-حلم-قرص",
    "name": "قرص",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الخبز يدل على الربح القليل",
    "wordCount": 5
  },
  {
    "slug": "qrd-3",
    "arabicSlug": "تفسير-حلم-قرض",
    "name": "قرض",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على صدقة القارض على المقترض، والقرض يدل على التوبة، ومن رأى انه يقرض الناس لوجه الله فانه ينفق المال في الجهاد",
    "wordCount": 22
  },
  {
    "slug": "qrt",
    "arabicSlug": "تفسير-حلم-قرط",
    "name": "قرط",
    "letter": "ق",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "تجارة لمن رآه في أذن زوجته",
    "wordCount": 6
  },
  {
    "slug": "qra",
    "arabicSlug": "تفسير-حلم-قرع",
    "name": "قرع",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل عالم أو طبيب، وهو للمريض شفاء",
    "wordCount": 9
  },
  {
    "slug": "qrn",
    "arabicSlug": "تفسير-حلم-قرن",
    "name": "قرن",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على القوة",
    "wordCount": 3
  },
  {
    "slug": "qryh",
    "arabicSlug": "تفسير-حلم-قرية",
    "name": "قرية",
    "letter": "ق",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هي في المنام ظلم وهلاك",
    "wordCount": 5
  },
  {
    "slug": "qswh",
    "arabicSlug": "تفسير-حلم-قسوة",
    "name": "قسوة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من وجد في قلبه قسوة فانه الانهماك في المعاصي",
    "wordCount": 9
  },
  {
    "slug": "qshr",
    "arabicSlug": "تفسير-حلم-قشر",
    "name": "قشر",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الكسوة، والقشرة تدل على الإطراء والنفاق",
    "wordCount": 8
  },
  {
    "slug": "qsharyrh",
    "arabicSlug": "تفسير-حلم-قشعريرة",
    "name": "قشعريرة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الخوف",
    "wordCount": 3
  },
  {
    "slug": "qsab",
    "arabicSlug": "تفسير-حلم-قصاب",
    "name": "قصاب",
    "letter": "ق",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دال على ملك الموت من رآه فانه يمرض ويبرأ وينال قوة في حياته",
    "wordCount": 13
  },
  {
    "slug": "qsas",
    "arabicSlug": "تفسير-حلم-قصاص",
    "name": "قصاص",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام عمر طويل",
    "wordCount": 5
  },
  {
    "slug": "qsb",
    "arabicSlug": "تفسير-حلم-قصب",
    "name": "قصب",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أرزال الناس، وقصب السكر يدل على الرزق المتعب، وتدل رؤيته مقشرا على السلامة",
    "wordCount": 15
  },
  {
    "slug": "qt",
    "arabicSlug": "تفسير-حلم-قط",
    "name": "قط",
    "letter": "ق",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "black-cat",
    "text": "دال على الجفاء والخصام وعدم الوفاء، ويدل على الإنسان الملاطف بالكلام والمتحبب",
    "wordCount": 12
  },
  {
    "slug": "qtayf",
    "arabicSlug": "تفسير-حلم-قطائف",
    "name": "قطائف",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المال والرزق",
    "wordCount": 4
  },
  {
    "slug": "qtan",
    "arabicSlug": "تفسير-حلم-قطان",
    "name": "قطان",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام صاحب مال وتعب",
    "wordCount": 6
  },
  {
    "slug": "qtran",
    "arabicSlug": "تفسير-حلم-قطران",
    "name": "قطران",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل يمنع المفسدين",
    "wordCount": 3
  },
  {
    "slug": "qta-alyd",
    "arabicSlug": "تفسير-حلم-قطع-اليد",
    "name": "قطع اليد",
    "letter": "ق",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "يدل على تارك الصلاة",
    "wordCount": 4
  },
  {
    "slug": "qtn",
    "arabicSlug": "تفسير-حلم-قطن",
    "name": "قطن",
    "letter": "ق",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على المال، كما يدل على رجل متواضع",
    "wordCount": 8
  },
  {
    "slug": "qtyah",
    "arabicSlug": "تفسير-حلم-قطيعة",
    "name": "قطيعة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الضلالة، أو الهجرة",
    "wordCount": 5
  },
  {
    "slug": "qfz",
    "arabicSlug": "تفسير-حلم-قفز",
    "name": "قفز",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على التنقل من حال إلى حال",
    "wordCount": 7
  },
  {
    "slug": "qfs",
    "arabicSlug": "تفسير-حلم-قفص",
    "name": "قفص",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام سجن، كما يدل على الدار",
    "wordCount": 8
  },
  {
    "slug": "qfl",
    "arabicSlug": "تفسير-حلم-قفل",
    "name": "قفل",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل صاحب أمانة كما يدل على امرأة بكر لمن عالجه، وإذا رأى فتح القفل فانه ينجو",
    "wordCount": 16
  },
  {
    "slug": "qladh",
    "arabicSlug": "تفسير-حلم-قلادة",
    "name": "قلادة",
    "letter": "ق",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": null,
    "text": "للمرأة زينتها، والقلادة للرجل تدل على الزواج",
    "wordCount": 7
  },
  {
    "slug": "qlb",
    "arabicSlug": "تفسير-حلم-قلب",
    "name": "قلب",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام شجاعة المرء وأمره",
    "wordCount": 6
  },
  {
    "slug": "qlah",
    "arabicSlug": "تفسير-حلم-قلعة",
    "name": "قلعة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الرج والإقلاع عن الذنوب",
    "wordCount": 6
  },
  {
    "slug": "qlq",
    "arabicSlug": "تفسير-حلم-قلق",
    "name": "قلق",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الندم",
    "wordCount": 3
  },
  {
    "slug": "qlm",
    "arabicSlug": "تفسير-حلم-قلم",
    "name": "قلم",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على العلم والأمر والنهي",
    "wordCount": 5
  },
  {
    "slug": "qmar",
    "arabicSlug": "تفسير-حلم-قمار",
    "name": "قمار",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "أمر باطل، والخصومة والنزاع",
    "wordCount": 4
  },
  {
    "slug": "qmh",
    "arabicSlug": "تفسير-حلم-قمح",
    "name": "قمح",
    "letter": "ق",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "رجل محتاط مدبر حكيم",
    "wordCount": 4
  },
  {
    "slug": "qmr",
    "arabicSlug": "تفسير-حلم-قمر",
    "name": "قمر",
    "letter": "ق",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "ملك عادل أو عالم كبير، ومن رأى القمر في حجره تزوج",
    "wordCount": 11
  },
  {
    "slug": "qml",
    "arabicSlug": "تفسير-حلم-قمل",
    "name": "قمل",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "القمل الكثير عذاب، أو مرض طويل، ومن قرصه القمل فان الناس يرمونه بكلام",
    "wordCount": 13
  },
  {
    "slug": "qmys",
    "arabicSlug": "تفسير-حلم-قميص",
    "name": "قميص",
    "letter": "ق",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": "clothes",
    "text": "هو في المنام دين الرجل أو تقواه، أو بشارة له، والقميص للمرأة رجل تتزوجه قناع : هو في المنام قناعة تناله",
    "wordCount": 21
  },
  {
    "slug": "qndyl",
    "arabicSlug": "تفسير-حلم-قنديل",
    "name": "قنديل",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على ولد أو زوج، كما يدل على العلم والتوبة والهداية",
    "wordCount": 11
  },
  {
    "slug": "qns",
    "arabicSlug": "تفسير-حلم-قنص",
    "name": "قنص",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الغفلة، أو إتباع الشهوات",
    "wordCount": 6
  },
  {
    "slug": "qntrh",
    "arabicSlug": "تفسير-حلم-قنطرة",
    "name": "قنطرة",
    "letter": "ق",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "دالة على الشبهات وربما دلت على الدنيا، وربما دلت على الزوجة أو تفريج الهموم",
    "wordCount": 14
  },
  {
    "slug": "qnfdh",
    "arabicSlug": "تفسير-حلم-قنفذ",
    "name": "قنفذ",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل ضيق القلب قليل الرحمة سريع الغضب، كما تدل رؤيته على المكر والخديعة",
    "wordCount": 13
  },
  {
    "slug": "qnwt-2",
    "arabicSlug": "تفسير-حلم-قنوت",
    "name": "قنوت",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على إجابة السؤال",
    "wordCount": 4
  },
  {
    "slug": "qnwt-3",
    "arabicSlug": "تفسير-حلم-قنوط",
    "name": "قنوط",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دال على الشرك بالله أو قتل النفس أو الوقوع في المحظور",
    "wordCount": 14
  },
  {
    "slug": "qwad",
    "arabicSlug": "تفسير-حلم-قواد",
    "name": "قواد",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الانتقال من الأمكنة الصالحة إلى الأمكنة الرديئة، والقوادة تدل رؤيتها على رغد العيش",
    "wordCount": 16
  },
  {
    "slug": "qwh",
    "arabicSlug": "تفسير-حلم-قوة",
    "name": "قوة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على طول المرض أو الضعف",
    "wordCount": 6
  },
  {
    "slug": "qws",
    "arabicSlug": "تفسير-حلم-قوس",
    "name": "قوس",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام سفر وأخ وامرأة وولد",
    "wordCount": 7
  },
  {
    "slug": "qws-qzh",
    "arabicSlug": "تفسير-حلم-قوس-قزح",
    "name": "قوس قزح",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل في المنام على الأمان من الخوف",
    "wordCount": 7
  },
  {
    "slug": "qy",
    "arabicSlug": "تفسير-حلم-قيء",
    "name": "قيء",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه تقيأ وهو صائم فان عليه دينا يمكنه أن يؤديه",
    "wordCount": 12
  },
  {
    "slug": "qyamh",
    "arabicSlug": "تفسير-حلم-قيامة",
    "name": "قيامة",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "نذير وتحذير لمن رآها من معصية، والقيامة عدل وإنصاف، ومن رأى القيامة قامت عليه وحده فتنه يموت",
    "wordCount": 17
  },
  {
    "slug": "qyh",
    "arabicSlug": "تفسير-حلم-قيح",
    "name": "قيح",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "مال ينمو، وربما يدل القيح الخارج من جسم الإنسان على قذفه بتهمة",
    "wordCount": 12
  },
  {
    "slug": "qyd",
    "arabicSlug": "تفسير-حلم-قيد",
    "name": "قيد",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الثبات في الدين، ويدل القيد على الإحسان ممن قيده",
    "wordCount": 11
  },
  {
    "slug": "qyrat",
    "arabicSlug": "تفسير-حلم-قيراط",
    "name": "قيراط",
    "letter": "ق",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام نكد يناله من جهة دين في ذمته",
    "wordCount": 10
  },
  {
    "slug": "kas",
    "arabicSlug": "تفسير-حلم-كأس",
    "name": "كأس",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المرأة، ومن رأى أنه أعطي ماء في كأس فدل على ولد في بطن أمه",
    "wordCount": 16
  },
  {
    "slug": "katb",
    "arabicSlug": "تفسير-حلم-كاتب",
    "name": "كاتب",
    "letter": "ك",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "رجل يحتال فأن رأى كاتب انه أمي فتذهب حيلته أو عقله أو يفتقر، ومن رأى انه كاتب فهو ينال تدبير أموره",
    "wordCount": 21
  },
  {
    "slug": "kafr",
    "arabicSlug": "تفسير-حلم-كافر",
    "name": "كافر",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على العدو",
    "wordCount": 3
  },
  {
    "slug": "kafwr",
    "arabicSlug": "تفسير-حلم-كافور",
    "name": "كافور",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الكافور يدل على صدقة السر، وإذا رئي مع الإنسان كان دليل على الأعمال الصالحة",
    "wordCount": 14
  },
  {
    "slug": "kanwn",
    "arabicSlug": "تفسير-حلم-كانون",
    "name": "كانون",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "كانون الحديد دال على امرأة من بيت ذوي قوة وبأس",
    "wordCount": 10
  },
  {
    "slug": "kahn",
    "arabicSlug": "تفسير-حلم-كاهن",
    "name": "كاهن",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الإيمان والتخلي عن الدنيا والشبهات",
    "wordCount": 7
  },
  {
    "slug": "kbd",
    "arabicSlug": "تفسير-حلم-كبد",
    "name": "كبد",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه كبير الكبد فانه رحيم، ومن رأى انه جرحت كبده فان يظهر له مال مدفون",
    "wordCount": 17
  },
  {
    "slug": "kbryt",
    "arabicSlug": "تفسير-حلم-كبريت",
    "name": "كبريت",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل كذاب",
    "wordCount": 4
  },
  {
    "slug": "kbsh",
    "arabicSlug": "تفسير-حلم-كبش",
    "name": "كبش",
    "letter": "ك",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على الرجل الشريف",
    "wordCount": 4
  },
  {
    "slug": "ktab",
    "arabicSlug": "تفسير-حلم-كتاب",
    "name": "كتاب",
    "letter": "ك",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "الكاتب هو في المنام حيلة، والكاتب محتال، وإذا رأى انه رديء الخط فانه يتوب، ومن رأى انه يكتب في صحيفة فانه يرث مالا",
    "wordCount": 23
  },
  {
    "slug": "ktan",
    "arabicSlug": "تفسير-حلم-كتان",
    "name": "كتان",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يلبس قميص من كتان فانه ينال معيشة شريفة",
    "wordCount": 11
  },
  {
    "slug": "ktf",
    "arabicSlug": "تفسير-حلم-كتف",
    "name": "كتف",
    "letter": "ك",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة، وقيل الكتفان يفسران بالقوة فما حدث فيهما من نقص أو زيادة فانسبه إلى قوة الإنسان",
    "wordCount": 19
  },
  {
    "slug": "ktman-alasrar",
    "arabicSlug": "تفسير-حلم-كتمان-الأسرار",
    "name": "كتمان الأسرار",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على كتمان العلم عن أهله كما يدل على طيب الأصل",
    "wordCount": 11
  },
  {
    "slug": "kthrh-aladd",
    "arabicSlug": "تفسير-حلم-كثرة-العدد",
    "name": "كثرة العدد",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى الزحام فنه تكثر معاونيه وتعظم مرتبته",
    "wordCount": 8
  },
  {
    "slug": "khl-3",
    "arabicSlug": "تفسير-حلم-كحل",
    "name": "كحل",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال وزيادة تبصر في الصلاح، والبكر إذا اكتحلت فإنها تتزوج",
    "wordCount": 13
  },
  {
    "slug": "kd",
    "arabicSlug": "تفسير-حلم-كد",
    "name": "كد",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يكد ويتعب فهو راحة، وربما دل على الوقوع في الخطاء",
    "wordCount": 13
  },
  {
    "slug": "kdhb",
    "arabicSlug": "تفسير-حلم-كذب",
    "name": "كذب",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على شهادة الزور والافتراء",
    "wordCount": 5
  },
  {
    "slug": "kr",
    "arabicSlug": "تفسير-حلم-كر",
    "name": "كر",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "عكس الفر ويدل على عدوه بعد فراره",
    "wordCount": 7
  },
  {
    "slug": "krawya",
    "arabicSlug": "تفسير-حلم-كراويا",
    "name": "كراويا",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على المال الطيب",
    "wordCount": 4
  },
  {
    "slug": "krb",
    "arabicSlug": "تفسير-حلم-كرب",
    "name": "كرب",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه مكروب فقد أذنب ذنبا وهو نادم عليه",
    "wordCount": 10
  },
  {
    "slug": "krh",
    "arabicSlug": "تفسير-حلم-كرة",
    "name": "كرة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على المخاصمة، كما تدل على السفر",
    "wordCount": 7
  },
  {
    "slug": "krsy",
    "arabicSlug": "تفسير-حلم-كرسي",
    "name": "كرسي",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرفعة في المقام من قبل السلطان أو امرأة",
    "wordCount": 10
  },
  {
    "slug": "krfs",
    "arabicSlug": "تفسير-حلم-كرفس",
    "name": "كرفس",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال من جهة السلطان",
    "wordCount": 7
  },
  {
    "slug": "krm",
    "arabicSlug": "تفسير-حلم-كرم",
    "name": "كرم",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "العنب عز وشرف لمن غرسه، والكرم يعبر بامرأة موسرة الحال",
    "wordCount": 10
  },
  {
    "slug": "krnb",
    "arabicSlug": "تفسير-حلم-كرنب",
    "name": "كرنب",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل ضخم فظ، رديء لجميع الناس",
    "wordCount": 6
  },
  {
    "slug": "kzbrh",
    "arabicSlug": "تفسير-حلم-كزبرة",
    "name": "كزبرة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام رجل نافع في الدين والدنيا",
    "wordCount": 8
  },
  {
    "slug": "ksa",
    "arabicSlug": "تفسير-حلم-كساء",
    "name": "كساء",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام كسوة وهو في الشتاء أجود من الصيف، ومن رأى ارتدى بكساء أو التف به ولم يكن ذلك من عادته فانه يفتقر",
    "wordCount": 24
  },
  {
    "slug": "kswf",
    "arabicSlug": "تفسير-حلم-كسوف",
    "name": "كسوف",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الشمس والقمر من رأى أن الشمس كسفت فهو تخويف للعباد",
    "wordCount": 10
  },
  {
    "slug": "kzm-alghyz",
    "arabicSlug": "تفسير-حلم-كظم-الغيظ",
    "name": "كظم الغيظ",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الثناء الجميل والخير",
    "wordCount": 5
  },
  {
    "slug": "kab",
    "arabicSlug": "تفسير-حلم-كعب",
    "name": "كعب",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على المقامر، وربما يدل على موت أو مصيبة، كما يدل الكعب المنخفض على القوة والشجاعة، والكعب للأعزب زوجة",
    "wordCount": 19
  },
  {
    "slug": "kabh",
    "arabicSlug": "تفسير-حلم-كعبة",
    "name": "كعبة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام خليفة أو رئيس، ومن رأى انه يصلي فيها فانه يؤمن من الأعداء",
    "wordCount": 15
  },
  {
    "slug": "kak",
    "arabicSlug": "تفسير-حلم-كعك",
    "name": "كعك",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من لا يقدر على أكله دليل على الهم والنكد",
    "wordCount": 9
  },
  {
    "slug": "kf-alyd",
    "arabicSlug": "تفسير-حلم-كف-اليد",
    "name": "كف اليد",
    "letter": "ك",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "قوة الرجل، وانبساط اليد دنياه",
    "wordCount": 5
  },
  {
    "slug": "kf-an-alshr",
    "arabicSlug": "تفسير-حلم-كف-عن-الشر",
    "name": "كف عن الشر",
    "letter": "ك",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دليل على التسليم لأوامر الله",
    "wordCount": 5
  },
  {
    "slug": "kfarh",
    "arabicSlug": "تفسير-حلم-كفارة",
    "name": "كفارة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على قضاء الدين من صوم أو حج أو صدقة",
    "wordCount": 10
  },
  {
    "slug": "kfalh",
    "arabicSlug": "تفسير-حلم-كفالة",
    "name": "كفالة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من تكفل في المنام بإنسان فيدل على الرزق",
    "wordCount": 8
  },
  {
    "slug": "kfr",
    "arabicSlug": "تفسير-حلم-كفر",
    "name": "كفر",
    "letter": "ك",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام غنى، والكفر مرض لا ينجو منه صاحبه",
    "wordCount": 10
  },
  {
    "slug": "kfn",
    "arabicSlug": "تفسير-حلم-كفن",
    "name": "كفن",
    "letter": "ك",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام ستر العورة، ومن رأى عليه كفن فانه يميل إلى الزنا، فان لم يتم لبسه فانه يدعى إلى الزنا ولا يستجيب",
    "wordCount": 23
  },
  {
    "slug": "klam",
    "arabicSlug": "تفسير-حلم-كلام",
    "name": "كلام",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رأى انه يتكلم بلغات عديدة فدليل على انه يملك ملكا عظيما، ومن رأى الطير يتكلم ارتفع شأنه",
    "wordCount": 18
  },
  {
    "slug": "klb",
    "arabicSlug": "تفسير-حلم-كلب",
    "name": "كلب",
    "letter": "ك",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "dog",
    "text": "هو في المنام رجل سفيه",
    "wordCount": 5
  },
  {
    "slug": "klyh",
    "arabicSlug": "تفسير-حلم-كلية",
    "name": "كلية",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام معين ومساعد، وفقد احد الكليتين فقد المعين",
    "wordCount": 10
  },
  {
    "slug": "km",
    "arabicSlug": "تفسير-حلم-كم",
    "name": "كم",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المال، فان رأى إن كمه واسع اتسع رزقه، وشق الكم فقر",
    "wordCount": 13
  },
  {
    "slug": "kmah",
    "arabicSlug": "تفسير-حلم-كمأة",
    "name": "كمأة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الرجل الوفي، وقيل امرأة لا خير فيها، ومن رأى أنه يأكل الكمأة فانه يكسب مال حلال",
    "wordCount": 18
  },
  {
    "slug": "kmthra",
    "arabicSlug": "تفسير-حلم-كمثرى",
    "name": "كمثرى",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام دالة على المال والنعمة",
    "wordCount": 7
  },
  {
    "slug": "knz",
    "arabicSlug": "تفسير-حلم-كنز",
    "name": "كنز",
    "letter": "ك",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "هو في المنام علم فمن رأى أنه لقي كنزا فانه يصيب علما، وان كان تاجرا فانه يرزق",
    "wordCount": 17
  },
  {
    "slug": "kns",
    "arabicSlug": "تفسير-حلم-كنس",
    "name": "كنس",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل خير لمن أعماله وسخة ولأهل الحرفة، ومن كنس بيت غيره نال من ماله والكنس للأغنياء فقر",
    "wordCount": 17
  },
  {
    "slug": "knysh",
    "arabicSlug": "تفسير-حلم-كنيسة",
    "name": "كنيسة",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي عند أهلها دالة على العلم والزهد",
    "wordCount": 7
  },
  {
    "slug": "khf-3",
    "arabicSlug": "تفسير-حلم-كهف",
    "name": "كهف",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على من يأوي الإنسان إليه، ويدل على ستر الأمور",
    "wordCount": 10
  },
  {
    "slug": "kwz",
    "arabicSlug": "تفسير-حلم-كوز",
    "name": "كوز",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام جارية أو خادم أو غلام، فمن شرب منها استفاد مالا",
    "wordCount": 13
  },
  {
    "slug": "kwkb",
    "arabicSlug": "تفسير-حلم-كوكب",
    "name": "كوكب",
    "letter": "ك",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "من رأى الكواكب اجتمع عنده كبار القوم",
    "wordCount": 7
  },
  {
    "slug": "ky",
    "arabicSlug": "تفسير-حلم-كي",
    "name": "كي",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دليل على منع الزكاة، وان كوي بحديد دل على الذنوب والمعاصي",
    "wordCount": 14
  },
  {
    "slug": "kys",
    "arabicSlug": "تفسير-حلم-كيس",
    "name": "كيس",
    "letter": "ك",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام بدن الإنسان",
    "wordCount": 5
  },
  {
    "slug": "lwlw",
    "arabicSlug": "تفسير-حلم-لؤلؤ",
    "name": "لؤلؤ",
    "letter": "ل",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "إذا كان منظوما فهو في المنام القران أو العلم أو الولد",
    "wordCount": 11
  },
  {
    "slug": "lbad",
    "arabicSlug": "تفسير-حلم-لباد",
    "name": "لباد",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الصبر، ورؤيته دليل على الرزق والفائدة",
    "wordCount": 8
  },
  {
    "slug": "lbs",
    "arabicSlug": "تفسير-حلم-لبس",
    "name": "لبس",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام شأن الرجل في دينه",
    "wordCount": 7
  },
  {
    "slug": "lbn",
    "arabicSlug": "تفسير-حلم-لبن",
    "name": "لبن",
    "letter": "ل",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": "milk",
    "text": "دال على المال الحلال، واللبن الرائب مال حرام ومن رأي في ثديه لبن فانه يجمع مالا",
    "wordCount": 16
  },
  {
    "slug": "lbwh",
    "arabicSlug": "تفسير-حلم-لبوة",
    "name": "لبوة",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة شريرة فمن رأى انه يجامع لبوة فانه ينجو من شدة عظيمة",
    "wordCount": 12
  },
  {
    "slug": "lhaf",
    "arabicSlug": "تفسير-حلم-لحاف",
    "name": "لحاف",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة يلتف بها الرجل",
    "wordCount": 7
  },
  {
    "slug": "lham",
    "arabicSlug": "تفسير-حلم-لحام",
    "name": "لحام",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الأمن من الخوف",
    "wordCount": 6
  },
  {
    "slug": "lhs",
    "arabicSlug": "تفسير-حلم-لحس",
    "name": "لحس",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الأصابع في المنام وغيرها رزق يسير من جوهر ما لحس في منامه",
    "wordCount": 12
  },
  {
    "slug": "lhm",
    "arabicSlug": "تفسير-حلم-لحم",
    "name": "لحم",
    "letter": "ل",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": "meat",
    "text": "هو في المنام مال إذا كان مطبوخا واللحم النيئ كله أوجاع وأمراض",
    "wordCount": 12
  },
  {
    "slug": "lhyh",
    "arabicSlug": "تفسير-حلم-لحية",
    "name": "لحية",
    "letter": "ل",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هي في المنام للرجل غنى وعز، والمرأة إذا رأت إن لها لحية وكانت متزوجة فإنها تفقد زوجها، وان كانت أرملة فإنها تتزوج",
    "wordCount": 22
  },
  {
    "slug": "ldgh",
    "arabicSlug": "تفسير-حلم-لدغ",
    "name": "لدغ",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "حية أو عقرب دال على ارتكاب الغلط",
    "wordCount": 7
  },
  {
    "slug": "lsan",
    "arabicSlug": "تفسير-حلم-لسان",
    "name": "لسان",
    "letter": "ل",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام ترجمان صاحبه ومدبر أموره",
    "wordCount": 7
  },
  {
    "slug": "ls",
    "arabicSlug": "تفسير-حلم-لص",
    "name": "لص",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل مخادع، وربما دل على الشيطان",
    "wordCount": 6
  },
  {
    "slug": "ltm",
    "arabicSlug": "تفسير-حلم-لطم",
    "name": "لطم",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تنبيه من غفلة وهو منفعة ولطم المرأة على وجهها دال على البشارة بالولد الذكر",
    "wordCount": 14
  },
  {
    "slug": "lab",
    "arabicSlug": "تفسير-حلم-لعب",
    "name": "لعب",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الغرور والاستهزاء",
    "wordCount": 4
  },
  {
    "slug": "laq",
    "arabicSlug": "تفسير-حلم-لعق",
    "name": "لعق",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "الماء أو اللبن وما شابهه دل ذلك على الكسب اليسير",
    "wordCount": 10
  },
  {
    "slug": "lghw",
    "arabicSlug": "تفسير-حلم-لغو",
    "name": "لغو",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دال على المعصية وعدم قبول النصح",
    "wordCount": 9
  },
  {
    "slug": "lft",
    "arabicSlug": "تفسير-حلم-لفت",
    "name": "لفت",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على امرأة قروية، واللفت ألفة",
    "wordCount": 6
  },
  {
    "slug": "lqah",
    "arabicSlug": "تفسير-حلم-لقاح",
    "name": "لقاح",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مرض ودنانير",
    "wordCount": 5
  },
  {
    "slug": "lqth",
    "arabicSlug": "تفسير-حلم-لقطة",
    "name": "لقطة",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الأشياء النفيسة يقتنيها الرأي أو ولد مبارك أو ميراث",
    "wordCount": 11
  },
  {
    "slug": "lqyt",
    "arabicSlug": "تفسير-حلم-لقيط",
    "name": "لقيط",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على العدو",
    "wordCount": 3
  },
  {
    "slug": "lkm",
    "arabicSlug": "تفسير-حلم-لكم",
    "name": "لكم",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الكلام الفاحش",
    "wordCount": 4
  },
  {
    "slug": "lwat",
    "arabicSlug": "تفسير-حلم-لواط",
    "name": "لواط",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أنه أتى غلاما فانه يصير أجيرا ويذهب رأس ماله، وان رأى انه ينكح شابا معروفا فان الفاعل يفعل بالمفعول خيرا",
    "wordCount": 24
  },
  {
    "slug": "lwh",
    "arabicSlug": "تفسير-حلم-لوح",
    "name": "لوح",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية اللوح المحفوظ في المنام دليل على الستر، وتدل رؤيته على البشارة لمن هو في شدة",
    "wordCount": 16
  },
  {
    "slug": "lwz",
    "arabicSlug": "تفسير-حلم-لوز",
    "name": "لوز",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على زوال الأمراض أو العزل لوم : دال على تتبع الشيطان",
    "wordCount": 12
  },
  {
    "slug": "lyf",
    "arabicSlug": "تفسير-حلم-ليف",
    "name": "ليف",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "النخلة هو في المنام كسوة للمرأة أو الرجل",
    "wordCount": 8
  },
  {
    "slug": "lyl",
    "arabicSlug": "تفسير-حلم-ليل",
    "name": "ليل",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على السكن والراحة، ورؤية ليلة القدر بشارة خير",
    "wordCount": 9
  },
  {
    "slug": "lymwn",
    "arabicSlug": "تفسير-حلم-ليمون",
    "name": "ليمون",
    "letter": "ل",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المرض، والليمون الأخضر خير من الأصفر، وشجر الليمون رجل نافع للناس",
    "wordCount": 13
  },
  {
    "slug": "mwdb",
    "arabicSlug": "تفسير-حلم-مؤدب",
    "name": "مؤدب",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دال على نفسه، وربما دل على القدوة أو الوالد",
    "wordCount": 12
  },
  {
    "slug": "mwdhn",
    "arabicSlug": "تفسير-حلم-مؤذن",
    "name": "مؤذن",
    "letter": "م",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دال على لداعي إلى الخير أو السمسار",
    "wordCount": 7
  },
  {
    "slug": "maydh",
    "arabicSlug": "تفسير-حلم-مائدة",
    "name": "مائدة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام نعمة وإجابة دعوة",
    "wordCount": 6
  },
  {
    "slug": "ma",
    "arabicSlug": "تفسير-حلم-ماء",
    "name": "ماء",
    "letter": "م",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": "water",
    "text": "هو في المنام حياة طيبة فمن رآه فهو سعادة وزيادة خير",
    "wordCount": 11
  },
  {
    "slug": "mbarzh",
    "arabicSlug": "تفسير-حلم-مبارزة",
    "name": "مبارزة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على القوة أو الخصومة",
    "wordCount": 5
  },
  {
    "slug": "mbayah",
    "arabicSlug": "تفسير-حلم-مبايعة",
    "name": "مبايعة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يبايع أهل البيت فانه يتبع الهدى",
    "wordCount": 9
  },
  {
    "slug": "mbrd",
    "arabicSlug": "تفسير-حلم-مبرد",
    "name": "مبرد",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على اللسان، والمبرد قضاء حاجة، كما يدل على النكاح",
    "wordCount": 10
  },
  {
    "slug": "mbyd",
    "arabicSlug": "تفسير-حلم-مبيض",
    "name": "مبيض",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الأعمال الطيبة",
    "wordCount": 4
  },
  {
    "slug": "mtah",
    "arabicSlug": "تفسير-حلم-متعة",
    "name": "متعة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام رائحة ومنفعة لمن يفعلها",
    "wordCount": 7
  },
  {
    "slug": "mthqal",
    "arabicSlug": "تفسير-حلم-مثقال",
    "name": "مثقال",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الأمر بالمعروف والنهي عن المنكر",
    "wordCount": 7
  },
  {
    "slug": "mjaah",
    "arabicSlug": "تفسير-حلم-مجاعة",
    "name": "مجاعة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على ذل الناس والطمع في أموالهم، والمجاعة من العلماء تدل على حبهم للعلم",
    "wordCount": 14
  },
  {
    "slug": "mjamah",
    "arabicSlug": "تفسير-حلم-مجامعة",
    "name": "مجامعة",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "من رأى انه يجامع نفسه بذكر دل على نزول الهمة، وان كان فقير دل على مرض شديد",
    "wordCount": 17
  },
  {
    "slug": "mjrfh",
    "arabicSlug": "تفسير-حلم-مجرفة",
    "name": "مجرفة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام زوجة للأعزب لا تحفظ سرا ولا مالا، وقد تدل على زوال الهم وقضاء الدين، ومن رأى بيده مجرفة صار إليه كل خير",
    "wordCount": 25
  },
  {
    "slug": "mjld",
    "arabicSlug": "تفسير-حلم-مجلد",
    "name": "مجلد",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن لديه مجلد كتب فانه يستقيم امرأة",
    "wordCount": 9
  },
  {
    "slug": "mjls",
    "arabicSlug": "تفسير-حلم-مجلس",
    "name": "مجلس",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى في المنام أن له مجلس وعظ وهو غير مؤهل فانه في هم ومرض",
    "wordCount": 15
  },
  {
    "slug": "mjmrh",
    "arabicSlug": "تفسير-حلم-مجمرة",
    "name": "مجمرة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام جارية أديبة أو غلام أديب وكل من صاحبها نال منهما ثناء حسنا",
    "wordCount": 15
  },
  {
    "slug": "mhrab",
    "arabicSlug": "تفسير-حلم-محراب",
    "name": "محراب",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هو في المنام رجل إمام، فمن رأى انه يصلي في المحراب فهو بشارة خير",
    "wordCount": 14
  },
  {
    "slug": "mhshw",
    "arabicSlug": "تفسير-حلم-محشو",
    "name": "محشو",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الأموال المكتسبة",
    "wordCount": 4
  },
  {
    "slug": "mkh",
    "arabicSlug": "تفسير-حلم-مخ",
    "name": "مخ",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ذخائر موروثة، وان كان مريضا نهضت قوته",
    "wordCount": 10
  },
  {
    "slug": "mkhat",
    "arabicSlug": "تفسير-حلم-مخاط",
    "name": "مخاط",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه أمتخط بيده على الأرض فان امرأته تلد بنتا، كما يدل المخاط على قضاء الدين",
    "wordCount": 17
  },
  {
    "slug": "mkhdh",
    "arabicSlug": "تفسير-حلم-مخدة",
    "name": "مخدة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام زوج ومال محفوظ وصاحبة سر وراحة من التعب",
    "wordCount": 11
  },
  {
    "slug": "mkhlb-altyr",
    "arabicSlug": "تفسير-حلم-مخلب-الطير",
    "name": "مخلب الطير",
    "letter": "م",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام نصرة للمخاصم",
    "wordCount": 5
  },
  {
    "slug": "mdbghh",
    "arabicSlug": "تفسير-حلم-مدبغة",
    "name": "مدبغة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على دار العلم، أو المرأة كثيرة الكد الصبورة",
    "wordCount": 9
  },
  {
    "slug": "mdrsh",
    "arabicSlug": "تفسير-حلم-مدرسة",
    "name": "مدرسة",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "تدل على مدرسها وفقهائها، وربما دلت على طلاق الأزواج",
    "wordCount": 9
  },
  {
    "slug": "mdynh",
    "arabicSlug": "تفسير-حلم-مدينة",
    "name": "مدينة",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "النبي من رآها في المنام ونزل فيها فهو خير في الدنيا مذلة : دليل على الضعف في الدين",
    "wordCount": 18
  },
  {
    "slug": "mdhy",
    "arabicSlug": "تفسير-حلم-مذي",
    "name": "مذي",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مثل المني فيعبر بمال أو براحة أو تفريط في ماله وإفشاء سره، والمذي مال ترجى زيادته مع يسر",
    "wordCount": 21
  },
  {
    "slug": "mrah-2",
    "arabicSlug": "تفسير-حلم-مرآة",
    "name": "مرآة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام خيال وغرور",
    "wordCount": 5
  },
  {
    "slug": "mrah-3",
    "arabicSlug": "تفسير-حلم-مرأة",
    "name": "مرأة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا كانت جميلة دالة على السنة المقبلة بالخير",
    "wordCount": 8
  },
  {
    "slug": "mrj",
    "arabicSlug": "تفسير-حلم-مرج",
    "name": "مرج",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام رزق بغير تعب أو زوجة قليلة المؤن، والمروج هو الدنيا وزينتها",
    "wordCount": 14
  },
  {
    "slug": "mrjan",
    "arabicSlug": "تفسير-حلم-مرجان",
    "name": "مرجان",
    "letter": "م",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "مال وخيرات كثيرة",
    "wordCount": 3
  },
  {
    "slug": "mrjwhh",
    "arabicSlug": "تفسير-حلم-مرجوحة",
    "name": "مرجوحة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه في مرجوحة فهو في ضلالة من دينه لا يدري ما يصنع",
    "wordCount": 14
  },
  {
    "slug": "mrhad",
    "arabicSlug": "تفسير-حلم-مرحاض",
    "name": "مرحاض",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام دال على فرج أهله وشدتهم وسعيهم",
    "wordCount": 9
  },
  {
    "slug": "mrd",
    "arabicSlug": "تفسير-حلم-مرض",
    "name": "مرض",
    "letter": "م",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام نفاق، ومن رأى انه مريض نقص دينه وصح جسمه",
    "wordCount": 12
  },
  {
    "slug": "mrkb-albhr",
    "arabicSlug": "تفسير-حلم-مركب-البحر",
    "name": "مركب البحر",
    "letter": "م",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "المركب دال على الرزق والفائدة",
    "wordCount": 5
  },
  {
    "slug": "mrwhh",
    "arabicSlug": "تفسير-حلم-مروحة",
    "name": "مروحة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام تدل على الراحة والفرج من الشدائد والغنى بعد الفقر",
    "wordCount": 12
  },
  {
    "slug": "mzmar",
    "arabicSlug": "تفسير-حلم-مزمار",
    "name": "مزمار",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته في المنام على اللهو واللعب وإثارة الفتن",
    "wordCount": 9
  },
  {
    "slug": "msamyr",
    "arabicSlug": "تفسير-حلم-مسامير",
    "name": "مسامير",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل يؤلف بين الناس في المودة",
    "wordCount": 6
  },
  {
    "slug": "msjd",
    "arabicSlug": "تفسير-حلم-مسجد",
    "name": "مسجد",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "هو رجل عالم",
    "wordCount": 3
  },
  {
    "slug": "msk",
    "arabicSlug": "تفسير-حلم-مسك",
    "name": "مسك",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على صدقة السر والحمل بالأولاد، وربما دل في الميت على انه في الجنة، وربما دل على التجارة",
    "wordCount": 18
  },
  {
    "slug": "mslkh",
    "arabicSlug": "تفسير-حلم-مسلخ",
    "name": "مسلخ",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "لا خير في رؤيته لذهاب الأرواح فيه، وربما دلت رؤيته على قضاء الحوائج",
    "wordCount": 13
  },
  {
    "slug": "msn",
    "arabicSlug": "تفسير-حلم-مسن",
    "name": "مسن",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام تدل رؤيته على الهداية إلى الرشد",
    "wordCount": 9
  },
  {
    "slug": "mshatmh",
    "arabicSlug": "تفسير-حلم-مشاتمة",
    "name": "مشاتمة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه شتم رجلا بما لا يحل فان المشتوم يظفر بالشاتم",
    "wordCount": 12
  },
  {
    "slug": "mshat",
    "arabicSlug": "تفسير-حلم-مشاط",
    "name": "مشاط",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجلي عن الناس همومهم، والماشطة امرأة مستورة",
    "wordCount": 7
  },
  {
    "slug": "mshtry",
    "arabicSlug": "تفسير-حلم-مشتري",
    "name": "مشتري",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مضطر، ومن رأى انه يشتري شيئا ويبيع فانه مضطر محتاج",
    "wordCount": 13
  },
  {
    "slug": "msht",
    "arabicSlug": "تفسير-حلم-مشط",
    "name": "مشط",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل نافع مسلي عن الهموم",
    "wordCount": 7
  },
  {
    "slug": "mshy",
    "arabicSlug": "تفسير-حلم-مشي",
    "name": "مشي",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يمشي مستويا فانه يطلب شرائع الإسلام ويرزق خيرا مص : من رأى إن إنسانا يمصه فانه يأخذ مالا منه، فان مص ثديه فانه يأخذ من امرأته مالا",
    "wordCount": 30
  },
  {
    "slug": "msahbh",
    "arabicSlug": "تفسير-حلم-مصاحبة",
    "name": "مصاحبة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إن رأى المريض في المنام انه يصاحب غيره فهو دليل برئه، وان رأى انه يصاحب أهل بيته فهو دليل رديء",
    "wordCount": 20
  },
  {
    "slug": "msarah",
    "arabicSlug": "تفسير-حلم-مصارعة",
    "name": "مصارعة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "في المنام هي مخاصمة",
    "wordCount": 4
  },
  {
    "slug": "msafhh",
    "arabicSlug": "تفسير-حلم-مصافحة",
    "name": "مصافحة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الفائدة والمبايعة والالتزام بالخير",
    "wordCount": 6
  },
  {
    "slug": "msalhh",
    "arabicSlug": "تفسير-حلم-مصالحة",
    "name": "مصالحة",
    "letter": "م",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "هي في المنام خصومة",
    "wordCount": 4
  },
  {
    "slug": "mshf",
    "arabicSlug": "تفسير-حلم-مصحف",
    "name": "مصحف",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه مزق مصحفا فهو دليل على انه جاحد",
    "wordCount": 10
  },
  {
    "slug": "msfah",
    "arabicSlug": "تفسير-حلم-مصفاة",
    "name": "مصفاة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام خادم جليل",
    "wordCount": 5
  },
  {
    "slug": "mswr",
    "arabicSlug": "تفسير-حلم-مصور",
    "name": "مصور",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الظلم والعذاب",
    "wordCount": 5
  },
  {
    "slug": "mdgh",
    "arabicSlug": "تفسير-حلم-مضغ",
    "name": "مضغ",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على مرض وعدم قبول للقوت، كما يدل على مال فيه كلام ويزداد حتى يصير منازعة",
    "wordCount": 16
  },
  {
    "slug": "mtr",
    "arabicSlug": "تفسير-حلم-مطر",
    "name": "مطر",
    "letter": "م",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": "rain",
    "text": "إذا لم يحصل فيه ضرر فهو خير ورزق",
    "wordCount": 8
  },
  {
    "slug": "mtrqh",
    "arabicSlug": "تفسير-حلم-مطرقة",
    "name": "مطرقة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على العون والرزق لأربابها، وربما دلت على الشر واللغط في الكلام",
    "wordCount": 12
  },
  {
    "slug": "majwn",
    "arabicSlug": "تفسير-حلم-معجون",
    "name": "معجون",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على لشفاء من الأمراض وعلى كثرة النسل",
    "wordCount": 8
  },
  {
    "slug": "madh",
    "arabicSlug": "تفسير-حلم-معدة",
    "name": "معدة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "عمر ورزق",
    "wordCount": 2
  },
  {
    "slug": "masrh",
    "arabicSlug": "تفسير-حلم-معصرة",
    "name": "معصرة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا بنيت المعاصر في المدينة فهي دليل على الخصب وعدمها دليل على القحط",
    "wordCount": 13
  },
  {
    "slug": "masm-almrah",
    "arabicSlug": "تفسير-حلم-معصم-المرأة",
    "name": "معصم المرأة",
    "letter": "م",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "دليل على زوجها، أو ما تجعله فيه من سوار وغيره",
    "wordCount": 10
  },
  {
    "slug": "malaq",
    "arabicSlug": "تفسير-حلم-معلاق",
    "name": "معلاق",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال مجموع من كل نوع",
    "wordCount": 8
  },
  {
    "slug": "malm",
    "arabicSlug": "تفسير-حلم-معلم",
    "name": "معلم",
    "letter": "م",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دال على صاحب المعروف",
    "wordCount": 4
  },
  {
    "slug": "mghzl",
    "arabicSlug": "تفسير-حلم-مغزل",
    "name": "مغزل",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا رأت المرأة في المنام أنها عندها مغزلا ولدت جارية أو أصابت أختا",
    "wordCount": 13
  },
  {
    "slug": "mghny",
    "arabicSlug": "تفسير-حلم-مغني",
    "name": "مغني",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الأفراح",
    "wordCount": 4
  },
  {
    "slug": "mfarqh",
    "arabicSlug": "تفسير-حلم-مفارقة",
    "name": "مفارقة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على تغير الأسباب والأزواج والدواب",
    "wordCount": 6
  },
  {
    "slug": "mftah",
    "arabicSlug": "تفسير-حلم-مفتاح",
    "name": "مفتاح",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "keys",
    "text": "هو في المنام رزق أو عون أو فتح باب علم",
    "wordCount": 10
  },
  {
    "slug": "mqbrh",
    "arabicSlug": "تفسير-حلم-مقبرة",
    "name": "مقبرة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على الموعظة والخشوع والبعد عن الدنيا",
    "wordCount": 7
  },
  {
    "slug": "mqs",
    "arabicSlug": "تفسير-حلم-مقص",
    "name": "مقص",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على تقريض الأعراض، وربما دل على ولي الأمر الفاصل بين الحق والباطل",
    "wordCount": 14
  },
  {
    "slug": "mqlah",
    "arabicSlug": "تفسير-حلم-مقلاة",
    "name": "مقلاة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام امرأة لا يعيش لها ولد",
    "wordCount": 8
  },
  {
    "slug": "mqyas-alma",
    "arabicSlug": "تفسير-حلم-مقياس-الماء",
    "name": "مقياس الماء",
    "letter": "م",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "تدل رؤيته على نزول الغيث",
    "wordCount": 5
  },
  {
    "slug": "mktb",
    "arabicSlug": "تفسير-حلم-مكتب",
    "name": "مكتب",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الهوان والصغار وضيق العيش، وربما دل على المنصب الجليل",
    "wordCount": 11
  },
  {
    "slug": "mkhlh",
    "arabicSlug": "تفسير-حلم-مكحلة",
    "name": "مكحلة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة تسعى في أمور الناس بالمصلحة والاصلاح",
    "wordCount": 7
  },
  {
    "slug": "mknsh",
    "arabicSlug": "تفسير-حلم-مكنسة",
    "name": "مكنسة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالت على زوال الهم وقضاء الدين",
    "wordCount": 6
  },
  {
    "slug": "mkyal",
    "arabicSlug": "تفسير-حلم-مكيال",
    "name": "مكيال",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام حاكم",
    "wordCount": 4
  },
  {
    "slug": "mlh",
    "arabicSlug": "تفسير-حلم-ملح",
    "name": "ملح",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام مال بلا تعب وإذا رايته بين المتخاصمين فأنهم يصطلحون",
    "wordCount": 12
  },
  {
    "slug": "mlqt",
    "arabicSlug": "تفسير-حلم-ملقط",
    "name": "ملقط",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الغلام الصبور",
    "wordCount": 5
  },
  {
    "slug": "mmatlh",
    "arabicSlug": "تفسير-حلم-مماطلة",
    "name": "مماطلة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إن كانت امرأة عجلت لنفسها الفرقة أو تؤثر العزل",
    "wordCount": 9
  },
  {
    "slug": "mna",
    "arabicSlug": "تفسير-حلم-منى",
    "name": "منى",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى نفسه فيها أمن من حيث خاف وبلغ مناه",
    "wordCount": 10
  },
  {
    "slug": "mnarh",
    "arabicSlug": "تفسير-حلم-منارة",
    "name": "منارة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رجل يؤلف بين الناس",
    "wordCount": 4
  },
  {
    "slug": "mnazah",
    "arabicSlug": "تفسير-حلم-منازعة",
    "name": "منازعة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ينازع إنسان يصيبه حزن شديد",
    "wordCount": 8
  },
  {
    "slug": "mnbr",
    "arabicSlug": "تفسير-حلم-منبر",
    "name": "منبر",
    "letter": "م",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الحاسب أو الرسام",
    "wordCount": 6
  },
  {
    "slug": "mnjm",
    "arabicSlug": "تفسير-حلم-منجم",
    "name": "منجم",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤيته تدل على معاشرة أرباب الصدور المطلع على أحوالهم",
    "wordCount": 9
  },
  {
    "slug": "mnkhl-aldqyq",
    "arabicSlug": "تفسير-حلم-منخل-الدقيق",
    "name": "منخل الدقيق",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على الهدى بعد الضلال والتوبة",
    "wordCount": 7
  },
  {
    "slug": "mndyl",
    "arabicSlug": "تفسير-حلم-منديل",
    "name": "منديل",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرقيق أو الزوجة أو الوالد",
    "wordCount": 7
  },
  {
    "slug": "mnshar",
    "arabicSlug": "تفسير-حلم-منشار",
    "name": "منشار",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على رجل يأخذ ويعطي ويسامح، والمنشار يدل على الحاكم والفاصل بين الخصمين",
    "wordCount": 13
  },
  {
    "slug": "mnqar",
    "arabicSlug": "تفسير-حلم-منقار",
    "name": "منقار",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على قضاء الحاجة والعون",
    "wordCount": 5
  },
  {
    "slug": "mnqwa",
    "arabicSlug": "تفسير-حلم-منقوع",
    "name": "منقوع",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من شربه للدواء فانه يدل على استعمال الرقى والاقتداء بالعلم",
    "wordCount": 10
  },
  {
    "slug": "mnfakh",
    "arabicSlug": "تفسير-حلم-منفاخ",
    "name": "منفاخ",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على إحياء الذكر وشفاء المريض وحبل المرأة",
    "wordCount": 8
  },
  {
    "slug": "mnkb",
    "arabicSlug": "تفسير-حلم-منكب",
    "name": "منكب",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو صديق الرجل أو شريكه أو أجيره",
    "wordCount": 7
  },
  {
    "slug": "mny",
    "arabicSlug": "تفسير-حلم-مني",
    "name": "مني",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى نطفة سائلة خرجت منه فانه مال يظهر له، وان تلطخت به زوجته نالت منه كسوة",
    "wordCount": 17
  },
  {
    "slug": "mhanh",
    "arabicSlug": "تفسير-حلم-مهانة",
    "name": "مهانة",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل لأرباب الكد على الراحة",
    "wordCount": 5
  },
  {
    "slug": "mhd",
    "arabicSlug": "تفسير-حلم-مهد",
    "name": "مهد",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه اشترى مهدا أو هو في مهد نال خيرا",
    "wordCount": 11
  },
  {
    "slug": "mhras",
    "arabicSlug": "تفسير-حلم-مهراس",
    "name": "مهراس",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على رجل يعمل ويتعب، كما تدل رؤيته على الخصام، وربما تدل رؤيته على قضاء الحوائج وتيسير الأمور",
    "wordCount": 18
  },
  {
    "slug": "mhnds",
    "arabicSlug": "تفسير-حلم-مهندس",
    "name": "مهندس",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على خراب العامر، وعمارة الخراب",
    "wordCount": 7
  },
  {
    "slug": "mwt",
    "arabicSlug": "تفسير-حلم-موت",
    "name": "موت",
    "letter": "م",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": "death",
    "text": "يدل الموت على هدم اللذات وفقدها، وربما دل على سعة العيش",
    "wordCount": 11
  },
  {
    "slug": "mwj-albhr",
    "arabicSlug": "تفسير-حلم-موج-البحر",
    "name": "موج البحر",
    "letter": "م",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "رؤيته في المنام شدة وعذاب",
    "wordCount": 5
  },
  {
    "slug": "mwz",
    "arabicSlug": "تفسير-حلم-موز",
    "name": "موز",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على المال المحرز والولد في المشيمة، أو الإنسان في قبره أو سجنه",
    "wordCount": 13
  },
  {
    "slug": "mwsm",
    "arabicSlug": "تفسير-حلم-موسم",
    "name": "موسم",
    "letter": "م",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه خرج إلى الموسم فانه يخرج من هم وغم",
    "wordCount": 11
  },
  {
    "slug": "nar",
    "arabicSlug": "تفسير-حلم-نار",
    "name": "نار",
    "letter": "ن",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": "fire",
    "text": "بشارة وإنذار وخسارة وذنوب وبركة، من رأى انه يعبد النار فانه يحب الحرب، ومن رأى انه يأكل النار فانه يأكل أموال اليتيم، ومن رأى نار أطفئت سكنت الفتنة",
    "wordCount": 28
  },
  {
    "slug": "naawrh",
    "arabicSlug": "تفسير-حلم-ناعورة",
    "name": "ناعورة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على حافظ أموال الناس، والدواليب تدل على دوران التجارة",
    "wordCount": 10
  },
  {
    "slug": "naqh",
    "arabicSlug": "تفسير-حلم-ناقة",
    "name": "ناقة",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": "camel",
    "text": "تدل على المرأة",
    "wordCount": 3
  },
  {
    "slug": "namws",
    "arabicSlug": "تفسير-حلم-ناموس",
    "name": "ناموس",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رآه نال مالا",
    "wordCount": 4
  },
  {
    "slug": "nbsh",
    "arabicSlug": "تفسير-حلم-نبش",
    "name": "نبش",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على نفاذ الأمور والأحكام لأربابها",
    "wordCount": 6
  },
  {
    "slug": "nbq",
    "arabicSlug": "تفسير-حلم-نبق",
    "name": "نبق",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الرزق، ومن أكل النبق حسن دينه",
    "wordCount": 8
  },
  {
    "slug": "nby",
    "arabicSlug": "تفسير-حلم-نبي",
    "name": "نبي",
    "letter": "ن",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دلت رؤيته على الولد، ويدل على الأستاذ",
    "wordCount": 7
  },
  {
    "slug": "nbydh",
    "arabicSlug": "تفسير-حلم-نبيذ",
    "name": "نبيذ",
    "letter": "ن",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "يدل في المنام على الهم ولنكد وربما دل على ضنك العيش",
    "wordCount": 11
  },
  {
    "slug": "njah-mn-shdh",
    "arabicSlug": "تفسير-حلم-نجاة-من-شدة",
    "name": "نجاة من شدة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على نتائج الأعمال الصالحة",
    "wordCount": 5
  },
  {
    "slug": "njar",
    "arabicSlug": "تفسير-حلم-نجار",
    "name": "نجار",
    "letter": "ن",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "هو في المنام رجل مؤدب يؤدب الناس",
    "wordCount": 7
  },
  {
    "slug": "njash",
    "arabicSlug": "تفسير-حلم-نجاسة",
    "name": "نجاسة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن به نجاسة وكان عنده وديعة وأمانة كان آثما فان غسل تلك النجاسة فانه يرد الأمانة",
    "wordCount": 18
  },
  {
    "slug": "nhas",
    "arabicSlug": "تفسير-حلم-نحاس",
    "name": "نحاس",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رآه في المنام فانه إصابة مال ومن رأى في يده نحاس فليحذر أناسا يعادونه",
    "wordCount": 15
  },
  {
    "slug": "nhl",
    "arabicSlug": "تفسير-حلم-نحل",
    "name": "نحل",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام غنى لمن اقتناه، ومن استخرج عسلا نال مالا حلال نخل : دال على رجل عالم، كما يدل على طول العمر",
    "wordCount": 23
  },
  {
    "slug": "nda",
    "arabicSlug": "تفسير-حلم-نداء",
    "name": "نداء",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام معصية لمن سمعه",
    "wordCount": 6
  },
  {
    "slug": "nrjs",
    "arabicSlug": "تفسير-حلم-نرجس",
    "name": "نرجس",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام امرأة، ومن رأى النرجس نال سرورا، كما يدل على الذهب والفضة",
    "wordCount": 14
  },
  {
    "slug": "nrd",
    "arabicSlug": "تفسير-حلم-نرد",
    "name": "نرد",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "سمو ورفعة، وربما دل على ما يرتكبه في اليقظة من استهزاء أو مخالفة",
    "wordCount": 13
  },
  {
    "slug": "nzwl",
    "arabicSlug": "تفسير-حلم-نزول",
    "name": "نزول",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "مفارقة الإنسان مما كان عليه",
    "wordCount": 5
  },
  {
    "slug": "nsa",
    "arabicSlug": "تفسير-حلم-نساء",
    "name": "نساء",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رويتهن على زينة الدنيا وشهواتها، ومن رأى النساء أدبرت عليه فانه يفتقر",
    "wordCount": 13
  },
  {
    "slug": "nsaj",
    "arabicSlug": "تفسير-حلم-نساج",
    "name": "نساج",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام الرجل كثير الكد واتعب في عمله",
    "wordCount": 9
  },
  {
    "slug": "nsr",
    "arabicSlug": "تفسير-حلم-نسر",
    "name": "نسر",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هو في المنام ملك، وربما دل على طول العمر والمال",
    "wordCount": 10
  },
  {
    "slug": "nsnas",
    "arabicSlug": "تفسير-حلم-نسناس",
    "name": "نسناس",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في لمنام رجل قليل العقل مهلك نفسه بأفعاله",
    "wordCount": 9
  },
  {
    "slug": "nsl",
    "arabicSlug": "تفسير-حلم-نصل",
    "name": "نصل",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام كلام أو أرباح",
    "wordCount": 6
  },
  {
    "slug": "nsyhh",
    "arabicSlug": "تفسير-حلم-نصيحة",
    "name": "نصيحة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام من العدو غش وغرور",
    "wordCount": 7
  },
  {
    "slug": "naas",
    "arabicSlug": "تفسير-حلم-نعاس",
    "name": "نعاس",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على أمن من الخوف ويدل على التوبة، كما يدل على الغنى بعد الفقر",
    "wordCount": 14
  },
  {
    "slug": "naamh",
    "arabicSlug": "تفسير-حلم-نعامة",
    "name": "نعامة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "امرأة، كم تدل على النعمة",
    "wordCount": 5
  },
  {
    "slug": "najh",
    "arabicSlug": "تفسير-حلم-نعجة",
    "name": "نعجة",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "هي في المنام امرأة شريفة غنية",
    "wordCount": 6
  },
  {
    "slug": "nal",
    "arabicSlug": "تفسير-حلم-نعل",
    "name": "نعل",
    "letter": "ن",
    "category": "ملابس وزينة",
    "categorySlug": "clothing-adornment",
    "canonicalSlug": "shoes",
    "text": "هو في المنام زوجة أو دابة، ومن رأى انه اشترى نعل ولم يمشي به فانه يتزوج، ومن رأى انه يمشي بالنعل فانه يسافر",
    "wordCount": 23
  },
  {
    "slug": "nanaa",
    "arabicSlug": "تفسير-حلم-نعناع",
    "name": "نعناع",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على النعي",
    "wordCount": 3
  },
  {
    "slug": "nfth",
    "arabicSlug": "تفسير-حلم-نفث",
    "name": "نفث",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو نفخ مع بعض بزاق من الفم يدل في المنام على السحر",
    "wordCount": 12
  },
  {
    "slug": "nfkh-fy-alnar",
    "arabicSlug": "تفسير-حلم-نفخ-في-النار",
    "name": "نفخ في النار",
    "letter": "ن",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "هو في المنام فتنة، والنفخ في الأرض كشف سر، ومن رأى انه نفخ في فرج امرأة فإنها تحمل",
    "wordCount": 18
  },
  {
    "slug": "nfqh",
    "arabicSlug": "تفسير-حلم-نفقة",
    "name": "نفقة",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "النفقة على الأهل صدقة جارية، والنفقة رزق واسع",
    "wordCount": 8
  },
  {
    "slug": "nqab",
    "arabicSlug": "تفسير-حلم-نقاب",
    "name": "نقاب",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على بنت طويلة العمر، وربما دل على التفقه في الدين",
    "wordCount": 11
  },
  {
    "slug": "nqash",
    "arabicSlug": "تفسير-حلم-نقاش",
    "name": "نقاش",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على العلم، وربما دلت رؤيته على المكر والحيلة، ونقاش الحجارة مكايدة",
    "wordCount": 13
  },
  {
    "slug": "nqsan",
    "arabicSlug": "تفسير-حلم-نقصان",
    "name": "نقصان",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية النقصان في المنام إذا كان في الجوارح فهو دال على النقصان في المال والنعمة",
    "wordCount": 15
  },
  {
    "slug": "nkah",
    "arabicSlug": "تفسير-حلم-نكاح",
    "name": "نكاح",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": "marriage",
    "text": "يدل على المنصب الجليل، ومن نكح عدوه فانه يقهره",
    "wordCount": 9
  },
  {
    "slug": "nmam",
    "arabicSlug": "تفسير-حلم-نمام",
    "name": "نمام",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام فرج دائم",
    "wordCount": 5
  },
  {
    "slug": "nmr",
    "arabicSlug": "تفسير-حلم-نمر",
    "name": "نمر",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على الحاكم الظالم أو عدو",
    "wordCount": 6
  },
  {
    "slug": "nmsh",
    "arabicSlug": "تفسير-حلم-نمش",
    "name": "نمش",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى نمش على وجهه فهو ذنوبه",
    "wordCount": 7
  },
  {
    "slug": "nml",
    "arabicSlug": "تفسير-حلم-نمل",
    "name": "نمل",
    "letter": "ن",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دال على قوم ضعفاء",
    "wordCount": 4
  },
  {
    "slug": "nhar",
    "arabicSlug": "تفسير-حلم-نهار",
    "name": "نهار",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على الفرج من الهموم والاحزان، ويدل على تجديد الملابس، كما يدل على ظهور الحجة",
    "wordCount": 15
  },
  {
    "slug": "nhr",
    "arabicSlug": "تفسير-حلم-نهر",
    "name": "نهر",
    "letter": "ن",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "هو في المنام رجل جليل ومن دخل فيه خالط رجلا من أكابر الناس",
    "wordCount": 13
  },
  {
    "slug": "nwah",
    "arabicSlug": "تفسير-حلم-نواح",
    "name": "نواح",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على الواعظ، ومن رأى أن موضعا يناح فيه وقع هناك شر وسوء تدبير",
    "wordCount": 14
  },
  {
    "slug": "nwr",
    "arabicSlug": "تفسير-حلم-نور",
    "name": "نور",
    "letter": "ن",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دال على الهداية والأعمال الصالحة",
    "wordCount": 5
  },
  {
    "slug": "nwm",
    "arabicSlug": "تفسير-حلم-نوم",
    "name": "نوم",
    "letter": "ن",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام غفلة",
    "wordCount": 4
  },
  {
    "slug": "hatf",
    "arabicSlug": "تفسير-حلم-هاتف",
    "name": "هاتف",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه سمع صوت هاتف بأمر أو إنذار أو زجر أو بشارة فهو كما سمعه",
    "wordCount": 16
  },
  {
    "slug": "hbh",
    "arabicSlug": "تفسير-حلم-هبة",
    "name": "هبة",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه وهب لرجل عبد فانه يرسل إليه عدوا، وان وهبه جارية أفاده تجارة",
    "wordCount": 15
  },
  {
    "slug": "hdm-aldar",
    "arabicSlug": "تفسير-حلم-هدم-الدار",
    "name": "هدم الدار",
    "letter": "ه",
    "category": "أماكن وبيوت ومباني",
    "categorySlug": "buildings-places",
    "canonicalSlug": null,
    "text": "تدل رؤيته على موت صاحبها، ومن رأى إن يهدم دارا فانه يصيبه هم وشر، وان رأت امرأة إن سقف بيتها أنهدم فانه يدل على موت زوجها",
    "wordCount": 26
  },
  {
    "slug": "hdnh",
    "arabicSlug": "تفسير-حلم-هدنة",
    "name": "هدنة",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الأمن من الخوف، والراحة بعد التعب",
    "wordCount": 8
  },
  {
    "slug": "hdhd",
    "arabicSlug": "تفسير-حلم-هدهد",
    "name": "هدهد",
    "letter": "ه",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "يدل رؤيته على الرسول أو الجاسوس، أو الرجل العالم الكثير الجدال",
    "wordCount": 11
  },
  {
    "slug": "hdyh",
    "arabicSlug": "تفسير-حلم-هدية",
    "name": "هدية",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هي في المنام فرح، وتدل على المحبة والمودة، كما تدل على الصلح",
    "wordCount": 12
  },
  {
    "slug": "hrh",
    "arabicSlug": "تفسير-حلم-هرة",
    "name": "هرة",
    "letter": "ه",
    "category": "حيوانات وزواحف",
    "categorySlug": "animals-reptiles",
    "canonicalSlug": null,
    "text": "دالة على الخادم حافظ للإنسان",
    "wordCount": 5
  },
  {
    "slug": "hrwlh",
    "arabicSlug": "تفسير-حلم-هرولة",
    "name": "هرولة",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على سرعة خروج الإنسان من الدنيا أو زوال منصبه، وربما دلت على الحج",
    "wordCount": 14
  },
  {
    "slug": "hzymh",
    "arabicSlug": "تفسير-حلم-هزيمة",
    "name": "هزيمة",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه ينهزم ولا يخاف فانه يموت، ومن رأى جند مهزومين وكانوا مستورين نصروا",
    "wordCount": 15
  },
  {
    "slug": "hdm-altaam",
    "arabicSlug": "تفسير-حلم-هضم-الطعام",
    "name": "هضم الطعام",
    "letter": "ه",
    "category": "طعام وشراب",
    "categorySlug": "food-drink",
    "canonicalSlug": null,
    "text": "من رأى أن طعامه انهضم حرص على السعي في حرفته",
    "wordCount": 10
  },
  {
    "slug": "hlal-3",
    "arabicSlug": "تفسير-حلم-هلال",
    "name": "هلال",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا طلع في محله فهو ولد ذكر كريم لمن رآه",
    "wordCount": 10
  },
  {
    "slug": "hm",
    "arabicSlug": "تفسير-حلم-هم",
    "name": "هم",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على كفارة الذنوب",
    "wordCount": 4
  },
  {
    "slug": "hna-3",
    "arabicSlug": "تفسير-حلم-هناء",
    "name": "هناء",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على العزاء وربما دل على الخروج من الضيق",
    "wordCount": 9
  },
  {
    "slug": "hwa-3",
    "arabicSlug": "تفسير-حلم-هواء",
    "name": "هواء",
    "letter": "ه",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "من رأى انه قائم في الهواء بين الأرض والسماء مال عزا وليس له ثبات في ذلك",
    "wordCount": 16
  },
  {
    "slug": "hykl",
    "arabicSlug": "تفسير-حلم-هيكل",
    "name": "هيكل",
    "letter": "ه",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الأمن من الخوف والنصر على الأعداء",
    "wordCount": 8
  },
  {
    "slug": "wady",
    "arabicSlug": "تفسير-حلم-وادي",
    "name": "وادي",
    "letter": "و",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "دال على السفر المتعب، أو على الإنسان الصعب، وربما دلت رؤيته على الأعمال الصالحة",
    "wordCount": 14
  },
  {
    "slug": "waaz",
    "arabicSlug": "تفسير-حلم-واعظ",
    "name": "واعظ",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال على البكاء والحزن المتوالية",
    "wordCount": 5
  },
  {
    "slug": "waly",
    "arabicSlug": "تفسير-حلم-والي",
    "name": "والي",
    "letter": "و",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "دال على الهموم واللهو والأعمال السيئة، وربما دلت رؤيته على المولاة للناس والمحبة لهم",
    "wordCount": 14
  },
  {
    "slug": "wba",
    "arabicSlug": "تفسير-حلم-وباء",
    "name": "وباء",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "أذى بالناس",
    "wordCount": 2
  },
  {
    "slug": "wbr",
    "arabicSlug": "تفسير-حلم-وبر",
    "name": "وبر",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "فوائد وأرزاق",
    "wordCount": 2
  },
  {
    "slug": "wtd",
    "arabicSlug": "تفسير-حلم-وتد",
    "name": "وتد",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى إن أنسانا شيخا ضرب في ظهره وتدا أو مسمارا فانه يخرج من صلبه ملك أو حاكم",
    "wordCount": 18
  },
  {
    "slug": "wthb",
    "arabicSlug": "تفسير-حلم-وثب",
    "name": "وثب",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه وثب فوق رجل فانه يغلبه، والوثوب قوة البدن",
    "wordCount": 11
  },
  {
    "slug": "wja",
    "arabicSlug": "تفسير-حلم-وجع",
    "name": "وجع",
    "letter": "و",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو ندامة من الذنب، ومن رأى وجع في سنه فانه يسمع قولا قبيحا من قريبه، ووجع العنق يدل على إن صاحبه أساء المعاشرة، أو خان الأمانة",
    "wordCount": 26
  },
  {
    "slug": "wjnh",
    "arabicSlug": "تفسير-حلم-وجنة",
    "name": "وجنة",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "علامة الخير والخصب والفرج",
    "wordCount": 4
  },
  {
    "slug": "wjh",
    "arabicSlug": "تفسير-حلم-وجه",
    "name": "وجه",
    "letter": "و",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": null,
    "text": "هو في المنام إذا رايته حسنا فانه يدل على حسن الحال في الدنيا، وإذا رايته اسود فانه يدل على بشارة بأنثى لمن له حامل",
    "wordCount": 24
  },
  {
    "slug": "whdh",
    "arabicSlug": "تفسير-حلم-وحدة",
    "name": "وحدة",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على انفراد الشخص بما هو فيه من صنعة أو رأي",
    "wordCount": 11
  },
  {
    "slug": "whsh",
    "arabicSlug": "تفسير-حلم-وحش",
    "name": "وحش",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية الوحش في المنام تدل على رجال أقوياء البدن، وأهل للبدع",
    "wordCount": 11
  },
  {
    "slug": "whl",
    "arabicSlug": "تفسير-حلم-وحل",
    "name": "وحل",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام لمن مشى فيه هم يدخل فيه، وينال فتنة",
    "wordCount": 11
  },
  {
    "slug": "wd",
    "arabicSlug": "تفسير-حلم-ود",
    "name": "ود",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على رفع القدر وحكمة العقل",
    "wordCount": 6
  },
  {
    "slug": "wdaa",
    "arabicSlug": "تفسير-حلم-وداع",
    "name": "وداع",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دال للمريض على موته، وطلاق الزوجة، والسفر، والتنقل في العمل",
    "wordCount": 10
  },
  {
    "slug": "wdyah",
    "arabicSlug": "تفسير-حلم-وديعة",
    "name": "وديعة",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على سر يطلع عليه المودع",
    "wordCount": 6
  },
  {
    "slug": "wrd",
    "arabicSlug": "تفسير-حلم-ورد",
    "name": "ورد",
    "letter": "و",
    "category": "طبيعة وعناصر",
    "categorySlug": "nature-elements",
    "canonicalSlug": null,
    "text": "هو في المنام رجل شريف أو ولد أو قدوم غائب أو امرأة، ومن رأى انه جني وردا نال كرامة ومحبة",
    "wordCount": 20
  },
  {
    "slug": "wrq-alshjr",
    "arabicSlug": "تفسير-حلم-ورق-الشجر",
    "name": "ورق الشجر",
    "letter": "و",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "يدل على الكسوة إلا ورق التين فانه حزن",
    "wordCount": 8
  },
  {
    "slug": "wrm",
    "arabicSlug": "تفسير-حلم-ورم",
    "name": "ورم",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "رؤية الوريد في المنام تدل على موت الإنسان وحياته",
    "wordCount": 9
  },
  {
    "slug": "wzyr",
    "arabicSlug": "تفسير-حلم-وزير",
    "name": "وزير",
    "letter": "و",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "تدل رؤية الوزير في المنام على العز ونفاذ الأمر أو قضاء الحوائج",
    "wordCount": 12
  },
  {
    "slug": "wsadh",
    "arabicSlug": "تفسير-حلم-وسادة",
    "name": "وسادة",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دالة على امرأة خادمة صاحبها تخدم الناس وتكرمهم",
    "wordCount": 8
  },
  {
    "slug": "wskh",
    "arabicSlug": "تفسير-حلم-وسخ",
    "name": "وسخ",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "إذا ره الإنسان في الثوب أو البدن فانه هم لصاحبه، الثياب الوسخة ذنوب",
    "wordCount": 13
  },
  {
    "slug": "wsy",
    "arabicSlug": "تفسير-حلم-وصي",
    "name": "وصي",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يوصي إليه دل على كلام الحق أو ارتفاع المقام",
    "wordCount": 12
  },
  {
    "slug": "wsyh",
    "arabicSlug": "تفسير-حلم-وصية",
    "name": "وصية",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "جدال على الصلة بين الموصي والموصى له، وان كان بينهما خلاف اصطلحا",
    "wordCount": 12
  },
  {
    "slug": "wdw",
    "arabicSlug": "تفسير-حلم-وضوء",
    "name": "وضوء",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى أنه توضأ على وضوئه بما يجوز به الوضوء فانه نور على نور",
    "wordCount": 14
  },
  {
    "slug": "wt",
    "arabicSlug": "تفسير-حلم-وطء",
    "name": "وطء",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على بلوغ المراد",
    "wordCount": 4
  },
  {
    "slug": "wtwat",
    "arabicSlug": "تفسير-حلم-وطواط",
    "name": "وطواط",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل رؤيته على العمى والضلالة",
    "wordCount": 5
  },
  {
    "slug": "wad",
    "arabicSlug": "تفسير-حلم-وعد",
    "name": "وعد",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه وعد وعدا حسنا فانه يصيب خيرا ونعمة، ومن رأى إن عدوه وعده خيرا نال منه وامن شرا",
    "wordCount": 20
  },
  {
    "slug": "war",
    "arabicSlug": "تفسير-حلم-وعر",
    "name": "وعر",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى نفسه في وعر ثم رأى نفسه في سهل دل ذلك على تسهل أموره وخروجه من المصائب",
    "wordCount": 18
  },
  {
    "slug": "wal",
    "arabicSlug": "تفسير-حلم-وعل",
    "name": "وعل",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه صاد وعلا فانه يحصل على غنيمة",
    "wordCount": 9
  },
  {
    "slug": "wqf",
    "arabicSlug": "تفسير-حلم-وقف",
    "name": "وقف",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "دليل على الأعمال الصالحة",
    "wordCount": 4
  },
  {
    "slug": "wkalh",
    "arabicSlug": "تفسير-حلم-وكالة",
    "name": "وكالة",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على الذنوب، والوكالة دالة على الغنى والتحكم",
    "wordCount": 8
  },
  {
    "slug": "wkr",
    "arabicSlug": "تفسير-حلم-وكر",
    "name": "وكر",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "يدل على ولد الزنا",
    "wordCount": 4
  },
  {
    "slug": "wladh",
    "arabicSlug": "تفسير-حلم-ولادة",
    "name": "ولادة",
    "letter": "و",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": "birth",
    "text": "لو رأى في المنام إن زوجته ولد ت ذكرا ولم تكن حامل فانه ينال أموالا",
    "wordCount": 15
  },
  {
    "slug": "wld",
    "arabicSlug": "تفسير-حلم-ولد",
    "name": "ولد",
    "letter": "و",
    "category": "أشخاص ووظائف",
    "categorySlug": "people-figures",
    "canonicalSlug": null,
    "text": "من رأى انه ولد له جملة من الأولاد فانه هم",
    "wordCount": 10
  },
  {
    "slug": "wlh",
    "arabicSlug": "تفسير-حلم-وله",
    "name": "وله",
    "letter": "و",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام حيرة في الدنيا وحسن عاقبة في الآخرة",
    "wordCount": 10
  },
  {
    "slug": "wlymh",
    "arabicSlug": "تفسير-حلم-وليمة",
    "name": "وليمة",
    "letter": "و",
    "category": "أحداث ومناسبات",
    "categorySlug": "events-death-marriage",
    "canonicalSlug": null,
    "text": "من حضر وليمة في المنام فدليل على زوال الهم",
    "wordCount": 9
  },
  {
    "slug": "yas",
    "arabicSlug": "تفسير-حلم-يأس",
    "name": "يأس",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من رأى انه يئس مسه شر، وتنزع منه الرحمة والنعمة",
    "wordCount": 10
  },
  {
    "slug": "yasmyn",
    "arabicSlug": "تفسير-حلم-ياسمين",
    "name": "ياسمين",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "من وجد ياسمين أو رآه نال سرورا وخيرا، كما يدل على انفراج الأمور",
    "wordCount": 13
  },
  {
    "slug": "yaqwt",
    "arabicSlug": "تفسير-حلم-ياقوت",
    "name": "ياقوت",
    "letter": "ي",
    "category": "أموال وذهب ومعادن",
    "categorySlug": "gold-money",
    "canonicalSlug": null,
    "text": "هو في المنام فرح ولهو",
    "wordCount": 5
  },
  {
    "slug": "ytm",
    "arabicSlug": "تفسير-حلم-يتم",
    "name": "يتم",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام قهر فمن رأى انه يتيم فانه يقهر",
    "wordCount": 10
  },
  {
    "slug": "yd",
    "arabicSlug": "تفسير-حلم-يد",
    "name": "يد",
    "letter": "ي",
    "category": "أعضاء الجسم والصحة",
    "categorySlug": "body-health",
    "canonicalSlug": "hand",
    "text": "هي في المنام إحسان الرجل وظهره وسنده، واليد اليمنى قوة صاحب الرؤيا وكسبه ومعروفه",
    "wordCount": 14
  },
  {
    "slug": "yrqan",
    "arabicSlug": "تفسير-حلم-يرقان",
    "name": "يرقان",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام لباس أو زوجة غير مناسبة",
    "wordCount": 8
  },
  {
    "slug": "ysr",
    "arabicSlug": "تفسير-حلم-يسر",
    "name": "يسر",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "هو في المنام ضد العسر وربما دل على التقوى",
    "wordCount": 9
  },
  {
    "slug": "yqzh",
    "arabicSlug": "تفسير-حلم-يقظة",
    "name": "يقظة",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "تدل على أوجه السداد في الأشغال وملازمة الأمور والرجوع في شيء يكرهه الإنسان",
    "wordCount": 13
  },
  {
    "slug": "ymyn-allh",
    "arabicSlug": "تفسير-حلم-يمين-الله",
    "name": "يمين الله",
    "letter": "ي",
    "category": "أشياء ومتفرقات",
    "categorySlug": "misc",
    "canonicalSlug": null,
    "text": "اليمين الكاذب فقر وذل وخداع، واليمين الصادق عمل صالح وأمن من الخوف",
    "wordCount": 12
  }
];

export const EDITORIAL_RESOLUTION: Record<string, string> = {
  "تفسير-حلم-الأسد": "lion",
  "تفسير-حلم-إمام-الصلاة": "prayer",
  "تفسير-حلم-بحر": "sea",
  "تفسير-حلم-بكاء": "crying",
  "تفسير-حلم-تجرد-من-الملابس": "clothes",
  "تفسير-حلم-تمر": "dates",
  "تفسير-حلم-ثعبان": "snake",
  "تفسير-حلم-ثوب": "clothes",
  "تفسير-حلم-جمل": "camel",
  "تفسير-حلم-حبل": "pregnancy",
  "تفسير-حلم-حج": "hajj",
  "تفسير-حلم-حذاء": "shoes",
  "تفسير-حلم-حمل-المرأة": "pregnancy",
  "تفسير-حلم-حوت": "fish",
  "تفسير-حلم-حية": "snake",
  "تفسير-حلم-خاتم": "ring",
  "تفسير-حلم-خيل": "horse",
  "تفسير-حلم-دار": "new-house",
  "تفسير-حلم-درهم": "money",
  "تفسير-حلم-دم": "blood",
  "تفسير-حلم-ذهب": "gold",
  "تفسير-حلم-زواج": "marriage",
  "تفسير-حلم-سفر": "travel",
  "تفسير-حلم-سقوط": "teeth-falling",
  "تفسير-حلم-سمك": "fish",
  "تفسير-حلم-سن": "teeth-falling",
  "تفسير-حلم-شعر": "hair",
  "تفسير-حلم-صلاة": "prayer",
  "تفسير-حلم-ضرس": "teeth-falling",
  "تفسير-حلم-طيران": "flying",
  "تفسير-حلم-عرس": "marriage",
  "تفسير-حلم-عقرب": "scorpion",
  "تفسير-حلم-غرق": "drowning",
  "تفسير-حلم-فلس": "money",
  "تفسير-حلم-قط": "black-cat",
  "تفسير-حلم-قميص": "clothes",
  "تفسير-حلم-كلب": "dog",
  "تفسير-حلم-لبن": "milk",
  "تفسير-حلم-لحم": "meat",
  "تفسير-حلم-ماء": "water",
  "تفسير-حلم-مطر": "rain",
  "تفسير-حلم-مفتاح": "keys",
  "تفسير-حلم-موت": "death",
  "تفسير-حلم-نار": "fire",
  "تفسير-حلم-ناقة": "camel",
  "تفسير-حلم-نعل": "shoes",
  "تفسير-حلم-نكاح": "marriage",
  "تفسير-حلم-ولادة": "birth",
  "تفسير-حلم-يد": "hand"
};

export function findDictionaryBySlug(slug: string): DictionaryEntry | undefined {
  const decoded = decodeURIComponent(slug).trim();
  const entry = DICTIONARY_DB.find((d) => d.slug === decoded || d.arabicSlug === decoded);
  if (!entry) return undefined;
  return { ...entry, canonicalSlug: entry.canonicalSlug ?? null };
}

export function normalizeArabicLetterRoot(s: string): string {
  if (!s) return s;
  let l = s.trim().replace(/[\u064B-\u0652\u0640]/g, '');
  const first = l.charAt(0);
  if (/[أإآاٱاء]/.test(first)) return 'أ';
  if (first === 'ى' || first === 'ئ' || first === 'ي') return 'ي';
  if (first === 'ؤ' || first === 'و') return 'و';
  if (first === 'ة') return 'هـ';
  return first;
}
const NORMALIZE_LETTER = normalizeArabicLetterRoot;

export function getDictionaryByLetter(letter: string): DictionaryEntry[] {
  const normalized = NORMALIZE_LETTER(letter);
  return DICTIONARY_DB.filter((d) => NORMALIZE_LETTER(d.letter) === normalized);
}

export function getDictionaryByCategory(categorySlug: string): DictionaryEntry[] {
  return DICTIONARY_DB.filter((d) => d.categorySlug === categorySlug);
}
